import moment from "moment";
import base64 from 'base-64';
import html2pdf from "html2pdf.js";
import Tab from "@mui/material/Tab";
import Cropper from "react-cropper";
import TabList from "@mui/lab/TabList";
import Modal from '@mui/material/Modal';
import TabPanel from "@mui/lab/TabPanel";
import Switch from '@mui/material/Switch';
import TabContext from "@mui/lab/TabContext";
import { ThreeDots } from 'react-loader-spinner';
import 'react-circular-progressbar/dist/styles.css';
import { useSelector, useDispatch } from "react-redux";
import React, { useEffect, useState, useRef, useCallback } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { Delete, Edit, KeyboardArrowLeft, LockOutlined } from "@mui/icons-material";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";

import Report from "./Report";
import QuesAns from "./QuesAns";
import Team from "./Team/index.js";
import Workflows from "./Workflows";
import DDQuesAns from "./DDQuesAns";
import FitReport from "./FitReport";
import Dashboard from "./NewDashboard.js";
import SidebarIndex from "./SidebarIndex";
import Certificates from "./Certificates";
import DiligencePack from "./DiligencePack";
import WorkflowReport from "./WorkflowReport";
import AllReports from "../Advisor/AllReports";
import CompanySettings from "./CompanySettings";
import ResearchAid from "./ResearchAid/index.js";
import Loader from "../../../components/Loader.js";
import CompanyAudit from "../Advisor/CompanyAudit";
import AnyListChecklists from "./AnyListChecklists";
import InvestorLeadList from "./investorLeadList.js";
import ShareDiligencePack from "./ShareDiligencePack";
import Dropbox from "../../../components/svgs/Dropbox";
import Button from "../../../components/common/Button";
import * as ROUTES from "../../../constants/routes.js";
import BenchmarkReport from "../Advisor/BenchmarkReport";
import ChecklistReport from "../Advisor/ChecklistReport";
import { updateUser } from '../../../reducers/userReducer';
import AnimatedPage from "../../../components/AnimatedPage";
import SharePoint from "../../../components/svgs/SharePoint";
import Certification from "../../../components/Certification";
import GoogleDrive from "../../../components/svgs/GoogleDrive";
import PortfolioDashboard from "./PortfolioDashboard/index.js";
import ResearchAidReport from "./ResearchAid/ResearchAidReport.js";
import { updatePartner } from "../../../reducers/partnerReducer.js";
import SiderbarResearchAid from "./ResearchAid/SiderbarResearchAid.js";
import { setDataroomConfig } from "../../../reducers/dataRoomReducer.js";
import SuperFlowHeader from "../../../components/header/SuperFlowHeader.js";
import { resetTabModal, toggleModal } from "../../../reducers/modalReducer";
import ModalWrapper from "../../../components/common/Modal/ModalWrapper.jsx";
import { setCompany, setFirstVisit } from "../../../reducers/companyReducer.js";
import RepositoryAlert from "../../../components/modals/repositoryAlert/index.js";
import HeadingSubheadingContent from "../../../components/HeadingSubheadingContent.js";
import socket, { getRequest, postRequest, showMessage, setLogout } from "../../../config";
import InvestorMatchDisclaimer from "../../../components/modals/investorMatchDisclaimer/index.jsx";
import FirstSetupDataRepositoryModal from "../../../components/modals/dataRepository/firstSetupDataRepository.jsx";
import { setCurrentScore, setFileReport, setMatchFileProcessing, updateFileAllocation } from "../../../reducers/filesAllocationReducer.js";
import InsuranceGapAnalysisReport from "./InsuranceGapAnalysisReport.js";
import Analyser from "./Analyser/index.js";
import AppStore from "./dashboard/AppStore/index.js";
import UpgradeCards from "../../../components/dashboard/upgradeCards/index.js";

const cropper = React.createRef(null);
export const sanitiseTab = t => decodeURIComponent(t).replace(/(-sync)?-report$/, "");
export default function Company(props) {

	let dispatch = useDispatch();
	let location = useLocation();
	let navigate = useNavigate();
	let user = useSelector(state => state.user);
	let modal = useSelector(state => state.modal);
	let partner = useSelector(state => state.partner);

	let { selectedCompany } = useSelector(state => state.company);
	let company = { ...selectedCompany };
	let { fileReport, currentScore, processing } = useSelector(state => state.fileAllocation);
	const [selectedDirector, setSelectedDirector] = useState({});
	const sectionRefs = useRef([]);
	const initialized = useRef(false);

	let [editUser, setEditUser] = useState({});

	let [moduleAI, setModuleAI] = useState('');
	let [advisors, setAdvisors] = useState([]);
	let [investors, setInvestors] = useState([]);
	let [companyId, setCompanyId] = useState({});
	let [selectAll, setSelectAll] = useState(false);
	let [isLeadPdf, setIsLeadPdf] = useState(false);
	let [showAlert, setShowAlert] = useState(false);
	let [uploadImage, setUploadImage] = useState("");
	let [userModules, setUserModules] = useState([]);
	let [aiEnhanced, setAiEnchaned] = useState(false);
	let [openTabs, setOpenTabs] = useState(new Set());
	let [isPortfolio, setIsPortfolio] = useState(false);
	let [isManualAdd, setIsManualAdd] = useState(false);
	let [acceptEmail, setAcceptEmail] = useState(false);
	let [investorEmail, setInvestorEmail] = useState({});
	let [checklistTask, setChecklistTask] = useState([]);
	let [userAction, setUserAction] = useState('Search');
	let [companyIndex, setCompanyIndex] = useState(false);
	let [isPrePopulate, setIsPrePopulate] = useState(true);
	let [linearProgress, setLinearProgress] = useState(25);
	let [isClientIndex, setIsClientIndex] = useState(true);
	let [deleteMemberId, setDeleteMemberId] = useState('');
	let [isShowTeamTab, setIsShowTeamTab] = useState(true);
	let [selectedSeeMore, setSelectedSeeMore] = useState({});
	let [selectedModules, setSelectedModules] = useState({});
	let [reportHistories, setReportHistories] = useState([]);
	let [files, setFiles] = useState(company?.['files'] || []);
	let [auditReportLogs, setAuditReportLogs] = useState({});
	let [visibleSection, setVisibleSection] = useState(null);
	let [fitInvestorFirms, setFitInvestorFirms] = useState([]);
	let [permissionLevel, setPermissionLevel] = useState('ALL');
	let [isBackFitReport, setIsBackFitReport] = useState(false);
	let [cloneImportResult, setCloneImportResult] = useState({});
	let [isWorkflowReport, setIsWorkflowReport] = useState(false);
	let [profileClass, setProfileClass] = useState('client-profile');
	let [dashboardTab, setDashboardTab] = useState("Company Dashboard");
	let [isGetInvestorMatches, setIsGetInvestorMatches] = useState(true);
	let [directors, setDirectors] = useState(company?.['directors'] || []);
	let [isViewTwoMinuteReport, setIsViewTwoMinuteReport] = useState(false);
	let [isGenerateAllResearchAid, setIsGenerateAllResearchAid] = useState(false);
	let [isTwoMinuteTesHomePage, setIsTwoMinuteTesHomePage] = useState(false);
	let [isLoader, setIsLoader] = useState({ show: false, message: 'Loading...' });
	let [activatingClient, setActivatingClient] = useState(null);
	let [companyDashboardTab, setCompanyDashboardTab] = useState("Dashboard");
	let [tab, setTabName] = useState(props && props?.isCallback ? 'repository' : '');
	const lastReportAnchorRef = useRef(null); // Anchor to scroll when closing report
	const [moduleContent] = useState({
		'kpi': {
			heading: 'KPI',
			aiEnhanced: true,
			uploadFiles: false,
			subheading: 'Key Performance Indicators'
		}, 'repository': {
			aiEnhanced: false,
			uploadFiles: true,
			heading: 'Repository',
			subheading: 'Securely store all your important documents here'
		}, 'business-audit-investment': {
			aiEnhanced: true,
			uploadFiles: false,
			heading: 'Business Audit',
			subheading: 'Get expert recommendations on how to reduce risk'
		}, 'business-audit-growth': {
			aiEnhanced: true,
			uploadFiles: false,
			heading: 'Business Audit',
			subheading: 'Get expert recommendations on how to reduce risk'
		}, 'business-audit-exit': {
			aiEnhanced: true,
			uploadFiles: false,
			heading: 'Business Audit',
			subheading: 'Get expert recommendations on how to reduce risk'
		}, 'directors-questionnaire': {
			aiEnhanced: false,
			uploadFiles: true,
			heading: 'Directors Questionnaire',
			subheading: ''
		}, 'two-minute-test-exit': {
			aiEnhanced: true,
			uploadFiles: false,
			heading: 'Exit Ready Test',
			subheading: 'See How Exit Ready You Are'
		}, 'two-minute-test-growth': {
			aiEnhanced: true,
			uploadFiles: false,
			heading: 'Growth Ready Test',
			subheading: 'See How Growth Ready You Are'
		}, 'two-minute-test-investment': {
			aiEnhanced: true,
			uploadFiles: false,
			heading: 'Investment Ready Test',
			subheading: 'How Investment Ready Are You'
		}, 'esg': {
			aiEnhanced: false,
			uploadFiles: true,
			heading: 'Environmental, Social & Governmental',
			subheading: 'Get expert recommendations on how to reduce risk'
		}, 'software-development': {
			aiEnhanced: false,
			uploadFiles: true,
			heading: 'Software Development',
			subheading: 'Get expert recommendations on how to reduce risk'
		}, 'warranty-disclosure': {
			aiEnhanced: false,
			uploadFiles: true,
			heading: 'Warranty Disclosure Schedule',
			subheading: 'Get expert recommendations on how to reduce risk'
		}, 'unaudited-certification': {
			sections: [],
			heading: 'Certification',
			subheading: 'This is your current certification',
		}, 'investor-lead': {
			uploadFiles: true,
			heading: 'Investor Match',
			subheading: 'Securely store all your important documents here'
		}
	});
	const [investorFirmCounts, setInvestorFirmCounts] = useState({
		gold: 0,
		silver: 0,
		bronze: 0,
		threshold: 0
	})

	const handleDeleteDirector = async (item) => {
		if (item) {
			dispatch(toggleModal({ open: 'deleteDirector' }));
			setSelectedDirector(item);
		} else {
			const response = await postRequest(`/company/${company._id}/delete-director/${selectedDirector['_id']}`, {});
			if (response['code'] === 200) {
				showMessage(response['message']);
				dispatch(setCompany({ ...company, directors: directors.filter(el => el['_id'] !== selectedDirector['_id']) }));
				dispatch(toggleModal({ open: 'showDirector' }));
			} else {
				showMessage(response['message']);

			}
		}
	}

	const findUser = async () => {
		let email = document.getElementById('searchEmail').value;
		let res = await postRequest(`/user/findUser`, { email, companyId });
		showMessage(res['message']);
		if (!res || res['code'] != 200) return;
		if (res['body']['found']) {
			setUserAction('Add');
			setEditUser(res['body']['user']);
		} else {
			editUser['email'] = document.getElementById('searchEmail').value;
			setEditUser(editUser);
			setUserAction('New');
		}
	};

	const saveUser = async () => {
		const permissions = editUser.permissions || {};
		const email = document.getElementById("userEmail").value;
		const lastName = document.getElementById("userLastName").value;
		const firstName = document.getElementById("userFirstName").value;
		const designation = document.getElementById("designation").value;

		let res = '';
		if (userAction == 'Edit') res = await postRequest('/user/editMember', { companyId, firstName, lastName, email, designation, permissions });
		else if (userAction == 'New') res = await postRequest('/user/newMember', { companyId, firstName, lastName, email, designation, permissions });
		else res = await postRequest('/user/addMember', { companyId, firstName, lastName, email, designation, permissions });

		if (!res || res['code'] != 200) return;
		getCompany();
		setEditUser({});
		setUserAction('Search');
		showMessage(res['message']);
		setSelectAll(false);
		dispatch(toggleModal({ open: '' }));
	};

	const selectAllPermissions = (event) => {
		const isChecked = event.target.checked;

		setSelectAll(isChecked);
		let permissions = {};
		company?.['sections']?.forEach((section) => {
			if (section.sectionNo.trim() !== "") permissions[section.sectionNo] = isChecked;
		});

		setEditUser({ ...editUser, permissions });
	};

	const handleUserChange = e => setEditUser({ ...editUser, [e.target.name]: e.target.type === "radio" ? e.target.id : e.target.value });
	const changeUser = (e) => {
		const updatedPermissions = { ...editUser.permissions, [e.target.name]: e.target.checked };
		setEditUser({ ...editUser, permissions: updatedPermissions, });
	};

	useEffect(() => {
		// Only redirect to billing if company has NO subscription at all
		// Allow Free and Lite subscriptions to access dashboard (for deferred client activation flow)
		if (user && company && Object.keys(company).length && ((typeof user['companyId'] === "string" && user['companyId'] !== company['_id']) || typeof user['companyId'] === "object" && user['companyId']?._id !== company['_id']) && user['role'] === 'Advisor' && !company['subscription']) {
			navigate(`/billing/${company['_id']}?plan=pro`);
			console.error("Company has no subscription", company['_id'], user['companyId']);
		}

		let checkManualAdd = localStorage.getItem('isManualAdd');
		if (user && user?.['role'] == 'Investor' && company?.['addedByInvestor'] == user?.['_id'] && checkManualAdd) setIsManualAdd(true);
		else setIsManualAdd(false);
	}, [user, company]);

	useEffect(() => {
		if (location?.hash) {
			let _tabName = location.hash.replace('#', '');
			if (_tabName === 'company-settings' || _tabName === 'company-audit-log') {
				setDashboardTab('Company Dashboard')
				setTabName(_tabName)
			}
		}
	}, [location?.hash]);

	function hasAllPermissions(companySections, userPermission) {
		return companySections.every(section => userPermission[section.sectionNo]);
	};

	useEffect(() => {
		if (editUser && editUser?.permissions && company && company['memberPermissions']) {
			setSelectAll(hasAllPermissions(company?.['sections'], editUser?.permissions));
		}
	}, [editUser, company]);

	useEffect(() => {
		let tabName = window.location.hash.replace('#', '');
		if (tabName) {
			setTabName(tabName)
			dispatch(updateFileAllocation({ tab: tabName }))
		} else dispatch(updateFileAllocation({ tab: '' }))
	}, [])

	// OPTIMIZATION: Fetch directors and files if not available (excluded in lightweight mode)
	useEffect(() => {
		const fetchDirectorsAndFiles = async () => {
			if (company?._id) {
				// Fetch directors if needed
				if (company?.['directorsCount'] !== undefined && !company?.['directors']) {
					try {
						const response = await getRequest(`/company/${company._id}/directors`);
						if (response['code'] === 200 && response['body']) {
							setDirectors(response['body']['directors'] || []);
						}
					} catch (e) {
						console.error('Failed to fetch directors:', e);
					}
				} else if (company?.['directors']) {
					setDirectors(company['directors']);
				}

				// Fetch files if needed
				if (company?.['filesCount'] !== undefined && !company?.['files']) {
					try {
						const response = await getRequest(`/company/${company._id}/files`);
						if (response['code'] === 200 && response['body']) {
							setFiles(response['body']['files'] || []);
						}
					} catch (e) {
						console.error('Failed to fetch files:', e);
					}
				} else if (company?.['files']) {
					setFiles(company['files']);
				}
			}
		};
		fetchDirectorsAndFiles();
	}, [company?._id, company?.['directors'], company?.['files'], company?.['directorsCount'], company?.['filesCount']]);

	useEffect(() => {
		const handleScroll = () => {
			const sectionPositions = sectionRefs.current.map(ref => {
				const id = ref?.id?.split('.')[0];
				const element = document.getElementById(id)
				const rect = element ? element.getBoundingClientRect() : { top: 0 };
				return { id, top: rect.top };
			});
			const currentSection = sectionPositions.find(position => position?.['top'] >= 0 && position.top < window.innerHeight)
			if (currentSection) setVisibleSection(currentSection.id);
		};

		window.addEventListener('scroll', handleScroll);
		return () => window.removeEventListener('scroll', handleScroll);
	}, []);

	useEffect(() => {
		if (user && (Object.keys(user).length == 0 || !user['stripeMethods'])) getUser();
		if (user && user['role'] !== 'Guest') getAdvisors();
		if (!initialized.current) {
			initialized.current = true
			if (location.pathname.includes('gDriveCallBack')) connectGDrive();
			else if (location.pathname.includes('dropBoxCallBack')) connectDropBox();
			else if (location.pathname.includes('sharePointCallBack')) connectSharePoint();
			else {
				let tabName = window.location.hash.replace('#', '');
				getCompany(tabName, selectedCompany);
				document.querySelectorAll(".sectionWrapper").forEach(el => observer.observe(el));
			}
		}
		let isWorkflowTab = localStorage.getItem('isWorkflowTab');
		if (isWorkflowTab) setCompanyDashboardTab('Workflows');

		let isResearchAid = localStorage.getItem('isResearchAid');
		if (isResearchAid) setCompanyDashboardTab('ResearchAid');

		let isAnylistTab = localStorage.getItem('isAnylistTab');
		let isDemoChecklist = localStorage.getItem('isDemoChecklist');
		let isPartnerChecklist = localStorage.getItem('isPartnerChecklist');
		if (isAnylistTab || isDemoChecklist || isPartnerChecklist) setCompanyDashboardTab('AnyLists');

	}, []);

	const hasTriggeredRef = useRef(false); // this ensures one-time trigger
	useEffect(() => {
		async function fetchData() {
			const stageProgress = selectedCompany['stageProgress'];
			const companyId = company._id;

			if (Object.keys(selectedCompany).length && stageProgress === 'updated' && !hasTriggeredRef.current) {
				hasTriggeredRef.current = true; // prevent future calls

				setShowAlert(true);
				dispatch(setMatchFileProcessing(true));
				const tab = 'repository';
				// Use lazy-loaded files state instead of company['files']
				let relPaths = [];
				let fileInfo = [];

				for (let i = 0; i < files.length; i++) {
					relPaths[i] = '';
					fileInfo[i] = files[i];
				}

				const res = await postRequest(`/company/matchFiles`, { files, companyId, tab, relPaths }, true, "noAnimation");

				if (!res?.body?.['report']) return;

				showMessage(res['message']);
				dispatch(setFileReport(res.body['report']));

				setCloneImportResult(JSON?.parse(JSON?.stringify(res.body?.['report']?.['importResult'])));
				const allocated = Object.keys(res.body['report']['importResult']).filter(key =>
					res.body['report']['importResult'][key]['section'].some((element) =>
						!element.includes("DXXX") && !element.includes("SXXX")
					)
				).length;

				const total = Object.keys(res.body['report']['importResult']).length;
				const score = total === 0 ? 0 : Math.round((allocated / total) * 100);
				setCurrentScore(score);

				dispatch(toggleModal({ open: 'importSummary', from: '' }));
				dispatch(updateFileAllocation({
					fileReport: res.body['report'],
					company,
					tab,
					underProcessingTab: tab,
					currentScore: score,
					reportHistories,
					profileClass
				}));

				dispatch(setCompany({ ...selectedCompany, stageProgress: 'pending' }));
				dispatch(setDataroomConfig({ syncing: true, message: "Folders are currently creating" }));
				setShowAlert(false);

				const syncBody = { newUpgradeSync: true, tab };
				if (selectedCompany['foldersPopulated']) {
					const res = await postRequest(`/company/syncGDriveDataroom/${companyId}`, syncBody, true);
					if (tab) reloadModule((tab ?? location.hash), false, false, true, "2");
					if (!res) return;
				} else if (selectedCompany['dropBoxFoldersPopulated']) {
					const res = await postRequest(`/company/syncDropBoxDataroom/${companyId}`, syncBody, true);
					if (tab) reloadModule((tab ?? location.hash), false, false, true, "3");
					if (!res) return;
				} else if (selectedCompany['sharePointFoldersPopulated']) {
					const res = await postRequest(`/company/syncSharePointDataroom/${companyId}`, syncBody, true);
					if (tab) reloadModule((tab ?? location.hash), false, false, true, "4");
					if (!res) return;
				}

				dispatch(setDataroomConfig({ syncing: false, message: null }));
			}
		}

		fetchData();
	}, [selectedCompany]);

	useEffect(() => {
		let isWorkflowTab = localStorage.getItem('isWorkflowTab');
		if (isWorkflowTab) localStorage.removeItem('isWorkflowTab');

		let isResearchAid = localStorage.getItem('isResearchAid');
		if (isResearchAid) localStorage.removeItem('isResearchAid');

		localStorage.removeItem('isAnylistTab');

		setInvestorFirmCounts({
			gold: 0,
			silver: 0,
			bronze: 0,
			threshold: 0
		})
	}, [tab, companyDashboardTab, dashboardTab]);

	useEffect(() => {
		if (user?.['type'] == 'Superflow' && user?.['partnerId']) getPartner(user?.['partnerId']);
		if (user) setProfileClass(user['role'] == 'Advisor' ? 'advisor-profile' : user['role'] == 'Investor' ? 'investor-profile br100' : 'client-profile')
	}, [user]);

	const getPartner = async (id) => {
		let res = await getRequest(`/checklist/partner/${id}`);
		if (res['code'] == 200) dispatch(updatePartner(res['body']));
	};

	useEffect(() => {
		socket.on('aireport:generated', async data => {
			if (data['moduleType']) {
				setModuleAI(data['moduleType']);
			}
			if (data['userId'] == user['_id']) {
				// setTab(tab, true); // Get updated AI Report from Server
				setAiEnchaned(true);
				showMessage(data['message']);
				if (!tab.match(/two-minute-test-.*-report/)) dispatch(toggleModal({ open: 'completeAIReport' }));
			}
		});

		socket.on('Sync', async data => {
			dispatch(setDataroomConfig({ syncing: false, message: null }))
			return showMessage(data['message']);
		});
	}, [socket]);

	// TODO: Check if the data exists
	useEffect(() => {
		location.hash = tab;
		window.scroll(0, 450);

		if (tab.endsWith("-report")) setIsPrePopulate(false);

		if (tab == 'checklist-tasks' && checklistTask.length == 0) getChecklistTask(tab);
		if (tab == 'company-audit-log' && Object.values(auditReportLogs).length == 0) getChangeReports(tab);
		if (tab == 'diligence-pack-reporting' && Object.values(selectedModules).length == 0) getCompanyByModules(tab);
		if (tab && tab.includes('two-minute-test') && user?.['role'] == 'Guest' && !user.firstName) return setIsTwoMinuteTesHomePage(true);
		else setIsTwoMinuteTesHomePage(false);

		if (tab && tab.includes('directors-questionnaire')) Array.from(openTabs).map(async openTab => {
			if (openTab.includes('directors-questionnaire')) {
				await openTabs.delete(openTab);
				setOpenTabs(new Set(Array.from(openTabs)));
				// if (tab === openTab) await setTab("");
			}
		});

		if (tab && tab !== 'fit-report') openTabs?.add(tab);
		if (tab == '' && window.location.pathname.includes('company')) {
			if (user['role'] != 'Guest') dispatch(toggleModal({ open: '' }));
			setCompanyIndex(true);
		} else setCompanyIndex(false);

		let isWorkflowOpen = localStorage.getItem('isWorkflowOpen');
		let isAnylistBuilder = localStorage.getItem('isAnylistBuilder');
		let isDiligencePack = localStorage.getItem('isDiligencePack');
		let isDemoChecklist = localStorage.getItem('isDemoChecklist');
		let isPartnerChecklist = localStorage.getItem('isPartnerChecklist');

		if (isAnylistBuilder || isDemoChecklist || isPartnerChecklist || isDiligencePack) {
			setCompanyIndex(true);
			if (user['role'] == 'Investor' && (tab == 'diligence-pack' || tab.includes('fit-report'))) setIsClientIndex(false);
		}
		if (isWorkflowOpen) {
			setTimeout(() => {
				setIsWorkflowReport(true);
				localStorage.removeItem('isWorkflowOpen');
			}, 100);
		}
	}, [tab]);

	useEffect(() => {
		if (user['role'] == 'Advisor' && company['advisors'] && company['advisors']?.[user['_id']] && company['advisors']?.[user['_id']]?.['type']) {
			permissionLevel = company['advisors']?.[user['_id']]?.['type'];
			setPermissionLevel(permissionLevel);
		}

		if (user['role'] == 'Investor' && company['investors'] && company['investors']?.[user['_id']] && company['investors']?.[user['_id']]?.['type']) {
			permissionLevel = company['investors']?.[user['_id']]?.['type'];
			setPermissionLevel(permissionLevel);
		}

		if (company?.['cLevel'] == 'Bronze') setLinearProgress(50);
		else if (company?.['cLevel'] == 'Silver') setLinearProgress(75);
		else if (company?.['cLevel'] == 'Gold') setLinearProgress(100);
		else setLinearProgress(25);

		// Get Investor Matches for Superflow Popup
		if (user?.['type'] == 'Superflow' && tab == 'investor-lead') {
			if (company?.['modules']?.['investor-lead']) {
				let sections = company?.['modules']?.['investor-lead']?.['sections'][0]?.['subFolders'];
				if (Object.values(sections)?.length > 0) {
					let completedSections = Object.values(sections).filter(section => (section?.['sectionNo'] == 'DEPF008.1' || section?.['sectionNo'] == 'DEPF008.2') && section?.['stats']?.['completionPercent'] == 100).map(section => section?.['sectionNo']);
					if (isGetInvestorMatches && completedSections?.length == 2 && completedSections?.includes('DEPF008.1') && completedSections?.includes('DEPF008.2')) {
						setIsGetInvestorMatches(false);
						getFitInvestorFirms();
					}
				}
			}
		}

		if (user?.['role'] == 'Advisor' || user?.['role'] == 'Investor') {
			if (user?.['companyId']?.['_id'] == company?.['_id']) setIsShowTeamTab(false);
			else setIsShowTeamTab(true);
		}
	}, [company]);

	const handleSuperFlowPopup = async () => {
		if (partner?.['name'] == 'Climb25 Super Flow' || partner?.['name'] == 'EHE Super Flow') dispatch(toggleModal({ open: 'applyInvestorMatchPopup' }));
		else dispatch(toggleModal({ open: 'superFlowPopup' }));
	};

	const handleActivateClientLogin = async (companyId) => {
		try {
			setActivatingClient(companyId);
			const response = await postRequest(`/company/activateClientLogin/${companyId}`, {});
			if (response?.['code'] === 200) {
				showMessage(response?.['message'] || 'Client login activated successfully');
				getCompany();
			} else showMessage(response?.['message'] || 'Failed to activate client login');
		} catch (e) {
			showMessage('An error occurred while activating client login');
		} finally {
			setActivatingClient(null);
		}
	};

	const getCompany = async (tabName, _company) => {
		let reset = false;
		const companyId = props && props?.isCallback ? props.companyId : location.pathname.split("/").slice(-1)[0];
		if (companyId.toLowerCase().includes('callback')) return;

		if (tabName && tabName.includes('%20')) {
			tabName = tabName.replaceAll('%20', ' ');
			reset = true;
		}

		let res = '';
		let moduleName = tabName ? sanitiseTab(tabName) : window.location.href.includes("#") ? window.location.hash.substring(1) : undefined;
		setIsLoader({ show: true, message: 'Loading...' });
		if (reset || (moduleName && (Object.keys(moduleContent).includes(moduleName) || moduleName.includes('directors-questionnaire')))) {
			let checkManualAdd = localStorage.getItem('isManualAdd');
			let query = `?moduleName=${moduleName}`;
			if (checkManualAdd && user && user?.['role'] == 'Investor' && moduleName == 'investor-lead') query = `?moduleName=${moduleName}&tags=short-investor-lead`;

			res = await getRequest(`/company/get/${companyId}${query}`);
		}
		else res = await getRequest(`/company/get/${companyId}`);
		if (selectedCompany['stageProgress'] === 'updated') res['body']['stageProgress'] = 'updated'
		setIsLoader({ show: false, message: 'Loading...' });
		if (res['code'] == 200) {
			(!res['body']['firstVisitRepository'] && (moduleName && moduleName.toLowerCase() === "repository")) && dispatch(toggleModal({ open: 'firstSetupDataRepository' }));
			res['body']['modules']['kpi'] = { type: "kpi", sections: [] };
			for (let module of Object.values(res['body']['modules'])) {
				let content = module['type'].includes('directors-questionnaire') ? moduleContent['directors-questionnaire'] : moduleContent[module['type']]
				if (content) {
					module['heading'] = module['director'] ? `${content['heading']} - ${module['director']['name']} (${module['director']['designation']})` : content['heading'];
					module['aiEnhanced'] = content['aiEnhanced'];
					module['subheading'] = content['subHeading'];
					module['uploadFiles'] = content['uploadFiles'];
					if (!module['uploadFiles'] && content['heading'] === "Repository") {
						module['uploadFiles'] = true;
					}
				}
			}
			res['body']['modules']['unaudited-certification'] = moduleContent['unaudited-certification'];
			if (!moduleName && _company?.['modules'] && (companyId === _company._id)) {
				res['body']['modules'] = _company['modules']
			}

			const resultArray = Object.entries(res['body']['modules']).filter(([key, value]) => value?.stats?.completionScore > 0).map(([key]) => key);
			setUserModules(resultArray);
			await dispatch(setCompany({ ...res['body'], from: 434 }))
			if (!res?.['body']?.['stats']?.['completionScore'] && res['body']['subscription'] != 'Free') dispatch(toggleModal({ open: 'dataRepository' }));

			setCompanyId(companyId);
			localStorage.setItem('companyId', companyId);
			if (tabName) setTab(tabName);
		};
	};

	const getCompanyByModules = async (tabName) => {
		const companyId = props && props?.isCallback ? props.companyId : location.pathname.split("/").slice(-1)[0];
		if (companyId.toLowerCase().includes('callback')) return;
		let moduleName = tabName && sanitiseTab(tabName);
		if (Object.values(selectedModules).length == 0) {
			let res = '';
			setIsLoader({ show: true, message: 'Loading...' });
			if (userModules && (Object.keys(moduleContent).includes(userModules) || userModules.includes('directors-questionnaire')))
				res = await getRequest(`/company/get/${companyId}?moduleName=${moduleName}`);
			else res = await getRequest(`/company/allReports/${companyId}`);
			setIsLoader({ show: false, message: 'Loading...' });

			if (res['code'] == 200) {
				for (let module of Object.values(res['body'])) {

					let content = module['type'].includes('directors-questionnaire') ? moduleContent['directors-questionnaire'] : moduleContent[module['type']]
					if (content) {
						module['heading'] = module['director'] ? `${content['heading']} - ${module['director']['name']} (${module['director']['designation']})` : content['heading'];
						module['aiEnhanced'] = content['aiEnhanced'];
						module['subheading'] = content['subHeading'];
						module['uploadFiles'] = content['uploadFiles'];
					}
				}
				await setSelectedModules(res['body'])
				await setCompanyId(companyId);
				localStorage.setItem('companyId', companyId);
			}
		}
		setTabName(tabName);
	};

	const getUser = async () => {
		let response = await getRequest(`/user`);
		if (response && response['code'] == 200) {
			let user = response?.['body']?.['user'];
			dispatch(updateUser(user));
		}
	};

	const getAdvisors = async () => {
		let response = await getRequest(`/user/getAdvisor`);
		if (response['code'] == 200 && response['body']) {
			setAdvisors(response['body']['advisors']);
			setInvestors(response['body']['investors'])
		};
	};

	const getFitInvestorFirms = async (isOpenModal) => {
		let clientId = location.pathname.split('/')[2];
		if (!clientId) clientId = company['_id'];
		if (clientId) {
			let response = await getRequest(`/company/getFitInvestorFirms/${clientId}`);
			if (response['code'] == 200 && response['body']) {
				if (response['message'] && user['type'] != 'Superflow') showMessage(response['message'])
				if (Array.isArray(response['body'])) {
					setFitInvestorFirms(response['body']);
					const disqualifiedFirms = response['body'].reduce((acc, firm) => {
						if (firm['requiredLevel']) acc[firm['requiredLevel'].toLowerCase()] += 1;
						return acc;
					}, {
						gold: 0,
						silver: 0,
						bronze: 0,
						threshold: 0
					})

					setInvestorFirmCounts(disqualifiedFirms);
				}
				if (user['type'] != 'Superflow') setCompanyDashboardTab('InvestorMatch');
			}
		}
	};

	const getChangeReports = async (tabName) => {
		const companyId = props && props?.isCallback ? props.companyId : location.pathname.split("/").slice(-1)[0];
		if (companyId.toLowerCase().includes('callback')) return;


		if (Object.values(auditReportLogs).length == 0) {
			setIsLoader({ show: true, message: 'Loading...' });
			let res = await getRequest(`/log/changeReports/${companyId}`);
			setIsLoader({ show: false, message: 'Loading...' });
			if (res['code'] == 200) {
				await setAuditReportLogs(res['body'])
				await setCompanyId(companyId);
				localStorage.setItem('companyId', companyId);

			}
		}
		setTabName(tabName);
	};

	const getChecklistTask = async (tabName) => {
		const companyId = props && props?.isCallback ? props.companyId : location.pathname.split("/").slice(-1)[0];
		if (companyId.toLowerCase().includes('callback')) return;

		let res = await getRequest(`/task/get/${companyId}`);
		if (res['code'] == 200) {
			await setChecklistTask(res['body'])
			await setCompanyId(companyId);
			localStorage.setItem('companyId', companyId);
		}
		setTabName(tabName);
	};

	const downloadPDF = async () => {
		try {
			setIsLeadPdf(true);
			const wrapper = document.getElementById("leadsPDF");
			wrapper.classList.remove("db");
			wrapper.classList.remove("h60vh");
			wrapper.classList.remove("oa");
			// const filename = 'Curated Investor Leads';
			const filename = [`DG-InvestorLeads-${company['cName'].substring(0, 7)}-${moment(Date.now()).format("ll")}`].join(" - ");
			const opt = { filename, jsPDF: { unit: 'mm', format: 'a2', orientation: 'p' } };
			await html2pdf().set(opt).from(wrapper).save();
			wrapper.classList.add("db");
			wrapper.classList.add("h60vh");
			wrapper.classList.add("oa");
			setTimeout(() => setIsLeadPdf(false), 1000);
		} catch (e) { console.error(e); }
	};


	const setTab = async (tabName, reset, isAfterSync, firstVisitRepository, companyNotFetch, check) => {

		if (tabName == "diligence-pack-reporting") return getCompanyByModules(tabName);
		if (tabName == "company-audit-log") return getChangeReports(tabName);
		if (tabName == "checklist-tasks") return getChecklistTask(tabName);

		let moduleName = tabName && sanitiseTab(tabName);
		dispatch(updateFileAllocation({ tab: moduleName }))
		const companyId = props && props?.isCallback ? props.companyId : location.pathname.split("/").slice(-1)[0];
		let finalUpdatedData = {}


		if (reset || (tabName && selectedCompany['modules']?.[moduleName]?.['sections'].length > 0 && !selectedCompany['modules']?.[moduleName]?.['sections'][0]['questions'])) {
			setIsLoader({ show: true, message: 'Loading...' });

			let obj = { companyId, moduleName };
			let response = await postRequest(`/company/getModule`, obj);
			setIsLoader({ show: false, message: 'Loading...' });
			if (response['code'] != 200) return;


			(!selectedCompany['firstVisitRepository'] && (moduleName && moduleName.toLowerCase() === "repository")) && dispatch(toggleModal({ open: 'firstSetupDataRepository' }));
			if (response && response?.body?.[moduleName]) {
				finalUpdatedData = {
					...selectedCompany,
					modules: {
						...selectedCompany['modules'],
						[moduleName]: {
							...selectedCompany['modules']?.[moduleName],
							...response['body'][moduleName],
							...(selectedCompany['modules']?.[moduleName]['questions'] ? { questions: selectedCompany['modules']?.[moduleName]['questions'] } : {}),
							...(moduleName === "repository" && { uploadFiles: true })
						}
					}, from: "543"
				}
				dispatch(setCompany(finalUpdatedData))
			}

			let data = {}
			if (isAfterSync == true) {
				const dataList = ['lastSyncBy', 'lastSyned', 'unallocatedFiles'];
				response = await postRequest(`/company/getData`, { companyId, dataList });
				if (response && response['code'] === 200) {
					for (const dataItem of dataList) if (dataItem in response['body'] && response['body'][dataItem] !== undefined) data = { ...data, [dataItem]: response['body'][dataItem] }
				}
				if (!companyNotFetch) getCompany(tabName, selectedCompany)
			}
			if (tabName && tabName !== "investor-lead") finalUpdatedData = calculateStats(finalUpdatedData, tabName);
			dispatch(setCompany({ ...finalUpdatedData, ...data, syncRequired: false, from: "576" }))
		}

		if (tabName) {
			setCompanyDashboardTab('Dashboard');
			setTabName(tabName);
		}
		if (moduleName == 'investor-lead') dispatch(toggleModal({ open: '' }));
	};

	const reloadModule = (resetTab, isAfterSync, hideFisrtTime = false, companyNotFetch, check) => setTimeout(() => setTab(resetTab, true, isAfterSync, hideFisrtTime, companyNotFetch, check), 1000)

	const handleCloseReportToRepository = useCallback((anchorOverride) => {
		const anchor = anchorOverride || lastReportAnchorRef.current || (() => {
			try { return localStorage.getItem('lastReportAnchor'); } catch (_) { return null; }
		})();
		setTab('repository');
		setTabName('repository');
		window.location.hash = '#repository';
		setOpenTabs((prev) => {
			const next = new Set(prev);
			next.add('repository');
			return next;
		});
		setTimeout(() => {
			const targetId = anchor || (() => {
				try { return localStorage.getItem('lastReportAnchor'); } catch (_) { return null; }
			})();
			if (targetId) {
				const el = document.getElementById(targetId);
				if (el && el.scrollIntoView) {
					el.scrollIntoView({ behavior: 'smooth', block: 'start' });
				}
			}
		}, 500);
	}, [setTab, setTabName, setOpenTabs]);

	useEffect(() => {
		let moduleName = tab && sanitiseTab(tab);
		if (moduleName == 'repository' && Object.keys(selectedCompany).length && !selectedCompany['firstVisitRepository']) {
			dispatch(toggleModal({ open: 'firstSetupDataRepository' }));
		}
	}, [selectedCompany])

	const moveToCompanyPage = () => {
		let { state } = urlSearchData(location['search']);
		let [companyId, verifier] = parseState(state);
		dispatch(toggleModal({ open: '' }))
		window.location.href = `/company/${companyId}#repository`;
	};

	const connectGDrive = () => {
		let { code, state: companyId } = urlSearchData(location['search']);
		dispatch(toggleModal({ open: 'connectingDataRoom' }));
		postRequest(`/company/connectGDrive`, { code, companyId }).then(response => {
			dispatch(toggleModal({ open: '' }));
			if (response && response['code'] == 200) {
				dispatch(toggleModal({ open: 'createdDataRoom' }));
				setTimeout(() => moveToCompanyPage(), 1000);
			}
			else setTimeout(() => moveToCompanyPage(), 1000);

		}).catch(e => showMessage('Failed to create Google Drive folders'));
	};

	const connectDropBox = async () => {
		let { code, state: companyId } = urlSearchData(location['search']);
		dispatch(toggleModal({ open: 'connectingDataRoom' }));
		postRequest(`/company/connectDropBox`, { code, companyId }).then(response => {
			dispatch(toggleModal({ open: '' }));
			if (response && response['code'] == 200) {
				dispatch(toggleModal({ open: 'createdDataRoom' }));
				setTimeout(() => moveToCompanyPage(), 1000);

			} else {
				// showMessage(response['message']);
				setTimeout(() => moveToCompanyPage(), 1000);
				// setTimeout(() => setTab("repository"), 1000);
			}
		}).catch(error => {
			showMessage('Failed to create Dropbox folders');
		})
	};

	const connectSharePoint = async () => {
		let { code, state, client_info } = urlSearchData(location['search']);
		const [companyId, verifier] = parseState(state);
		dispatch(toggleModal({ open: 'connectingDataRoom' }));
		await postRequest(`/company/connectSharePoint`, { code, companyId, client_info, verifier }, true, false, true).then(async (response) => {

			if (response && response['code'] == 200) {
				dispatch(toggleModal({ open: 'createdDataRoom' }));
				setTimeout(() => moveToCompanyPage(), 1000);
			}
			if (response?.message.includes("only supports Company")) {
				dispatch(toggleModal({ open: 'notSupportPersonalAccount' }));
			}
		}).catch(error => {
			showMessage('Failed to create SharePoint folders');
		})
	};

	const urlSearchData = searchString => {
		if (!searchString) return {};
		return searchString.substring(1).split('&').reduce((result, next) => {
			let pair = next.split('=');
			result[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
			return result;
		}, {});
	};

	const parseState = state => {
		if (state.length > 25) {
			const decode = base64.decode(state);
			return decode.split("==");
		}
		return [state, ""];
	};

	const handleMemberEdit = (user) => {
		user['permissions'] = company['memberPermissions'][user['_id']];
		dispatch(toggleModal({ open: 'editUser' }));
		setEditUser(user);
		setUserAction('Edit');
	};

	const resendInviteMember = async (memberId) => {
		let res = await postRequest('/user/resendInvite', { companyId, memberId });
		if (!res || res['code'] != 200) return;
		showMessage(res['message']);
		dispatch(toggleModal({ open: '' }));
	};

	const handleDeleteMember = (userId) => {
		setDeleteMemberId(userId);
		dispatch(toggleModal({ open: 'deleteMember' }))
	};

	const submitDeleteMember = async () => {
		if (deleteMemberId !== '') {
			let res = await postRequest('/user/deleteMember', { companyId, userId: deleteMemberId });
			showMessage(res['message']);
			if (!res || res['code'] != 200) return;
			getCompany();
		}
		dispatch(toggleModal({ open: '' }));
	};

	const openKPI = async () => {
		try {
			// OPTIMIZATION: Use kpiCount instead of keyPerformanceIndicators array (excluded in lightweight mode)
			const hasKPIs = company['kpiCount'] !== undefined ? company['kpiCount'] > 0 :
				(company['keyPerformanceIndicators'] && Object.values(company['keyPerformanceIndicators']).length > 0);

			if (!hasKPIs) {
				showMessage('We are generating your KPI report, please wait!');
				let res = await getRequest(`/company/generateKPI/${companyId}`);
				if (res['code'] == 200) await getCompany();
			}
			await setIsViewTwoMinuteReport(true);
			setTab("kpi-report");
			dispatch(toggleModal({ open: '' }));
			postRequest(`/company/generateAIReport/${company['_id']}`, { module: `two-minute-test-${company?.['testType']}` });
		} catch (e) { showMessage('Unable to generate KPI') }
	};

	const linksToCloseTab = () => {
		if (((user?.['role'] == 'Investor' || user?.['role'] == 'Advisor') && company?.['_id'] != user?.['companyId']?.['_id']) && tab == 'diligence-pack') return `/investor-dashboard`;
		else if ((window.location.href.includes('fit-report') || tab.includes('fit-report')) && user['role'] == 'Investor') return `/company/${companyId}#diligence-pack`;
		else return window.location.pathname;
	};

	const closeTab = (e, openTab) => {
		if (((user?.['role'] == 'Investor' || user?.['role'] == 'Advisor') && company?.['_id'] != user?.['companyId']?.['_id']) && tab == 'diligence-pack') return navigate(`/investor-dashboard`);
		if ((window.location.href.includes('fit-report') || tab.includes('fit-report')) && user['role'] == 'Investor') {
			navigate(`/company/${companyId}#diligence-pack`);
			setTab('diligence-pack');
			return;
		};

		localStorage.removeItem('isDiligenceReport');
		if (e?.stopPropagation) e.stopPropagation();
		openTabs.delete(openTab);
		setOpenTabs(new Set(Array.from(openTabs)));
		dispatch(toggleModal({ open: '' }));
		setAiEnchaned(false);
		if (tab === openTab) setTabName('');
	};

	const setCertificateSeeMore = async () => {
		let seeMore = {
			icon: <svg width="51" height="65" viewBox="0 0 51 65" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path d="M47.0127 19.2576C46.1594 18.4418 45.2769 17.5983 44.9976 16.9214C44.6908 16.1778 44.716 14.9085 44.7405 13.6812C44.7839 11.5015 44.8331 9.03118 43.1542 7.3442C41.4723 5.65418 38.9981 5.69252 36.817 5.72756C35.592 5.74673 34.3245 5.76692 33.584 5.45829C32.9072 5.1762 32.0659 4.29285 31.2523 3.4387C29.7169 1.82688 27.977 0 25.498 0C23.0189 0 21.279 1.82688 19.7438 3.43857C18.9302 4.29285 18.0889 5.1762 17.4121 5.45816C16.6717 5.76679 15.4042 5.74673 14.1792 5.72731C11.9962 5.69392 9.52378 5.65406 7.84202 7.34395C6.16291 9.03092 6.21217 11.5013 6.25559 13.681C6.27996 14.9085 6.30536 16.1778 5.99863 16.9212C5.7192 17.5982 4.83674 18.4418 3.98335 19.2575C2.37623 20.7939 0.554688 22.5351 0.554688 25.011C0.554688 27.4868 2.37623 29.2282 3.98335 30.7643C4.83674 31.5801 5.7192 32.4236 5.99851 33.1005C6.30536 33.8441 6.28009 35.1134 6.25559 36.3409C6.21217 38.5205 6.16304 40.9908 7.84189 42.6779C8.90031 43.7414 10.2723 44.1202 11.6877 44.2464V63.0965C11.6877 63.7357 12.0084 64.3322 12.5416 64.6848C13.0746 65.0375 13.7493 65.0991 14.3374 64.849L25.498 60.1023L36.6587 64.849C36.8979 64.9507 37.1513 65.0008 37.4038 65.0008C37.772 65.0008 38.1381 64.8941 38.4544 64.6848C38.9874 64.3323 39.3083 63.7357 39.3083 63.0965V44.2469C40.7237 44.1207 42.0955 43.7417 43.154 42.6784C44.8331 40.9914 44.7838 38.5209 44.7404 36.3413C44.716 35.1138 44.6906 33.8445 44.9973 33.1012C45.2768 32.4241 46.1592 31.5805 47.0126 30.7648C48.6197 29.2284 50.4413 27.4872 50.4413 25.0114C50.4413 22.5355 48.6199 20.794 47.0127 19.2576ZM26.2432 56.2806C25.7671 56.0779 25.2288 56.0779 24.7528 56.2806L15.4964 60.2173V44.2896C16.251 44.3044 16.9392 44.3671 17.4121 44.564C18.0889 44.8461 18.9302 45.7295 19.7438 46.5836C21.279 48.1954 23.0189 50.0223 25.498 50.0223C27.977 50.0223 29.7169 48.1954 31.2521 46.5838C32.0657 45.7295 32.9071 44.8461 33.5839 44.5642C34.0569 44.367 34.745 44.3042 35.4996 44.2893V60.2172L26.2432 56.2806ZM44.3809 28.0117C43.2414 29.1008 42.0633 30.227 41.4768 31.6483C40.8669 33.1262 40.9003 34.7992 40.9325 36.4172C40.9608 37.839 40.9929 39.4507 40.4544 39.9916C39.914 40.5345 38.3005 40.5095 36.8767 40.4868C35.2616 40.4616 33.5914 40.4352 32.1189 41.0485C30.702 41.6389 29.5796 42.8174 28.494 43.9571C27.4865 45.0148 26.3447 46.2137 25.4977 46.2137C24.6508 46.2137 23.509 45.0147 22.5013 43.9569C21.4159 42.8173 20.2935 41.6389 18.8765 41.0484C17.6995 40.5581 16.3964 40.4765 15.0958 40.4765C14.7694 40.4765 14.4429 40.4817 14.1189 40.4868C12.695 40.509 11.0815 40.5346 10.5411 39.9916C10.0028 39.4505 10.0349 37.8391 10.0631 36.4172C10.0953 34.7992 10.1287 33.126 9.51871 31.648C8.9323 30.227 7.75416 29.1008 6.61474 28.0115C5.55924 27.0026 4.36295 25.859 4.36295 25.0112C4.36295 24.1634 5.55924 23.0197 6.61474 22.0108C7.75416 20.9216 8.9323 19.7954 9.51883 18.3742C10.1287 16.8963 10.0953 15.2233 10.0631 13.6052C10.0348 12.1833 10.0027 10.5716 10.5412 10.0307C11.0816 9.48783 12.6959 9.51297 14.1188 9.5357C15.7348 9.56083 17.4044 9.58737 18.8768 8.97379C20.2936 8.38358 21.416 7.20506 22.5015 6.06539C23.5091 5.00748 24.6511 3.80864 25.498 3.80864C26.3449 3.80864 27.4869 5.00748 28.4944 6.06526C29.5798 7.20506 30.7022 8.38346 32.1191 8.97367C33.5916 9.58724 35.2614 9.56045 36.8771 9.53557C38.3009 9.51335 39.9143 9.48796 40.4548 10.0307C40.9931 10.5716 40.9609 12.1832 40.9328 13.6051C40.9005 15.223 40.8671 16.8962 41.4771 18.3742C42.0635 19.7952 43.2417 20.9214 44.3811 22.0106C45.4366 23.0196 46.6329 24.1633 46.6329 25.0111C46.6329 25.8589 45.4365 27.0026 44.3809 28.0117Z" fill="#4A67FF" />
				<path d="M25.4974 11.1484C17.9579 11.1484 11.8242 17.2991 11.8242 24.8594C11.8242 32.4197 17.9579 38.5705 25.4974 38.5705C33.0368 38.5705 39.1705 32.4198 39.1705 24.8595C39.1705 17.2993 33.0368 11.1484 25.4974 11.1484ZM25.4974 34.7619C20.058 34.7619 15.6329 30.3197 15.6329 24.8595C15.6329 19.3994 20.058 14.9572 25.4974 14.9572C30.9367 14.9572 35.3619 19.3994 35.3619 24.8595C35.3619 30.3197 30.9367 34.7619 25.4974 34.7619Z" fill="#4A67FF" />
				<path d="M27.733 21.2648L24.2814 24.7165L23.2665 23.7016C22.5229 22.958 21.3171 22.958 20.5734 23.7016C19.8297 24.4452 19.8297 25.651 20.5734 26.3947L22.9349 28.7562C23.292 29.1133 23.7763 29.314 24.2814 29.314C24.7864 29.314 25.2709 29.1134 25.6279 28.7562L30.426 23.9579C31.1697 23.2142 31.1697 22.0085 30.426 21.2648C29.6824 20.5211 28.4766 20.5211 27.733 21.2648Z" fill="#4A67FF" />
			</svg>,
			title: <>Diligentsia <br />Certification</>,
			points: [
				'Complete modules',
				'Completeness and risk scoring',
				'Unaudited certification:',
				'Gold certification – opens up access to InvestorMatch',
				'Digital certification valid for 3 months',
				'Or, with Diligentsia Pro PLUS, have your lawyer or accountant assist and provide you an audited certificate',
			],
			subMenu: {
				index: 2,
				points: [
					"- Bronze – basic level reached",
					"- Silver – potentially investible",
					"- Gold – sophisticated"
				]
			},
			image: require('../../../../images/landingpage/banner5.png'),
		}
		await setSelectedSeeMore(seeMore);
		dispatch(toggleModal({ open: 'seeMorePopup' }));
	};

	useEffect(() => {
		if (modal.resetTab) {
			openTabs.delete('repository');
			if (!openTabs.has(tab)) setOpenTabs(new Set(Array.from(openTabs)));
			if (tab === 'repository') setTab('');
			dispatch(resetTabModal(false))
		}
	}, [modal.resetTab])

	const toggleReport = async (e, reportType) => {
		if (tab.endsWith("-report")) {
			closeTab(e, tab);
			if (tab === "kpi-report") {
				if (user['role'] == 'Guest') setTab("two-minute-test-" + company.testType);
				else setTab('');
			}
			else {
				if (tab == `business-audit-${company['testType']}`) enableAIEnhancedReporting();
				if (permissionLevel != 'DASHBOARD & REPORT') await setTab((reportType || tab).replace(/(-sync)?-report$/, ""));
				// navigate(`#${(reportType || tab).replace(/(-sync)?-report$/, "")}`);
			}
		}
		else {
			// navigate(`#${tab}-report`);
			if (tab == `business-audit-${company['testType']}`) enableAIEnhancedReporting();
			setTab(reportType || tab + "-report");
			scrollTo({ top: 0, behavior: "smooth" });
		}

		e.target.innerText = tab.endsWith("-report") ? e.target.innerText.replace("CLOSE", "VIEW") : e.target.innerText.replace("VIEW", "CLOSE");
	};

	const twoMinuteTestAIReport = async (module) => {
		if (tab.includes('two-minute-test') && module['stats']['completionPercent'] < 100) showMessage('Please complete the Test!');
		else enableAIEnhancedReporting();
	};

	const enableAIEnhancedReporting = async () => {
		if (aiEnhanced) {
			if (!tab.includes("report")) {
				setTab(tab + "-report");
			}
			if (user['role'] == 'Guest' || tab == 'kpi-report') {
				setTab(`two-minute-test-${company?.['testType']}-report`);

			}
			if (user['role'] == 'Guest' && tab.includes('two-minute-test')) {
				setOpenTabs((prevTabs) => {
					const updatedTabs = new Set(prevTabs);
					const tabName = `two-minute-test-${company?.['testType']}-report`
					updatedTabs.add(tabName);
					return updatedTabs;
				});
			}
			showMessage('AI Report Generated. Check AI Enhanced Recommendations.');
			return;
		}

		dispatch(toggleModal({ open: 'generatingAIReport' }));
		let module;
		if (user['role'] == 'Guest' || tab == 'kpi-report') module = `two-minute-test-${company?.['testType']}`;
		else module = tab.replace('-report', '');
		const response = await postRequest(`/company/generateAIReport/${company['_id']}`, { module });
		if (response['code'] == 400) dispatch(toggleModal({ open: '' }));
	};

	const calculateCertification = (company) => {
		let auditType = 'business-audit-' + company['testType'];
		let points = { 'Bronze': {}, 'Silver': {}, 'Gold': {} }, extraModules = { 'Bronze': {}, 'Silver': {}, 'Gold': {} };
		let data = {
			'repository': {
				// completeness: 75,
				'completeness': company['modules']?.['repository']?.['stats']?.['completionPercent'] || 0
			}, 'business-audit': {
				'risk': company['modules']?.[auditType]?.['stats']?.['riskPercent'] || 0,
				'completeness': company['modules']?.[auditType]?.['stats']?.['completionPercent'] || 0
			}, 'warranty-disclosure': {
				'completeness': company['modules']?.['warranty-disclosure']?.['stats']?.['completionPercent'] || 0
			}, 'directors-questionnaire': {
				'risk': company?.['directorsStats']?.['riskPercent'] || 0,
				'completeness': company?.['directorsStats']?.['completionPercent'] || 0,
			}, 'esg': {
				'risk': company['modules']?.['esg']?.['stats']?.['riskPercent'] || 0,
				'completeness': company['modules']?.['esg']?.['stats']?.['completionPercent'] || 0
			}, 'software-development': {
				'risk': company['modules']?.['software-development']?.['stats']?.['riskPercent'] || 0,
				'completeness': company['modules']?.['software-development']?.['stats']?.['completionPercent'] || 0
			}, 'two-minute-test': {
				'risk': company['modules'][`two-minute-test-${company['testType']}`]?.['stats']?.['riskPercent'] || 0,
				'completeness': company['modules'][`two-minute-test-${company['testType']}`]?.['stats']?.['completionPercent'] || 0,
			}
		};

		for (let [moduleKey, object] of Object.entries(company['modules'])) {
			if (!data[moduleKey]) {
				data[moduleKey] = { completeness: object?.['stats']?.['completionPercent'] || 0, risk: object?.['stats']?.['riskPercent'] || 0 };

				points['Bronze'][moduleKey] = data[moduleKey]['completeness'] >= 60 && data[moduleKey]['risk'] <= 60;
				points['Silver'][moduleKey] = data[moduleKey]['completeness'] >= 80 && data[moduleKey]['risk'] <= 40;
				points['Gold'][moduleKey] = data[moduleKey]['completeness'] == 100 && data[moduleKey]['risk'] <= 30;

				company['moduleCertification'] = {
					...company['moduleCertification'],
					[moduleKey]: points['Gold'][moduleKey] ? 'Gold' : points['Silver'][moduleKey] ? 'Silver' : points['Bronze'][moduleKey] ? 'Bronze' : 'None'
				};
			}
		}

		points['Bronze']['p1'] = data['repository']['completeness'] >= 75;
		points['Bronze']['p2'] = data['business-audit']['completeness'] >= 75 && data['business-audit']['risk'] <= 50;
		points['Bronze']['status'] = (points['Bronze']['p1'] && points['Bronze']['p2']) ? 'complete-button' : (points['Bronze']['p1'] || points['Bronze']['p2']) ? 'inprogrees-btn' : 'noy-yet-btn';
		points['Bronze']['active'] = points['Bronze']['status'] == 'complete-button';
		extraModules['Bronze']['p1'] = data['esg']['completeness'] >= 75 && data['esg']['risk'] <= 50;
		extraModules['Bronze']['p2'] = data['software-development']['completeness'] >= 75 && data['software-development']['risk'] <= 50;

		points['Silver']['p1'] = data['repository']['completeness'] >= 90;
		points['Silver']['p2'] = data['business-audit']['completeness'] >= 90 && data['business-audit']['risk'] <= 50;
		points['Silver']['p3'] = data['warranty-disclosure']['completeness'] >= 75;
		points['Silver']['p4'] = data['directors-questionnaire']['completeness'] >= 75 && data['directors-questionnaire']['risk'] <= 50;
		points['Silver']['status'] = (points['Silver']['p1'] && points['Silver']['p2'] && points['Silver']['p3'] && points['Silver']['p4']) ? 'complete-button' :
			(points['Silver']['p1'] || points['Silver']['p2'] || points['Silver']['p3'] || points['Silver']['p4']) ? 'inprogrees-btn' : 'noy-yet-btn';
		points['Silver']['active'] = points['Silver']['status'] == 'complete-button';
		extraModules['Silver']['p1'] = data['esg']['completeness'] >= 90 && data['esg']['risk'] <= 50;
		extraModules['Silver']['p2'] = data['software-development']['completeness'] >= 90 && data['software-development']['risk'] <= 50;

		points['Gold']['p1'] = data['repository']['completeness'] == 100;
		points['Gold']['p2'] = data['business-audit']['completeness'] == 100 && data['business-audit']['risk'] <= 25;
		points['Gold']['p3'] = data['warranty-disclosure']['completeness'] >= 90;
		points['Gold']['p4'] = data['directors-questionnaire']['completeness'] >= 90 && data['directors-questionnaire']['risk'] <= 50;
		points['Gold']['status'] = (points['Gold']['p1'] && points['Gold']['p2'] && points['Gold']['p3'] && points['Gold']['p4']) ? 'complete-button' :
			(points['Gold']['p1'] || points['Gold']['p2'] || points['Gold']['p3'] || points['Gold']['p4']) ? 'inprogrees-btn' : 'noy-yet-btn';
		points['Gold']['active'] = points['Gold']['status'] == 'complete-button';
		extraModules['Gold']['p1'] = data['esg']['completeness'] == 100 && data['esg']['risk'] <= 25;
		extraModules['Gold']['p2'] = data['software-development']['completeness'] == 100 && data['software-development']['risk'] <= 25;

		company['points'] = points;

		let cLevel = points['Bronze']['active'] && points['Silver']['active'] && points['Gold']['active'] ? 'Gold' :
			points['Bronze']['active'] && points['Silver']['active'] ? 'Silver' : points['Bronze']['active'] ? 'Bronze' : 'None';
		company['cLevel'] = cLevel;
		company['certificateNext'] = cLevel == 'Gold' ? 'All Done' : cLevel == 'Silver' ? 'Gold' : cLevel == 'Bronze' ? 'Silver' : cLevel == 'None' ? 'Bronze' : 'None';

		company['moduleCertification'] = {
			...company['moduleCertification'],
			'repository': points['Gold']['p1'] ? 'Gold' : points['Silver']['p1'] ? 'Silver' : points['Bronze']['p1'] ? 'Bronze' : 'None',
			'business-audit': points['Gold']['p2'] ? 'Gold' : points['Silver']['p2'] ? 'Silver' : points['Bronze']['p2'] ? 'Bronze' : 'None',
			'warranty-disclosure': points['Gold']['p3'] ? 'Gold' : points['Silver']['p3'] ? 'Silver' : points['Bronze']['p3'] ? 'Bronze' : 'None',
			'directors-questionnaire': points['Gold']['p4'] ? 'Gold' : points['Silver']['p4'] ? 'Silver' : points['Bronze']['p4'] ? 'Bronze' : 'None',
			'esg': extraModules['Gold']['p1'] ? 'Gold' : extraModules['Silver']['p1'] ? 'Silver' : extraModules['Bronze']['p1'] ? 'Bronze' : 'None',
			'software-development': extraModules['Gold']['p2'] ? 'Gold' : extraModules['Silver']['p2'] ? 'Silver' : extraModules['Bronze']['p2'] ? 'Bronze' : 'None',
		}
		company['moduleCertification'][`two-minute-test-${company['testType']}`] = data['two-minute-test']['risk'] == 0 && data['two-minute-test']['completeness'] == 0 ? 'None' : data['two-minute-test']['risk'] <= 50 && data['two-minute-test']['completeness'] == 100 ? 'Pass' : 'Fail';

		let completePoints = 0, totalPoints = 0;
		let point = points[company['certificateNext']] || points[cLevel];
		if (point) Object.keys(point).forEach(key => {
			if (key.indexOf('p') >= 0) {
				totalPoints++;
				if (point[key]) completePoints++;
			}
		});
		company['certificateProgress'] = (completePoints / totalPoints) * 100;

		return company;
	};

	const calculateStats = (companyObject, moduleName, check) => {
		companyObject = JSON.parse(JSON.stringify(companyObject));
		const wasRepositoryComplete = companyObject?.['modules']?.['repository']?.['stats']?.['completionPercent'] === 100;
		// for (const module of Object.values(companyObject.modules)) {
		let module = companyObject['modules'][sanitiseTab(moduleName ?? tab)];

		if (module) {
			if (module['stats']) module['stats'] = { minRiskScore: 0, maxRiskScore: 0, riskScore: 0, maxCompletionScore: 0, completionScore: 0, workflowCompletionScore: 0, workflowMaxScore: 0 }
			if (module['sections']) {
				for (const section of Object.freeze(module['sections'])) {

					section['stats'] = { minRiskScore: 0, maxRiskScore: 0, riskScore: 0, maxCompletionScore: 0, completionScore: 0, workflowCompletionScore: 0, workflowMaxScore: 0 };

					// TODO: For Expension packs aggregate all questions from SubFolders
					let questions = [];
					if (module['expansionPack']) {
						Object.values(section['subFolders']).forEach(subSection => questions = questions.concat(subSection['questions']));
						questions = questions.filter(question => question !== undefined);
					} else questions = section['questions'];

					if (questions) {
						for (const question of questions) {
							if (section["type"] === "Existing Sections" && question["type"] === "repository" && companyObject["subscription"] == "Pro" && question["qNo"].split(".").length == 1) continue;
							else if (section["type"] === "Existing Sections" && question["type"] === "repository" && companyObject["subscription"] == "Lite" && question["qNo"].split(".").length > 1) continue;

							if (!question['isSkipped']) {
								let answer = question?.['answer'] || {};
								if (["Completed", "Not Applicable"].includes(answer?.['status'])) {
									// if (["Completed", "Not Applicable"].includes(answer?.['status']) || module['type'] !== "repository" && answer?.['radioOption']) {
									if (answer?.['radioOption'] && answer?.['radioOption'] !== 'NC')
										// if(answer?.['radioOption'] && answer?.['radioOption'] !== 'NC' && ["Completed", "Not Applicable"].includes(answer?.['status']))
										section['stats']['completionScore'] += question['completionScore'] || 1;
									if (question['questionType'] == 'D/ND')
										section['stats']['riskScore'] += answer?.['radioOption'] == 'Disclosure' ? question['riskIfD']
											: answer?.['radioOption'] == 'No Disclosure' ? question['riskIfND']
												: answer?.['radioOption'] == 'Not Sure' ? question['riskIfNS'] : 0;
									else section['stats']['riskScore'] += question["riskIf" + answer?.['radioOption']] || 0;

									let workflowScores = { 'Not Started': 0, 'Started': 0.25, 'In Progress': 0.50, 'Completed - Further Work': 0.75, 'Completed - No Issues': 1 }
									if (answer['taskStatus'] && Object.keys(workflowScores).includes(answer['taskStatus'])) {
										section['stats']['workflowMaxScore'] += 1;
										section['stats']['workflowCompletionScore'] += workflowScores[answer['taskStatus']];
									}

									const allRiskScores = Object.keys(question).filter(k => k.startsWith("riskIf")).map(k => question[k]);
									section['stats']['minRiskScore'] += Math.min(...allRiskScores);
									section['stats']['maxRiskScore'] += Math.max(...allRiskScores);

								}
								section['stats']['maxCompletionScore'] += question['completionScore'] || 1;
							}
						}
					}

					if (section['stats']['completionScore'] == 0) section['stats']['riskPercent'] = 0
					else section['stats']['riskPercent'] = Math.round((section['stats']['riskScore'] - section['stats']['minRiskScore']) / (section['stats']['maxRiskScore'] - section['stats']['minRiskScore']) * 100);
					section['stats']['completionPercent'] = Math.round(section['stats']['completionScore'] / section['stats']['maxCompletionScore'] * 100);
					section['stats']['workflowCompletionPercent'] = Math.round((section['stats']['workflowCompletionScore'] / section['stats']['workflowMaxScore']) * 100);

					if (section['subFolders']) calculateSubFolderStats(module, section['subFolders'], questions);
				}
				module['stats'] = module.sections.reduce((stats, section) => {
					for (const key in section['stats'])
						stats[key] = (stats[key] ?? 0) + section['stats'][key];
					return stats;
				}, { minRiskScore: 0, maxRiskScore: 0, riskScore: 0, maxCompletionScore: 0, completionScore: 0, workflowCompletionScore: 0, workflowMaxScore: 0 });

				if (module['type'] == 'repository' && companyObject['subscription'] == 'Lite') module["stats"]["maxCompletionScore"] = 20;

				if (module['stats']['completionScore'] == 0) module['stats']['riskPercent'] = 0
				else module['stats']['riskPercent'] = Math.round((module['stats']['riskScore'] - module['stats']['minRiskScore']) / (module['stats']['maxRiskScore'] - module['stats']['minRiskScore']) * 100);

				if (module['stats']['completionScore']) module['stats']['completionPercent'] = Math.round(module['stats']['completionScore'] / module['stats']['maxCompletionScore'] * 100);
				module['stats']['workflowCompletionPercent'] = Math.round((module['stats']['workflowCompletionScore'] / module['stats']['workflowMaxScore']) * 100);
			}

			companyObject['stats'] = Object.values(companyObject.modules).reduce((stats, module) => {
				if (module?.['stats']?.['completionScore'] > 0)
					for (const key in module['stats'])
						stats[key] = (stats[key] ?? 0) + module['stats'][key];
				return stats;
			}, { minRiskScore: 0, maxRiskScore: 0, riskScore: 0, maxCompletionScore: 0, completionScore: 0, workflowCompletionScore: 0, workflowMaxScore: 0 });

			if (companyObject['stats']['completionScore'] == 0) companyObject['stats']['riskPercent'] = 0
			else companyObject['stats']['riskPercent'] = Math.round((companyObject['stats']['riskScore'] - companyObject['stats']['minRiskScore']) / (companyObject['stats'].maxRiskScore - companyObject['stats']['minRiskScore']) * 100);
			companyObject['stats']['completionPercent'] = Math.round(companyObject['stats']['completionScore'] / companyObject['stats'].maxCompletionScore * 100);
			companyObject['stats']['workflowCompletionPercent'] = Math.round((module['stats']['workflowCompletionScore'] / module['stats']['workflowMaxScore']) * 100);

			if (!wasRepositoryComplete && companyObject?.modules?.repository?.['stats']?.['completionPercent'] == 100) dispatch(toggleModal({ open: 'respositoryCompleted' }));
			if (tab == `two-minute-test-${company['testType']}` && companyObject?.['modules']?.[tab]?.['stats']?.['completionPercent'] == 100) {
				if (!moduleName) {
					reloadModule(`two-minute-test-${company['testType']}`, true, null, null, "1");
				}
				if (!tab.endsWith("-report") && user['role'] == 'Guest') dispatch(toggleModal({ open: 'twoMinuteTestCompleted' }));
			}
			calculateCertification(companyObject);
			companyObject = calculateDirectorStats(companyObject);
		}
		return companyObject;
	};

	const calculateDirectorStats = (companyObj) => {
		let directorsCount = 0;
		if (companyObj['directorsStats']) {
			companyObj['directorsStats']['riskPercent'] = 0;
			companyObj['directorsStats']['completionPercent'] = 0;
		}
		for (let module of Object.values(companyObj['modules'])) {
			if (module['type'] && module['type'].includes('directors-questionnaire')) {
				if (!companyObj['directorsStats']) {
					companyObj['directorsStats'] = {
						riskPercent: module['stats']['riskPercent'],
						completionPercent: module['stats']['completionPercent']
					}
				} else {
					companyObj['directorsStats']['riskPercent'] += module['stats']['riskPercent'];
					companyObj['directorsStats']['completionPercent'] += module['stats']['completionPercent'];
				}
				directorsCount++;
			}
		}
		if (directorsCount > 0) {
			companyObj['directorsStats']['riskPercent'] = (companyObj['directorsStats']['riskPercent'] / directorsCount).toFixed(0);
			companyObj['directorsStats']['completionPercent'] = (companyObj['directorsStats']['completionPercent'] / directorsCount).toFixed(0);
		}

		const directorsStatsPercentage = {
			personal: { completionPercent: 0, riskPercent: 0 },
			occupational: { completionPercent: 0, riskPercent: 0 },
			personalFinantial: { completionPercent: 0, riskPercent: 0 },
			litigation: { completionPercent: 0, riskPercent: 0 }
		}
		let numofDirectors = 0
		for (const moduleKey in companyObj['modules']) {
			if (typeof companyObj['modules'][moduleKey] === 'object') {
				const module = companyObj['modules'][moduleKey];
				if (moduleKey.includes('directors-questionnaire')) {
					for (const section of module['sections']) {
						if (section['subFolders']) {
							for (const subFolderKey in section['subFolders']) {
								const subFolder = section.subFolders[subFolderKey];
								if (subFolder['sectionNo'] == "DEPF007.1") {
									directorsStatsPercentage['personal']['completionPercent'] += subFolder['stats']['completionPercent'];
									directorsStatsPercentage['personal']['riskPercent'] += subFolder['stats']['riskPercent'];
								}
								if (subFolder['sectionNo'] == "DEPF007.2") {
									directorsStatsPercentage['occupational']['completionPercent'] += subFolder['stats']['completionPercent'];
									directorsStatsPercentage['occupational']['riskPercent'] += subFolder['stats']['riskPercent'];
								}
								if (subFolder['sectionNo'] == "DEPF007.3") {
									directorsStatsPercentage['personalFinantial']['completionPercent'] += subFolder['stats']['completionPercent'];
									directorsStatsPercentage['personalFinantial']['riskPercent'] += subFolder['stats']['riskPercent'];
								}
								if (subFolder['sectionNo'] == "DEPF007.4") {
									directorsStatsPercentage['litigation']['completionPercent'] += subFolder['stats']['completionPercent'];
									directorsStatsPercentage['litigation']['riskPercent'] += subFolder['stats']['riskPercent'];
								}
							}
						}
					}
					numofDirectors++;
				}
			}
		}
		if (numofDirectors > 0)
			for (const category in directorsStatsPercentage) {
				directorsStatsPercentage[category]['completionPercent'] /= numofDirectors;
				directorsStatsPercentage[category]['riskPercent'] /= numofDirectors;
			}

		companyObj['directorSectionStats'] = directorsStatsPercentage;

		return companyObj;
	};

	const calculateSubFolderStats = (module, subFolders, questions) => {
		for (const subFolder of Object.values(subFolders)) {
			subFolder.stats = { minRiskScore: 0, maxRiskScore: 0, riskScore: 0, maxCompletionScore: 0, completionScore: 0, workflowCompletionScore: 0, workflowMaxScore: 0 };

			let currentQuestions;
			if (subFolder['questions']) currentQuestions = subFolder['questions'];
			else currentQuestions = questions && questions.filter(q => q.qNo.match(new RegExp(subFolder.no + "((\.[0-9]+)|$)")));
			if (currentQuestions) {
				for (const question of currentQuestions) {
					if (!question['isSkipped']) {
						let answer = question['answer'] || {};
						if (["Completed", "Not Applicable"].includes(answer?.status)) {
							// if (["Completed", "Not Applicable"].includes(answer?.status) || module.type !== "repository" && answer?.['radioOption']) {
							if (answer?.['radioOption'] && answer?.['radioOption'] !== 'NC')
								subFolder['stats']['completionScore'] += question['completionScore'] || 1;
							if (question['questionType'] == 'D/ND')
								subFolder['stats']['riskScore'] += answer?.['radioOption'] == 'Disclosure' ? question['riskIfD']
									: answer?.['radioOption'] == 'No Disclosure' ? question['riskIfND']
										: answer?.['radioOption'] == 'Not Sure' ? question['riskIfNS'] : 0;
							else subFolder['stats']['riskScore'] += question["riskIf" + answer?.['radioOption']] || 0;

							let workflowScores = { 'Not Started': 0, 'Started': 0.25, 'In Progress': 0.50, 'Completed - Further Work': 0.75, 'Completed - No Issues': 1 }
							if (answer['taskStatus'] && Object.keys(workflowScores).includes(answer['taskStatus'])) {
								subFolder['stats']['workflowMaxScore'] += 1;
								subFolder['stats']['workflowCompletionScore'] += workflowScores[answer['taskStatus']];
							}
							const allRiskScores = Object.keys(question).filter(k => k.startsWith("riskIf")).map(k => question[k]);
							subFolder['stats']['minRiskScore'] += Math.min(...allRiskScores);
							subFolder['stats']['maxRiskScore'] += Math.max(...allRiskScores);
						}
						subFolder['stats']['maxCompletionScore'] += question['completionScore'] || 1;
					}
				}
			}
			if (subFolder['stats']['completionScore'] == 0) subFolder['stats']['riskPercent'] = 0
			else subFolder['stats']['riskPercent'] = Math.round((subFolder['stats']['riskScore'] - subFolder['stats']['minRiskScore']) / (subFolder['stats']['maxRiskScore'] - subFolder['stats']['minRiskScore']) * 100);
			subFolder['stats']['completionPercent'] = Math.round(subFolder['stats']['completionScore'] / subFolder['stats']['maxCompletionScore'] * 100);
			subFolder['stats']['workflowCompletionPercent'] = Math.round((module['stats']['workflowCompletionScore'] / module['stats']['workflowMaxScore']) * 100);

			if (subFolder.subFolders) calculateSubFolderStats(module, subFolder['subFolders'], currentQuestions);
		}
	};

	const getCompletenessAndRiskHTML = (layoutType, stats, questions) => {
		let tabModule = company?.['modules']?.[sanitiseTab(tab)];
		if (stats) stats = JSON.parse(JSON.stringify(stats));
		if (questions) questions = JSON.parse(JSON.stringify(questions));

		let completenessColour = 9 - Math.floor(stats['completionPercent'] / 33.34);
		let completenessText = (stats['completionPercent'] && stats['completionPercent'] > 0 ? stats['completionPercent'] + `% ${stats['completionPercent'] == 100 ? 'Completed' : 'Complete'}` : "Not Started");

		// If its 1 question
		if (questions && questions.length == 1) {
			completenessText = questions[0]?.['answer']?.status || 'Not Started';
			completenessColour = completenessText === 'Not Started' ? 9 : (completenessText == 'In Progress' || completenessText == 'Not Applicable') ? 8 : completenessText == 'Completed' ? 7 : 9;
		}

		if (layoutType.includes("repository") || layoutType.includes("investor-lead") || tabModule?.['riskScoring'] == false)
			return <span className={"fw600 lh1 fs1rem mt1rem c" + completenessColour}>{completenessText}</span>

		let riskText, riskColour;
		if (stats['riskPercent'] == 0 && stats['completionPercent'] == 0) {
			riskColour = 37;
			riskText = "No Risk Score";
		} else if (stats['riskPercent'] > 62) {
			riskColour = 9;
			riskText = "High Risk";
		} else if (stats['riskPercent'] < 38) {
			riskColour = 34;
			riskText = "Low Risk";
		} else {
			riskColour = 8;
			riskText = "Medium Risk";
		}

		if (layoutType.includes("sidebar"))
			return <>
				<span className={`fw300 c${completenessColour} tac fw600 lh1 fs1rem mt1rem`}>{stats.completionPercent || 0}% Complete</span>
				{(!layoutType.includes("repository") || !layoutType.includes("investor-lead") || tabModule?.['riskScoring'] == true) && <span className={`fw300 c${riskColour} tac fw600 lh1 fs1rem mt0-5rem`}>{riskText}</span>}
			</>;
		return <>
			<span className={"c" + completenessColour}>{completenessText}</span>
			<span className="mx0-5rem"> | </span>
			<span className={"c" + riskColour}>{riskText}</span>
		</>
	};

	const handleContactInvestor = async (investor, isContacted = true) => {
		let investorId = investor['_id'];
		let clientId = location.pathname.split('/')[2];
		let res = await postRequest(`/company/contactInvestor`, { investorId, clientId, isContacted });
		if (res && res['code'] == 200) getFitInvestorFirms();
		else showMessage(res['message']);
	};

	const handleInvestorEmail = async (investor) => {
		if (!investor['isContacted']) {
			setAcceptEmail(false);
			await setInvestorEmail(investor);
			await handleContactInvestor(investor, true);
			dispatch(toggleModal({ open: 'investorEmailSent' }));
		}
	};

	const sendInvestorEmail = async () => {
		let data = {
			investorId: investorEmail['_id'],
			investorName: investorEmail['name'],
			clientId: company['_id'],
			clientName: company['cName'],
			fitScorePercentage: investorEmail['fitScorePercentage'],
			contactId: investorEmail['contactId'],
			contactName: investorEmail['contactName'],
			email: investorEmail['contactEmail'],
		};

		if (investorEmail) {
			let res = await postRequest(`/company/sendInvestorEmail`, data);
			if (res['code'] == 200) {
				setInvestorEmail({});
				setAcceptEmail(false);
				dispatch(toggleModal({ open: '' }));
				showMessage(res['message']);
			}
		}
	};

	const handleUploadImage = async (e) => {
		let profile = e.target.files[0];
		if (profile && profile.size > 5 * 1024 * 1024)
			return showMessage("Photo Size must be less than 5MB");
		profile = await URL.createObjectURL(profile);
		setUploadImage(profile);
	};

	const updateProfile = async () => {
		let attachment = [];
		if (cropper.current && uploadImage) {
			let imageToUpload = cropper?.current?.getCroppedCanvas()?.toDataURL();
			let res = await fetch(imageToUpload);
			let blob = await res.blob();
			const coverFile = new File([blob], "profile-image.png", { type: "image/png" });
			attachment.push(coverFile);

			const response = await postRequest(`/company/updateLogo/${companyId}`, { attachment });
			if (response || response["code"] == 200) dispatch(setCompany({ ...selectedCompany, logo: response?.['body']?.['logo'] }))

			setUploadImage('');
			dispatch(toggleModal({ open: "" }));
		}
		else showMessage("Please upload image first")
	};

	const permissionTooltip = (permissions, isOwner) => {
		return (
			<div className='module-tooltip-box' style={{ position: 'relative' }}>
				<img src={require('../../../../images/hover-list-icon.png')} style={{ width: '20px', height: '20px', bottom: '25px', left: '-10px' }} className="cp pa" alt="list-img" />
				{company?.['sections'] && company['sections'].length > 0 && Object.keys(permissions).length > 0 &&
					<span className="tooltip-area tooltip-area-permissions" style={{ height: '60vh', overflow: 'auto' }}>
						{company['sections'].map((sec, idx) => {
							return <p key={`section-${sec?.['sectionNo'] || idx}`} className="dashboard-permission-overlaybox overlay-box cp w100 tac bss bw1px bo28" style={{ opacity: (permissions?.[sec?.['sectionNo']] || isOwner) ? '1' : '0.5' }}>
								{(permissions?.[sec?.['sectionNo']] || isOwner) && <i className="fa fa-check-circle green mr0-5rem" style={{ fontSize: '13px' }}></i>}
								{sec['sectionName']}
							</p>
						})}
					</span>
				}
			</div>
		)
	};

	const showPopupPercent = (value, type) => {
		let color;
		if (type == 'Risk') color = value > 67 ? 'red' : value > 33 ? 'yellow' : 'green';
		else if (type == 'Completeness') color = value > 67 ? 'green' : value > 33 ? 'yellow' : 'red';
		return <span className={`${color}`}><span className='c6'>{type}</span> {value || 0}% </span>
	};

	const createDirector = async () => {
		const companyId = location.pathname.split("/").slice(-1)[0];
		const name = document.getElementById("directorName").value;
		const designation = document.getElementById("directorDesignation").value;
		if (name && designation) {
			const postBody = { name, designation };
			const response = await postRequest(`/company/createDirector/${companyId}`, postBody);
			if (response && response['code'] == 200) {
				dispatch(toggleModal({ open: '' }));
				showMessage(response['message']);
				window.location.reload();
			}
		} else showMessage("Enter director name and designation");
	};

	const handleViewDirector = async (item) => {
		if ((localStorage.getItem('isDiligencePack') && !isBackFitReport) || user?.['type'] == 'External') await setTab(`directors-questionnaire_${item['_id']}-report`);
		else await setTab(`directors-questionnaire_${item['_id']}`);
		dispatch(toggleModal({ open: '' }));
	};

	const handleBackDirectors = async () => {
		await setTabName("");
		await setOpenTabs(new Set());
		dispatch(toggleModal({ open: 'showDirectors' }));
	};

	const sortSections = (a, b) => {
		let valueA = (a?.sectionNo || a?.no).match(/\d+/g);
		let valueB = (b?.sectionNo || b?.no).match(/\d+/g);

		return valueA - valueB;
	};

	const handleDemoNext = async () => {
		let module = company['modules'][tab.replace('-report', '')];
		if (isPrePopulate && module) {
			dispatch(toggleModal({ open: 'demoChecklistFlow' }));
			let res = await postRequest(`/checklist/populate`, { companyId: company['_id'], moduleId: module['_id'] });
			if (res?.['code'] == 200) {
				await setTab(tab, true);
				dispatch(toggleModal({ open: '' }));
				setIsPrePopulate(false);
			}
		}
		else {
			setIsPrePopulate(false);
			if (tab.endsWith("-report")) {
				if (isWorkflowReport) window.location.href = `/company/${company['_id']}`;
				else {
					setIsWorkflowReport(true);
					dispatch(toggleModal({ open: 'demoChecklistFlow' }));
					setTimeout(() => { dispatch(toggleModal({ open: '' })); setTab(tab); }, 4000);
				}
			}
			else {
				setIsWorkflowReport(false);
				dispatch(toggleModal({ open: 'demoChecklistFlow' }));
				setTimeout(() => { dispatch(toggleModal({ open: '' })); setTab(`${tab}-report`); }, 4000);
			}
		}

	};

	const handlePartnerChecklistNext = async () => {
		setIsPrePopulate(false);
		if (tab.endsWith("-report")) window.location.href = `/company/${company['_id']}`;
		else {
			setIsWorkflowReport(false);
			dispatch(toggleModal({ open: 'demoChecklistFlow' }));
			setTimeout(() => { dispatch(toggleModal({ open: '' })); setTab(`${tab}-report`); }, 4000);
		}
	};

	const handleSuperflowNext = async () => {
		if (company?.modules?.['investor-lead'] && company?.modules?.['investor-lead']?.['stats']?.['completionPercent'] == 100) handleSuperFlowPopup();
	};

	const nextInvestmentReadiness = async () => {
		if (company['modules']?.['Investment Readiness']) {
			window.location.href = `/company/${company['_id']}#${partner['moduleName']}`;
			setTimeout(() => window.location.reload(), 200);
		}
		else window.location.href = `/completeInvestment/${partner['_id']}?companyId=${company['_id']}&cName=${company['cName']}`;
	};

	const handleCompleteInvestmentReadiness = async () => {
		dispatch(toggleModal({ open: 'completeInvestmentReadiness' }));
		setIsGenerateAllResearchAid(true);
		let res = await postRequest('/company/generateAllReports', { companyId: company['_id'] });
		if (res['code'] == '200') dispatch(toggleModal({ open: 'generatedResearchAidReports' }));
		else dispatch(toggleModal({ open: 'notGeneratedResearchAidReports' }));
		setIsGenerateAllResearchAid(false);
		if (user && user['type'] == 'Superflow') {
			if (res) await postRequest('/user/updateUserType', { type: 'User' });
		}
	};

	const updateUserType = async () => {
		if (user && user['type'] == 'Superflow') {
			let res = await postRequest('/user/updateUserType', { type: 'User' });
			if (res['code'] == '200') window.location.href = `/company/${companyId}`;
		}
	};

	const handleRedirectResearchAid = async () => {
		await getCompany();
		await getUser();
		navigate(`/company/${company['_id']}`)
		setCompanyDashboardTab('ResearchAid');
		dispatch(toggleModal({ open: '' }));
	};

	return (
		<AnimatedPage>
			{isLoader['show'] && <Loader message={isLoader['message']} />}
			<div className="company-dashboard-view poppins-font-style * ">
				<TabContext value={dashboardTab}>
					{(user?.['type'] == 'Superflow' && (tab.includes('Readiness') || tab.includes('investor-lead'))) || (isManualAdd)
						? <SuperFlowHeader
							page='Company Dashboard' company={company}
							breadcrum={['Company View', '/Company Dashboard', `/${tab.includes('investor-lead') ? 'InvestorMatch' : 'Investment Readiness'}`]}
							heading={(user?.['role'] == 'Investor' && company?.['addedByInvestor'] == user?.['_id'] && tab == 'investor-lead')
								? <>Investor<span className='c4'>Match</span> <br /> Add Applicant</>
								: <><span className='c4'>One</span>Form {tab.includes('investor-lead') ? <>Investor<span className='c4'>Match</span></> : 'Investment Readiness'}</>}
						/>
						: <div className="dashboard-container pt2rem pb1rem df fdc ">
							<div className={`banner-advisor-dashboard pr w100 mt2rem mb1rem ${company?.['_id'] && user?.['_id'] && ' company-dashboard-bg'}
								${((user['role'] == 'Advisor' && user?.['companyId']?.['_id'] == company?.['_id']) || company?.['creatorId']?.['createdBy']?.['role'] == 'Advisor') ? 'advisor-bg-lite'
									: (((user['role'] == 'Investor' && user?.['companyId']?.['_id'] == company?.['_id']) || company?.['creatorId']?.['createdBy']?.['role'] == 'Investor') && company['cName'] !== "YOUR COMPANY HERE LIMITED") ? 'investor-bg' : 'client-bg'}`}>
								<div className={`company-tab bg1 new-shadow br20px py2rem px3rem my2rem pr`}>
									<div className={`dg gtcr2 jcsb aic top-admin-area mb2rem`}>
										<div className='left-area'>
											<ul className='c27 df aic lisn'>
												<li className="c27">{company?.['_id'] && user?.['_id'] && <>{((user['role'] == 'Advisor' || user['role'] == 'Investor') && user?.['companyId']?.['_id'] == company?.['_id']) ? 'Your Firm' : 'Company'}</>} View</li>
												<li className="c27">/</li>
												<li className="c27">{dashboardTab}</li>
												{dashboardTab == 'Company Dashboard' && <>
													<li className="c27">/</li>
													<li className='fw600 c27'>{companyDashboardTab}</li>
												</>}
											</ul>
										</div>
										<div className='right-area df jcfe'>
											<div className="ass df">
												{/* Owner */}
												<div className="df fs1rem aic">
													<div className='mr1rem tar df fdc'>
														{user?.['firstName'] && <span className="c15 ase">{user?.['firstName'] + " " + (user?.['lastName'] ? user?.['lastName'] : "")}</span>}
														{company?.['creatorId']?.['_id'] == user['_id'] && <span className={`c3 ase fs0-75rem`}>Company Admin</span>}
													</div>
													{user?.['firstName'] &&
														<span className={`w30px h30px df jcc aic br100 bg3 c1 bw3px bss bo30`}>
															{user?.['profile']
																? <img src={user?.['profile']} className={`w30px h30px df jcc aic br100 bw3px bss bo30`} data-tooltip={user?.['firstName'] + " " + (user?.['lastName'] ? user?.['lastName'] : "")} />
																: <span className={`w30px h30px df jcc aic br100`} data-tooltip={user?.['firstName'] + " " + (user?.['lastName'] ? user?.['lastName'] : "")}>{user?.['firstName'] ? (user?.['firstName']?.[0] + (user?.['lastName'] ? user?.['lastName']?.[0] : "")) : "?"}</span>
															}</span>
													}
												</div>
											</div>
										</div>
									</div>
									<div className='df fww aifs company-details-area'>
										<div className='left-company-area w33'>
											<h4 className="fs1-5rem fw500 c27">{company.cName || "Loading..."}</h4>
											<p className="ass fs1rem my0-5rem c15">Company Number: <span className="fw600">{company['ukRegNo']}</span></p>
											<p className="ass fs1rem my0-5rem c15">Company Objective: <span className="fw600 ttc">{company.testType}</span></p>
											<p className="ass fs1rem my0-5rem c15">Company Stage: <span className="fw600 ttc">{company?.['cStage']}</span></p>
											{company?.['creatorId'] && <p className="df aic ass fs1rem my0-5rem c15">Created By:
												<span className="fw600 ttc mx0-5rem">{company?.['creatorId']['firstName'] + " " + (company?.['creatorId']['lastName'] ? company?.['creatorId']['lastName'] : "")}</span>
												<span key={company?.['creatorId']['_id']} data-tooltip={company?.['creatorId']['firstName'] ? (company?.['creatorId']['firstName'] + " " + (company?.['creatorId']['lastName'] ? company?.['creatorId']['lastName'] : "")) : "Register to show your name here"} className={`${profileClass} w2rem h2rem df jcc aic br100 mr0-5rem bw2px bss ${user['_id'] == company?.['creatorId']['_id'] ? ' bo7' : ' bo16'}`}>
													{company?.['creatorId']?.['profile']
														? <img src={company?.['creatorId']?.['profile']} className={`w2rem h2rem df jcc aic br100 ${profileClass}`} data-tooltip={company?.['creatorId'].firstName ? (company?.['creatorId'].firstName + " " + (company?.['creatorId'].lastName ? company?.['creatorId'].lastName : "")) : "Register to show your name here"} />
														: company?.['creatorId']['firstName'] ? (company?.['creatorId']['firstName'][0] + (company?.['creatorId']['lastName'] ? company?.['creatorId']['lastName'][0] : "")) : "?"}
												</span>
											</p>}
											<p className="ass fs1rem my0-5rem c15">Subscription: <span className="fw600 c7">
												{((company?.['creatorId']?.['role'] == 'Advisor' || company?.['creatorId']?.['createdBy']?.['role'] == 'Advisor') || (company?.['creatorId']?.['role'] == 'Investor' || company?.['creatorId']?.['createdBy']?.['role'] == 'Investor')) && company['subscription'] == 'Pro'
													? 'Portfolio PRO'
													: <>{company['subscription']}</>
												}
											</span></p>
											<p className="ass fs1rem my0-5rem c15 df aic">Data Room: <span className="fw600 ml0-5rem"> &nbsp;
												{company.dropBoxLink ? <Dropbox />
													: company.gDriveLink ? <GoogleDrive />
														: company.sharePointLink ? <SharePoint />
															: company['subscription'] == 'Free' ? 'N/A' : 'Not Connected'}</span>
											</p>
										</div>
										<div className='center-logo-area w33 df jcc fww fdc mla mra pr'>
											<div className="company-name">
												{company?.['_id'] && user?.['_id']
													? <h2 className='c15 fs2rem tac w100 fw500 mb2rem'>
														{tab ? <>Core Workspace</> : <>{((user['role'] == 'Advisor' || user['role'] == 'Investor') && user?.['companyId']?.['_id'] == company?.['_id']) ? 'Your Firm' : (user['role'] == 'Advisor' && company?.['creatorId']?.['createdBy']) ? 'Client ' : 'Company '}</>} View
													</h2>
													: <div class='df jcc aic'><ThreeDots height="80" width="80" color="#8496f4" ariaLabel="three-dots-loading" /></div>
												}
											</div>
											<span className='bw0px bss br10px bsbb w9rem h9rem p1rem tac df aic jcc pr ' style={{ border: '1px solid #E3E3E3' }}>
												<img src={company["logo"] || require('../../../../images/yourlogohere.png')} className="w100 cp br10px" />
												{user['role'] != 'Guest' &&
													<div className="input-file">
														<span className="add-btn bg5" onClick={() => { dispatch(toggleModal({ open: "uploadProfile" })), setUploadImage("") }}>
															<svg viewBox="0 0 487 487" className="zi3">
																<g>
																	<path
																		d="M308.1,277.95c0,35.7-28.9,64.6-64.6,64.6s-64.6-28.9-64.6-64.6s28.9-64.6,64.6-64.6S308.1,242.25,308.1,277.95z
																M440.3,116.05c25.8,0,46.7,20.9,46.7,46.7v122.4v103.8c0,27.5-22.3,49.8-49.8,49.8H49.8c-27.5,0-49.8-22.3-49.8-49.8v-103.9
																v-122.3l0,0c0-25.8,20.9-46.7,46.7-46.7h93.4l4.4-18.6c6.7-28.8,32.4-49.2,62-49.2h74.1c29.6,0,55.3,20.4,62,49.2l4.3,18.6H440.3z
																M97.4,183.45c0-12.9-10.5-23.4-23.4-23.4c-13,0-23.5,10.5-23.5,23.4s10.5,23.4,23.4,23.4C86.9,206.95,97.4,196.45,97.4,183.45z
																M358.7,277.95c0-63.6-51.6-115.2-115.2-115.2s-115.2,51.6-115.2,115.2s51.6,115.2,115.2,115.2S358.7,341.55,358.7,277.95z"
																	/>
																</g>
															</svg>
														</span>
													</div>
												}
											</span>
										</div>
										<div className='right-certificate-area w33 df jce'>
											<div className="bg19 br10px p1rem w50">
												<div className="progress-bar-box bg1 br8px bss bw1px bo31 df aic p0-5rem jcc fww" style={{ border: '2px solid #768CFE' }}>
													<div className="progress-area w50 tac">
														<div className={`ttu progress-bar ${company?.['creatorId']?.['createdBy']?.['role'] == 'Investor' && 'investor-circle'}`} style={{ width: 70, height: 70 }}>
															<CircularProgressbar
																className={`${company?.['stats']?.['completionPercent'] > 67 ? 'green'
																	: company?.['stats']?.['completionPercent'] > 33 ? 'orange' : 'red'}`}
																value={company?.['stats']?.['completionPercent'] || 0}
																text={`${company?.['stats']?.['completionPercent'] || 0}%`}
																styles={buildStyles({
																	strokeLinecap: 'round',
																	strokeWidth: '5px',
																	textSize: '22px',
																	pathTransitionDuration: 0.5,
																	trailColor: '#d6d6d6',
																	backgroundColor: '#fc7785',
																})}
															/>
														</div>
														<p className="fs0-75rem c32 lh2">Overall <br /> Completeness</p>
													</div>
													<div className="progress-area w50 tac">
														<div className={`ttu progress-bar ${company?.['creatorId']?.['createdBy']?.['role'] == 'Investor' && 'investor-circle'}`} style={{ width: 70, height: 70 }}>
															<CircularProgressbar
																className={`${company?.['stats']?.['riskPercent'] > 67 ? 'red'
																	: company?.['stats']?.['riskPercent'] > 33 ? 'orange' : 'green'}`}
																value={company?.['stats']?.['riskPercent'] || 0}
																text={company?.['stats']?.['completionPercent'] ? `${company?.['stats']?.['riskPercent'] || 0}%` : "0%"}
																styles={buildStyles({
																	strokeLinecap: 'butt',
																	strokeWidth: '5px',
																	textSize: '22px',
																	pathTransitionDuration: 0.5,
																	trailColor: '#d6d6d6',
																	backgroundColor: '#fc7785',
																})}
															/>
														</div>
														<p className="fs0-75rem c32 lh2">Overall <br /> Risk</p>
													</div>
												</div>
												{company['subscription'] == 'Pro'
													? <>
														<div className="df p0-5rem w100 fww">
															<div className="df jcsb w90">
																<div className='df jcc'>
																	<span className="fs0-75rem c32 lh2 mt1rem">
																		{company['cLevel'] == 'None'
																			? <>Not<br />Certified</>
																			: <>{company['cLevel']}<br />Certification</>
																		}</span>
																	<span onClick={() => setCertificateSeeMore()} class='cp'><img style={{ width: '15px' }} src={require(`../../../../images/info-icon.svg`)} alt="info" /></span>
																</div>
																<Link to='#unaudited-certification' class='cp' onClick={() => setTab('unaudited-certification')}>
																	<div className="certficate-area" style={{ zoom: '0.6' }}>
																		{company['cLevel'] && <Certification className='mla mra dashbaord-certficate-page mt0-5rem' component='Company' level={company['cLevel']} expiryTimestamp={company['createdAt']} company={company} subscription={company['subscription']} />}
																	</div>
																</Link>
															</div>
															<div className="bottom-certification w100 my0-5rem df jcfs fww">
																<Link to='#unaudited-certification' class='cp' onClick={() => setTab('unaudited-certification')}>
																	<img className="w90" src={require(`../../../../images/advisor-dashboard/banner-certificate-bottom.png`)} alt="" />
																	<div className="progress-dashboard-horizantal w90" role="progressbar" id="progressBar">
																		<div className="progress-bar progress-bar-striped progress-bar-animated" id="innerBar" style={{ width: `${linearProgress}%` }}></div>
																	</div>
																</Link>
															</div>

														</div>
														<div className="progress-bar-box bg1 br8px bss bw1px bo31 p0-5rem jcc w100 bsbb">
															<div className="progress-box df jcsb">
																<div className="bottom-text tal mt0-5rem">
																	<p className="fs0-75rem c32">Overall Workflow <br />Completeness</p>
																</div>
																<div className={`progress-bar workflow-report-progress ${company?.stats?.workflowCompletionPercent > 75 ? 'workflow-progress-green' : company?.stats?.workflowCompletionPercent > 26 ? 'workflow-progress-yellow' : ' workflow-progress-pink'}`}
																	style={{ width: 56, height: 56, borderRadius: '50%', margin: 0, border: '2px solid #F1F1F1' }}>
																	<CircularProgressbar
																		text={(company?.stats?.workflowCompletionPercent || 0) + "%"}
																		styles={buildStyles({
																			strokeWidth: '0',
																			textSize: '20px',
																			trailColor: '#FBFBFB',
																			stroke: 'transparent',
																			strokeLinecap: 'butt',
																			backgroundColor: '#FBFBFB',
																			pathTransitionDuration: 0.5,
																			dominantBaseline: 'ideographic',
																		})}
																	/>
																</div>
															</div>
														</div>
													</>
													: <>
														<div className="certficate-area df jcc my1rem">
															<Certification className='dashbaord-certficate-page mt0-5rem pr df aic c6' component='Company' level='None' expiryTimestamp={company['createdAt']} company={company} subscription='Lite' />
														</div>
														<p className="tac c6 fs0-75rem">Upgrade to Pro for certification</p>
													</>}
											</div>
										</div>
									</div>
									{user?.['type'] !== 'External' && <>
										<div className="df fww aic mt2rem add-member-area">
											<div className='user-area bg19 br30px p0-5rem df aic w80'>
												<div className='user-advisor df aic'>
													<div className="ass df">
														{/* Members */}
														<div className="df aic mr1rem bg1 br35px adivsor-user-company">
															{company['members'] && [...company['members'], company?.['creatorId']].length > 0
																? <div className="df aic py0-5rem">
																	{[...new Map([...company['members'], company?.['creatorId']]
																		.filter(Boolean)
																		.map(member => [member['_id'], member])
																	).values()].sort((a, b) => {
																		if (company && company['creatorId'] && a._id === company['creatorId']['_id']) return -1;
																		if (company && company['creatorId'] && b._id === company['creatorId']['_id']) return 1;
																		return 0;
																	}).map(member => (<div key={`member-${member['_id']}`} className="df bg25 mx0-5rem br20px">
																		<span data-tooltip={member?.['firstName'] && member?.['firstName'] + " " + (member?.['lastName'] ? member?.['lastName'] : "")} className={`shadow w30px h30px bw3px bss bo19 df jcc aic br100 c1`}>
																			{member?.['profile']
																				? <img src={member?.['profile']} className={`w30px h30px df jcc aic br100 bg4 c1 ${profileClass}`} data-tooltip={member?.['firstName'] && member?.['firstName'] + " " + (member?.['lastName'] ? member?.['lastName'] : "")} />
																				: <span className='c15' data-tooltip={member?.['firstName'] && member?.['firstName'] + " " + (member?.['lastName'] ? member?.['lastName'] : "")}>{member['firstName'] ? (member['firstName'][0] + (member?.['lastName'] ? member?.['lastName']?.[0] : "")) : "?"}</span>}
																		</span>
																		{(company?.['memberPermissions'] && company?.['memberPermissions'][member?._id] && Object.keys(company['memberPermissions']).length > 0) && permissionTooltip(company?.['memberPermissions'][member?._id], company['owners'].includes(member?._id))}
																	</div>))}
																</div>
																: <div className="df">
																	<img data-tooltip={user['email'] == 'temp' ? "Register to add members" : "No Members"} className={`${user['email'] == 'temp' && 'da-cursor '} br100 w2rem h2rem`} src={require('../../../../images/profile-photo.png')} />
																</div>
															}
															<span className={`${user['email'] == 'temp' ? 'c15 ' : 'c4 '} ml0-5rem fs0-75rem`}>Members</span>
														</div>
														{/* Advisors */}
														<div className="df aic mr1rem bg1 br35px adivsor-user-company">
															{company['advisorData'] && company['advisorData'].length > 0
																? <div className="df aic py0-5rem">
																	{company['advisorData']?.map(advisor => (<div key={`advisor-${advisor['_id']}`} className="df bg25 mx0-5rem br20px">
																		<span data-tooltip={advisor?.['firstName'] && advisor?.['firstName'] + " " + (advisor?.['lastName'] ? advisor?.['lastName'] : "")} className={`shadow w30px h30px bw3px bss bo19 df jcc aic br100 c1`}>
																			{advisor?.['profile']
																				? <img src={advisor?.['profile']} className={`w30px h30px df jcc aic br100 bg4 c1 ${profileClass}`} data-tooltip={advisor?.['firstName'] && advisor?.['firstName'] + " " + (advisor?.['lastName'] ? advisor?.['lastName'] : "")} />
																				: <span className='c15' data-tooltip={advisor?.['firstName'] && advisor?.['firstName'] + " " + (advisor?.['lastName'] ? advisor?.['lastName'] : "")}>{advisor['firstName'] ? (advisor['firstName'][0] + (advisor?.['lastName'] ? advisor?.['lastName']?.[0] : "")) : "?"}</span>}
																		</span>
																		{(company?.['advisors'] && company?.['advisors']?.[advisor['_id']] && company['advisors'][advisor['_id']]['modules'] && Object.keys(company['advisors'][advisor['_id']]['modules']).length > 0) && permissionTooltip(company['advisors'][advisor['_id']]['modules'])}
																	</div>))}
																</div>
																: <div className="df">
																	<img data-tooltip={user['email'] == 'temp' ? "Register to add advisors" : "No Advisor"} className={`${user['email'] == 'temp' && 'da-cursor '} br100 w3rem h3rem`} src={require('../../../../images/profile-photo.png')} />
																</div>
															}
															<span className={`${user['email'] == 'temp' ? 'c12 ' : 'c4 '} ml0-5rem fs0-75rem`}>Advisors</span>
														</div>
														{/* Investors */}
														<div className="df aic mr1rem bg1 br35px adivsor-user-company">
															{company['investorData'] && company['investorData'].length > 0
																? <div className="df aic">
																	{company['investorData']?.map(investor => (
																		<div key={`investor-${investor['_id']}`} className="df bg25 br20px">
																			<span data-tooltip={investor['firstName'] ? (investor['firstName'] + " " + (investor?.['lastName'] ? investor?.['lastName'] : "")) : "Register to show your name here"} className={`w2rem h2rem df jcc aic br100 bg4 c1 mr0-5rem`}>
																				{investor?.['profile']
																					? <img src={investor?.['profile']} className="w2rem h2rem df jcc aic br100 bg4 c1" data-tooltip={investor.firstName ? (investor.firstName + " " + (investor?.lastName ? investor?.lastName : "")) : "Register to show your name here"} />
																					: <span>{investor['firstName'] ? (investor['firstName']?.[0] + (investor['lastName'] ? investor['lastName']?.[0] : "")) : "?"}</span>}
																			</span>
																			{(company['investors'] && company?.['investors']?.[investor['_id']] && Object.keys(company['investors'][investor['_id']]['modules']).length > 0) && permissionTooltip(company['investors'][investor['_id']]['modules'])}
																		</div>
																	))}
																</div>
																: <div className="df">
																	<img data-tooltip={user['email'] == 'temp' ? "Register to add investors" : "No Investor"} className={`${user['email'] == 'temp' && 'da-cursor '} br100 w3rem h3rem`} src={require('../../../../images/profile-photo.png')} />
																</div>
															}
															<span className={`${user['email'] == 'temp' ? 'c12 ' : 'c4 '} ml0-5rem fs0-75rem`}>Investors</span>
														</div>
														{/* Add Members */}
														{(user['role'] !== 'Advisor' && user['role'] !== 'Investor') &&
															<div className="df fdc mr2rem">
																<div className="df" style={{ marginTop: '7px' }}>
																	<div className="df bg1 br50px mr0-5rem pr1rem p0-5rem bsbb aic mr1rem cp add-btn-dashboard" onClick={() => { setEditUser({}); dispatch(toggleModal({ open: 'editUser' })); setUserAction('Search'); }}>
																		<span className='bg1 bsbb p0-5rem mr0-5rem br100 w40px h40px tac df jcc aic'>
																			<svg className='h30px w30px' width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
																				<g clip-path="url(#clip0_2656_879)">
																					<path d="M19 0C8.52298 0 0 8.52298 0 19C0 29.477 8.52298 38 19 38C29.477 38 38 29.477 38 19C38 8.52298 29.477 0 19 0Z" fill="#4A67FF" />
																					<path d="M27.3098 20.5825H20.5805V27.3118C20.5805 28.1859 19.8714 28.895 18.9973 28.895C18.1232 28.895 17.4141 28.1859 17.4141 27.3118V20.5825H10.6848C9.8107 20.5825 9.10156 19.8734 9.10156 18.9993C9.10156 18.1252 9.8107 17.416 10.6848 17.416H17.4141V10.6868C17.4141 9.81265 18.1232 9.10352 18.9973 9.10352C19.8714 9.10352 20.5805 9.81265 20.5805 10.6868V17.416H27.3098C28.1839 17.416 28.893 18.1252 28.893 18.9993C28.893 19.8734 28.1839 20.5825 27.3098 20.5825Z" fill="#FAFAFA" />
																				</g>
																				<defs>
																					<clipPath id="clip0_2656_879">
																						<rect width="38" height="38" fill="white" />
																					</clipPath>
																				</defs>
																			</svg>
																		</span>
																		<span className='c15'>Add to team</span>
																	</div>
																</div>
															</div>}
													</div>
												</div>
											</div>
										</div>
										<div className='tabs-navlist df aic jcc mt2rem pr' style={{ cursor: user['role'] == 'Guest' && 'not-allowed' }} >
											{(company?.['_id'] && user?.['_id']) &&
												<TabList onChange={(e, value) => setDashboardTab(value)}>
													<Tab disabled={user['role'] == 'Guest'} data-tooltip={user['role'] == 'Guest' ? 'Please register to access it' : ''} className="fs1rem fw600 c3" label={`${(user['role'] == 'Advisor' && company?.['creatorId']?.['createdBy']) ? 'Client ' : 'Company '} Dashboard`} value="Company Dashboard" />
													{(user?.['role'] != "Guest" && isShowTeamTab) && <Tab className="fs1rem fw600 c3" label={`${(user['role'] == 'Advisor' && company?.['creatorId']?.['createdBy']) ? 'Client ' : ''} Team`} value="Team" />}
													{((user['role'] == 'Advisor' || user['role'] == 'Investor') && company?.['creatorId']?.['createdBy']) && <Tab className="fs1rem fw600 c3" label={`${user['role']} Dashboard`} value="Portfolio Dashboard" />}
												</TabList>
											}
											<div className="pa r0 right-index-btn t0 mt0-5rem">
												{company['modules'] && <>
													{user?.['role'] == "Guest"
														? <Link data-tooltip='Company Index is disabled. You must register to access it.' className='new-shadow w100 bg16 df jcc aic px2rem py1rem pr zi1 bw0px bbw2px bo3 c2 br30px df aic jcc cna'>
															<i className="icon mr1rem">
																<svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
																	<path d="M6.79039 11.7808L2.97655 7.99985L6.79039 4.21887C7.09858 3.91299 7.06263 3.4485 6.70945 3.18134C6.35626 2.91443 5.82021 2.94581 5.51145 3.25144L1.20972 7.51624C0.930093 7.7932 0.930093 8.20671 1.20972 8.48368L5.5115 12.7485C5.67959 12.9147 5.91479 13 6.15137 13C6.34949 13 6.54841 12.9402 6.70945 12.8184C7.06268 12.5512 7.09887 12.0867 6.79039 11.7808Z" fill="white" stroke="white" stroke-width="0.5" />
																	<path d="M14.1607 7.27344H2.20665C1.79909 7.27344 1.46875 7.60374 1.46875 8.01133C1.46875 8.4189 1.79909 8.74923 2.20665 8.74923H14.1607C16.3038 8.74923 18.0472 10.4926 18.0472 12.6355C18.0472 14.7784 16.3038 16.5218 14.1607 16.5218H3.19053C2.78297 16.5218 2.45264 16.8521 2.45264 17.2597C2.45264 17.6673 2.78297 17.9976 3.19053 17.9976H14.1607C17.1172 17.9976 19.523 15.592 19.523 12.6355C19.523 9.67899 17.1175 7.27344 14.1607 7.27344Z" fill="white" stroke="white" stroke-width="0.5" />
																</svg>
															</i>
															Company Index
														</Link>
														: <>{companyIndex
															? <Link to={(user['role'] == 'Advisor' || user['role'] == 'Investor') ? `/${user['role'].toLowerCase()}-dashboard#index` : `/dashboard`}
																className="tac dashboard-btn c1 bg4 bg-gradient-hover br30px fs0-75rem fw500 mr0-5rem w110 td270 w200px p1rem ml2rem df aic jcc">
																<i className="icon mr1rem">
																	<svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
																		<path d="M6.79039 11.7808L2.97655 7.99985L6.79039 4.21887C7.09858 3.91299 7.06263 3.4485 6.70945 3.18134C6.35626 2.91443 5.82021 2.94581 5.51145 3.25144L1.20972 7.51624C0.930093 7.7932 0.930093 8.20671 1.20972 8.48368L5.5115 12.7485C5.67959 12.9147 5.91479 13 6.15137 13C6.34949 13 6.54841 12.9402 6.70945 12.8184C7.06268 12.5512 7.09887 12.0867 6.79039 11.7808Z" fill="white" stroke="white" stroke-width="0.5" />
																		<path d="M14.1607 7.27344H2.20665C1.79909 7.27344 1.46875 7.60374 1.46875 8.01133C1.46875 8.4189 1.79909 8.74923 2.20665 8.74923H14.1607C16.3038 8.74923 18.0472 10.4926 18.0472 12.6355C18.0472 14.7784 16.3038 16.5218 14.1607 16.5218H3.19053C2.78297 16.5218 2.45264 16.8521 2.45264 17.2597C2.45264 17.6673 2.78297 17.9976 3.19053 17.9976H14.1607C17.1172 17.9976 19.523 15.592 19.523 12.6355C19.523 9.67899 17.1175 7.27344 14.1607 7.27344Z" fill="white" stroke="white" stroke-width="0.5" />
																	</svg>
																</i>
																{user?.['role'] == 'Advisor' ? 'Client ' : user?.['role'] == 'Investor' ? 'Portfolio ' : 'Company '} Index
															</Link>
															: <>{isPortfolio
																? <Link to={`/investor-dashboard`} onClick={() => setTab("")} className={`${!company["subscription"] && "op20 pen"
																	} tac dashboard-btn c1 bg4 bg-gradient-hover br30px fs0-75rem fw500 mr0-5rem w110 td270 w200px p1rem ml2rem df aic jcc`}>
																	<i className="icon mr1rem">
																		<svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
																			<path d="M6.79039 11.7808L2.97655 7.99985L6.79039 4.21887C7.09858 3.91299 7.06263 3.4485 6.70945 3.18134C6.35626 2.91443 5.82021 2.94581 5.51145 3.25144L1.20972 7.51624C0.930093 7.7932 0.930093 8.20671 1.20972 8.48368L5.5115 12.7485C5.67959 12.9147 5.91479 13 6.15137 13C6.34949 13 6.54841 12.9402 6.70945 12.8184C7.06268 12.5512 7.09887 12.0867 6.79039 11.7808Z" fill="white" stroke="white" stroke-width="0.5" />
																			<path d="M14.1607 7.27344H2.20665C1.79909 7.27344 1.46875 7.60374 1.46875 8.01133C1.46875 8.4189 1.79909 8.74923 2.20665 8.74923H14.1607C16.3038 8.74923 18.0472 10.4926 18.0472 12.6355C18.0472 14.7784 16.3038 16.5218 14.1607 16.5218H3.19053C2.78297 16.5218 2.45264 16.8521 2.45264 17.2597C2.45264 17.6673 2.78297 17.9976 3.19053 17.9976H14.1607C17.1172 17.9976 19.523 15.592 19.523 12.6355C19.523 9.67899 17.1175 7.27344 14.1607 7.27344Z" fill="white" stroke="white" stroke-width="0.5" />
																		</svg>
																	</i>
																	Portfolio Index
																</Link>
																: <Link to={window.location.pathname} onClick={() => { localStorage.removeItem('isDiligenceReport'); setTabName("") }}
																	className="tac dashboard-btn c1 bg4 bg-gradient-hover br30px fs0-75rem fw500 mr0-5rem w110 td270 w200px p1rem ml2rem df aic jcc">
																	<i className="icon mr1rem">
																		<svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
																			<path d="M6.79039 11.7808L2.97655 7.99985L6.79039 4.21887C7.09858 3.91299 7.06263 3.4485 6.70945 3.18134C6.35626 2.91443 5.82021 2.94581 5.51145 3.25144L1.20972 7.51624C0.930093 7.7932 0.930093 8.20671 1.20972 8.48368L5.5115 12.7485C5.67959 12.9147 5.91479 13 6.15137 13C6.34949 13 6.54841 12.9402 6.70945 12.8184C7.06268 12.5512 7.09887 12.0867 6.79039 11.7808Z" fill="white" stroke="white" stroke-width="0.5" />
																			<path d="M14.1607 7.27344H2.20665C1.79909 7.27344 1.46875 7.60374 1.46875 8.01133C1.46875 8.4189 1.79909 8.74923 2.20665 8.74923H14.1607C16.3038 8.74923 18.0472 10.4926 18.0472 12.6355C18.0472 14.7784 16.3038 16.5218 14.1607 16.5218H3.19053C2.78297 16.5218 2.45264 16.8521 2.45264 17.2597C2.45264 17.6673 2.78297 17.9976 3.19053 17.9976H14.1607C17.1172 17.9976 19.523 15.592 19.523 12.6355C19.523 9.67899 17.1175 7.27344 14.1607 7.27344Z" fill="white" stroke="white" stroke-width="0.5" />
																		</svg>
																	</i>
																	Back To Dashboard
																</Link>
															}</>
														}</>
													}
												</>}
											</div>
										</div>
									</>}
								</div>
							</div>
						</div>
					}
					<div className={`dahboard-tabs`}>
						{/* Company Dashboard */}
						<TabPanel className="w100 company-dashboard" value="Company Dashboard">
							{(isClientIndex && user?.['type'] !== 'Superflow' && user?.['type'] !== 'External') && !isManualAdd &&
								<div className='tabs-navlist tabs-dashboard df aic jcc mt2rem'>
									{['Dashboard', 'Analyser', 'AnyLists', 'Workflows', 'ResearchAid', 'InvestorMatch', 'AppStore'].map((item, idx) => {
										if ((user['role'] == 'Advisor' || user['role'] == 'Investor') && item == 'InvestorMatch') return;
										return <div key={`dashboard-tab-${idx}`} className="df fdc">
											<button disabled={user['role'] == 'Guest'} className={`fs1-25rem fw500 c15 ${companyDashboardTab == item && ' active'}`}
												onClick={() => {
													if (item === 'InvestorMatch' && companyDashboardTab !== item) dispatch(toggleModal({ open: 'investorMatchDisclaimer' }))
													else setCompanyDashboardTab(item)
												}} style={{ cursor: user['role'] == 'Guest' ? 'not-allowed' : 'pointer' }}>
												{item}
											</button>
										</div>
									})}
								</div>}
							{((user?.['role'] == 'Advisor' || user?.['role'] == 'Investor') && permissionLevel && company?.['clientLoginActivated'] === false) &&
								<div class='w100 mt1rem'>
									<button
										onClick={() => handleActivateClientLogin(company['_id'])}
										disabled={activatingClient === company['_id']}
										data-tooltip="Click to send activation email to client"
										className={`cp c1 bg3 bg4-hover tac br20px fs0-75rem px3rem py0-5rem fw500 td250 mb0-5rem ${activatingClient === company['_id'] ? 'op50' : ''}`}
										style={{ border: "none" }}>
										{activatingClient === company['_id'] ? 'Activating...' : 'Activate Client Login'}
									</button>
								</div>
							}

							{
								(company['subscription'] !== 'Pro' && tab === "" && companyDashboardTab == 'Dashboard') && <UpgradeCards user={user} company={company} />
							}

							{companyDashboardTab == 'Dashboard' && <>
								{(tab.endsWith("-report") && user?.role.toLowerCase() === "guest" && user?.['type'] !== 'External')
									? <HeadingSubheadingContent wrapperClass="tac" heading={""} subheading={""}
										paragraph={<>Register at the end of test to access more features <span className="fs11px">(No credit card required)</span><br></br><LockOutlined className="c3" /></>}
									/> : null}
								{/* Selected Tabs */}
								{(company['modules'] && user?.['type'] !== 'External') &&
									<div className="df top-tabs-report">
										<div className={`df aic oxa w100`}>
											{Array.from(openTabs).map((openTab, idx) => {
												return (
													<Link to={`#${openTab}`} key={`tab-${openTab}-${idx}`} onClick={() => setTab(openTab)} className={(tab === openTab ? "bg1" : "bo6") + " shadow p1rem mt1rem wsn usn td250 c15 tab cp df fw600 ttu fs1rem jcc aic pr zi1 tal"}>
														{company.modules[openTab]?.heading == undefined
															? openTab.includes("directors-questionnaire")
																? "Directors Questionnaire Report"
																: openTab.includes("fit-report")
																	? 'Fit Report'
																	: openTab.endsWith("-analyser")
																		? (() => {
																			// Extract the tab identifier (before -analyser)
																			const tabId = openTab.replace(/-analyser$/, '');
																			// Find the matching report in aiReports
																			const report = company?.['aiReports']?.find(r => {
																				if (r._id && r._id.toString() === tabId) return true;
																				// Also check by sanitized reportLabel
																				if (r.reportLabel) {
																					const sanitized = r.reportLabel.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '').replace(/-+/g, '-').replace(/^-|-$/g, '');
																					return sanitized === tabId;
																				}
																				return false;
																			});
																			return report?.reportLabel || report?.name || <>{(openTab.replace(/-analyser$/, '').replaceAll("-", " ")).replaceAll("%20", " ")} Analyser</>;
																		})()
																		: (openTab.includes("-researchaid") && openTab.includes('?'))
																			? openTab.split('?')[1]
																			: <>{(openTab.replaceAll("-", " ")).replaceAll("%20", " ")}</>
															: <>{openTab.includes("directors-questionnaire")
																? company.modules[openTab]?.heading.split(",")[0]
																: openTab.includes("investor-lead")
																	? <span className="c15">Investor<span className="c4">Match</span></span>
																	: company.modules[openTab]?.heading || company.modules[openTab.replace(/-report/, "")]?.heading + " Report"
															}</>
														}
														{(!isPortfolio && isClientIndex && user?.['type'] !== 'Superflow' && !isManualAdd) &&
															<Link className="ml0-5rem pr" to={linksToCloseTab()} onClick={e => closeTab(e, openTab)} style={{ top: '4px' }}>
																<svg width="23" height="24" viewBox="0 0 23 24" fill="none" xmlns="http://www.w3.org/2000/svg">
																	<rect opacity="0.8" x="1.53125" y="2.03516" width="19.9333" height="19.9333" rx="9.96667" fill="white" />
																	<path d="M18.6149 4.88438C17.2076 3.47722 15.4146 2.51896 13.4627 2.13078C11.5108 1.7426 9.48763 1.94193 7.64901 2.70357C5.81039 3.4652 4.2389 4.75494 3.13327 6.40969C2.02763 8.06443 1.4375 10.0099 1.4375 12C1.4375 13.9901 2.02763 15.9356 3.13327 17.5903C4.2389 19.2451 5.81039 20.5348 7.64901 21.2964C9.48763 22.0581 11.5108 22.2574 13.4627 21.8692C15.4146 21.4811 17.2076 20.5228 18.6149 19.1156C19.5494 18.1812 20.2907 17.0719 20.7964 15.851C21.3022 14.6301 21.5625 13.3215 21.5625 12C21.5625 10.6785 21.3022 9.36992 20.7964 8.14902C20.2907 6.92811 19.5494 5.81878 18.6149 4.88438ZM15.093 14.5444C15.1648 14.6116 15.2221 14.6929 15.2612 14.7831C15.3004 14.8734 15.3205 14.9707 15.3205 15.0691C15.3205 15.1674 15.3004 15.2648 15.2612 15.355C15.2221 15.4453 15.1648 15.5265 15.093 15.5938C15.0259 15.6604 14.9462 15.7131 14.8586 15.7488C14.7711 15.7846 14.6773 15.8027 14.5827 15.8022C14.3942 15.8014 14.2135 15.7265 14.0796 15.5938L11.4993 13.0134L8.9549 15.5938C8.82102 15.7265 8.64033 15.8014 8.45177 15.8022C8.35718 15.8027 8.26341 15.7846 8.17584 15.7488C8.08827 15.7131 8.00862 15.6604 7.94146 15.5938C7.80759 15.4591 7.73245 15.2769 7.73245 15.087C7.73245 14.8972 7.80759 14.715 7.94146 14.5803L10.4858 12L7.94146 9.45563C7.82371 9.31813 7.76218 9.14126 7.76917 8.96037C7.77616 8.77948 7.85115 8.60789 7.97915 8.47988C8.10716 8.35188 8.27875 8.27689 8.45964 8.2699C8.64053 8.26291 8.8174 8.32444 8.9549 8.44219L11.4993 10.9866L14.0436 8.44219C14.1102 8.37329 14.1897 8.31817 14.2775 8.27997C14.3653 8.24178 14.4599 8.22127 14.5556 8.2196C14.6514 8.21793 14.7466 8.23514 14.8357 8.27025C14.9248 8.30536 15.0062 8.35768 15.0751 8.42422C15.144 8.49077 15.1991 8.57023 15.2373 8.65808C15.2755 8.74592 15.296 8.84043 15.2977 8.9362C15.2993 9.03198 15.2821 9.12715 15.247 9.21627C15.2119 9.30539 15.1596 9.38673 15.093 9.45563L12.5127 12L15.093 14.5444Z" fill="#FC7785" />
																</svg>
															</Link>}
													</Link>
												)
											})}
										</div>
										{(tab && tab.includes('directors-questionnaire') && !isBackFitReport) &&
											<Link onClick={async () => handleBackDirectors()} className='tac dashboard-btn c1 bg4 bg-gradient-hover br30px fs0-75rem fw500 td270 w200px mb0-5rem p1rem df aic jcc'>
												<i className="icon mr1rem">
													<svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
														<path d="M6.79039 11.7808L2.97655 7.99985L6.79039 4.21887C7.09858 3.91299 7.06263 3.4485 6.70945 3.18134C6.35626 2.91443 5.82021 2.94581 5.51145 3.25144L1.20972 7.51624C0.930093 7.7932 0.930093 8.20671 1.20972 8.48368L5.5115 12.7485C5.67959 12.9147 5.91479 13 6.15137 13C6.34949 13 6.54841 12.9402 6.70945 12.8184C7.06268 12.5512 7.09887 12.0867 6.79039 11.7808Z" fill="white" stroke="white" stroke-width="0.5" />
														<path d="M14.1607 7.27344H2.20665C1.79909 7.27344 1.46875 7.60374 1.46875 8.01133C1.46875 8.4189 1.79909 8.74923 2.20665 8.74923H14.1607C16.3038 8.74923 18.0472 10.4926 18.0472 12.6355C18.0472 14.7784 16.3038 16.5218 14.1607 16.5218H3.19053C2.78297 16.5218 2.45264 16.8521 2.45264 17.2597C2.45264 17.6673 2.78297 17.9976 3.19053 17.9976H14.1607C17.1172 17.9976 19.523 15.592 19.523 12.6355C19.523 9.67899 17.1175 7.27344 14.1607 7.27344Z" fill="white" stroke="white" stroke-width="0.5" />
													</svg>
												</i>Back To Directors</Link>
										}
									</div>
								}
								{company['modules'] && ((tab && tab !== "") &&
									<div className="pr report-page">
										{tab.endsWith("-section-report") || tab.endsWith("-analysis-report")
											? <div className="td250 container bg1 py2rem w100 df">
												<div className="w80 mr1rem dg bg5 py2rem">
													<InsuranceGapAnalysisReport company={company} tab={tab} />
												</div>
												<SiderbarResearchAid title={tab.endsWith("-section-report") ? "Section Report" : "Insurance Gap Analysis Report"} company={company} tab={tab} setTab={setTab} setOpenTabs={setOpenTabs} setTabName={setTabName} isBackFitReport={isBackFitReport} setIsBackFitReport={setIsBackFitReport} setCompanyDashboardTab={setCompanyDashboardTab} onCloseReport={handleCloseReportToRepository} />
											</div>
											: tab.endsWith("-report")
												? <div className="td250 container bg1 py2rem w100 df">
													<div className="w80 mr1rem dg bg5 py2rem">
														{isWorkflowReport
															? <WorkflowReport sectionRefs={sectionRefs} getCompany={getCompany} setCompany={setCompany} calculateStats={calculateStats} profileClass={profileClass} user={user} company={company} aiEnhanced={aiEnhanced}
																setAiEnchaned={setAiEnchaned} moduleCertification={company?.moduleCertification[tab.includes('business-audit') ? 'business-audit-' + company.testType : sanitiseTab(tab)]} module={company.modules[sanitiseTab(tab)]}
																tab={tab} setTab={setTab} twoMinuteTestAIReport={twoMinuteTestAIReport} sortSections={sortSections} isLoader={isLoader} setIsLoader={setIsLoader} />
															: <Report sectionRefs={sectionRefs} getCompany={getCompany} setCompany={setCompany} profileClass={profileClass} user={user} company={company} aiEnhanced={aiEnhanced}
																setAiEnchaned={setAiEnchaned} moduleCertification={company?.moduleCertification[tab.includes('business-audit') ? 'business-audit-' + company.testType : sanitiseTab(tab)]} module={company.modules[sanitiseTab(tab)]} tab={tab}
																setTab={setTabName} twoMinuteTestAIReport={twoMinuteTestAIReport} sortSections={sortSections} openTabs={openTabs} setOpenTabs={setOpenTabs} />
														}
													</div>
													<SidebarIndex getCompany={getCompany} getUser={getUser} isWorkflowReport={isWorkflowReport} setIsWorkflowReport={setIsWorkflowReport} isViewTwoMinuteReport={isViewTwoMinuteReport} visibleSection={visibleSection} profileClass={profileClass} advisors={user['role'] == 'Advisor' ? advisors : investors}
														permissionLevel={permissionLevel} company={company} setCompany={setCompany} tab={tab} sanitiseTab={sanitiseTab} toggleReport={toggleReport} openKPI={openKPI} enableAIEnhancedReporting={enableAIEnhancedReporting} calculateStats={calculateStats} calculateSubFolderStats={calculateSubFolderStats}
														getCompletenessAndRiskHTML={getCompletenessAndRiskHTML} twoMinuteTestAIReport={twoMinuteTestAIReport} getFitInvestorFirms={getFitInvestorFirms} setTab={setTab} setTabName={setTabName} setOpenTabs={setOpenTabs} openTabs={openTabs} sortSections={sortSections} handlePartnerChecklistNext={handlePartnerChecklistNext}
														setCompanyDashboardTab={setCompanyDashboardTab} closeTab={closeTab} isBackFitReport={isBackFitReport} setIsBackFitReport={setIsBackFitReport} isLoader={isLoader} setIsLoader={setIsLoader} isExternalPage={false} />
												</div>
												: tab.includes('insuranceGapAnalysis-researchaid')
													? <div className="td250 container bg1 py2rem w100 df">
														<div className="w80 mr1rem dg bg5 py2rem">
															<InsuranceGapAnalysisReport company={company} tab={tab} setTab={setTab} setCompanyDashboardTab={setCompanyDashboardTab} />
														</div>
														<SiderbarResearchAid company={company} tab={tab} setTab={setTab} setOpenTabs={setOpenTabs} setTabName={setTabName} isBackFitReport={isBackFitReport} setIsBackFitReport={setIsBackFitReport} setCompanyDashboardTab={setCompanyDashboardTab} onCloseReport={handleCloseReportToRepository} />
													</div>
													: tab.endsWith("-researchaid")
														? <div className="td250 container bg1 py2rem w100 df">
															<div className="w80 mr1rem dg bg5 py2rem">
																<ResearchAidReport company={company} tab={tab} setTab={setTab} setCompanyDashboardTab={setCompanyDashboardTab} />
															</div>
															<SiderbarResearchAid company={company} tab={tab} setTab={setTab} setOpenTabs={setOpenTabs} setTabName={setTabName} isBackFitReport={isBackFitReport} setIsBackFitReport={setIsBackFitReport} setCompanyDashboardTab={setCompanyDashboardTab} onCloseReport={handleCloseReportToRepository} />
														</div>
														: tab.endsWith("-analyser")
															? <div className="td250 container bg1 py2rem w100 df">
																<div className="w80 mr1rem dg bg5 py2rem">
																	<InsuranceGapAnalysisReport company={company} tab={tab} setTab={setTab} setCompanyDashboardTab={setCompanyDashboardTab} />
																</div>
																<SiderbarResearchAid title="AI Analyser Report" company={company} tab={tab} setTab={setTab} setOpenTabs={setOpenTabs} setTabName={setTabName} isBackFitReport={isBackFitReport} setIsBackFitReport={setIsBackFitReport} setCompanyDashboardTab={setCompanyDashboardTab} onCloseReport={handleCloseReportToRepository} />
															</div>
															: tab.includes('fit-report') ? <FitReport user={user} company={company} setIsBackFitReport={setIsBackFitReport} moduleCertification={company?.moduleCertification['investor-lead']} module={company.modules['investor-lead']} tab={tab} setTab={setTab} fitInvestorFirms={fitInvestorFirms} getFitInvestorFirms={getFitInvestorFirms} linearProgress={linearProgress} />
																: tab === 'unaudited-certification' ? <Certificates profileClass={profileClass} user={user} company={company} setTab={setTab} />
																	: tab === 'diligence-pack' ? <DiligencePack company={company} setCompanyDashboardTab={setCompanyDashboardTab} setTab={setTab} isExternal={false} />
																		: tab === 'share-diligence-pack' ? <ShareDiligencePack company={company} setCompany={setCompany} getCompany={getCompany} setTab={setTab} setTabName={setTabName} />
																			: tab === 'company-settings' ? <CompanySettings profileClass={profileClass} company={company} setCompany={setCompany} setTab={setTab} getCompany={getCompany} handleMemberEdit={handleMemberEdit} />
																				: tab === 'checklist-tasks' ? <ChecklistReport profileClass={profileClass} checklistTask={checklistTask} user={user} company={company} setTab={setTab} getChecklistTask={getChecklistTask} />
																					: tab === 'diligence-pack-reporting' ? <>
																						{company != {} && selectedModules != {} && <AllReports profileClass={profileClass} user={user} company={company} aiEnhanced={aiEnhanced} setAiEnchaned={setAiEnchaned}
																							modules={selectedModules} tab={tab} setTab={setTabName} />}
																					</>
																						: tab === 'company-audit-log' ? <CompanyAudit profileClass={profileClass} auditReportLogs={auditReportLogs} user={user} company={company} />
																							: tab === 'benchmark-reporting' ? <BenchmarkReport profileClass={profileClass} user={user} company={company} tab={tab} setTab={setTab} />
																								: tab === 'investorMatch'
																									? <InvestorLeadList
																										tab={tab}
																										user={user}
																										setTab={setTab}
																										company={company}
																										isLeadPdf={isLeadPdf}
																										downloadPDF={downloadPDF}
																										fitInvestorFirms={fitInvestorFirms}
																										setIsBackFitReport={setIsBackFitReport}
																										getFitInvestorFirms={getFitInvestorFirms}
																										handleInvestorEmail={handleInvestorEmail}
																										handleContactInvestor={handleContactInvestor}
																										investorFirmCounts={investorFirmCounts}
																										setInvestorFirmCounts={setInvestorFirmCounts}
																									/>
																									: ([`two-minute-test-${company['testType']}`, 'repository', `business-audit-${company['testType']}`, 'warranty-disclosure', 'investor-lead', 'software-development', 'esg'].includes(tab) || tab.includes('directors-questionnaire'))
																										? <QuesAns isManualAdd={isManualAdd} setTabName={setTabName}
																											getCompany={getCompany}
																											setIsWorkflowReport={setIsWorkflowReport} profileClass={profileClass} advisors={user['role'] == 'Advisor' ? advisors : investors} permissionLevel={permissionLevel} tab={tab} setTab={setTab} sanitiseTab={sanitiseTab} company={{ ...selectedCompany }} setCompany={setCompany} companyId={companyId}
																											openKPI={openKPI} toggleReport={toggleReport} showAlert={showAlert} enableAIEnhancedReporting={enableAIEnhancedReporting} calculateStats={calculateStats} calculateSubFolderStats={calculateSubFolderStats} getCompletenessAndRiskHTML={getCompletenessAndRiskHTML} aiEnhanced={aiEnhanced} setAiEnchaned={setAiEnchaned} setOpenTabs={setOpenTabs} openTabs={openTabs}
																											reloadModule={reloadModule} twoMinuteTestAIReport={twoMinuteTestAIReport} getFitInvestorFirms={getFitInvestorFirms} isTwoMinuteTesHomePage={isTwoMinuteTesHomePage} cloneImportResult={cloneImportResult} setCloneImportResult={setCloneImportResult} fileReport={{ ...fileReport }} setFileReport={setFileReport} currentScore={currentScore} setCurrentScore={setCurrentScore} reportHistories={reportHistories}
																											setReportHistories={setReportHistories} sortSections={sortSections} companyIndex={companyIndex} handleSuperflowNext={handleSuperflowNext} setCompanyDashboardTab={setCompanyDashboardTab} closeTab={closeTab} isBackFitReport={isBackFitReport} setIsBackFitReport={setIsBackFitReport} isLoader={isLoader} setIsLoader={setIsLoader} />
																										: <DDQuesAns closeTab={closeTab} setTabName={setTabName} setCompanyDashboardTab={setCompanyDashboardTab} setIsWorkflowReport={setIsWorkflowReport} profileClass={profileClass} advisors={user['role'] == 'Advisor' ? advisors : investors} permissionLevel={permissionLevel} tab={tab} setTab={setTab} sanitiseTab={sanitiseTab} getUser={getUser} company={company} setCompany={setCompany} companyId={companyId}
																											openKPI={openKPI} toggleReport={toggleReport} enableAIEnhancedReporting={enableAIEnhancedReporting} fileReport={{ ...fileReport }} setFileReport={setFileReport} reportHistories={reportHistories} setReportHistories={setReportHistories} calculateStats={calculateStats} calculateSubFolderStats={calculateSubFolderStats} getCompletenessAndRiskHTML={getCompletenessAndRiskHTML} aiEnhanced={aiEnhanced}
																											setAiEnchaned={setAiEnchaned} reloadModule={reloadModule} twoMinuteTestAIReport={twoMinuteTestAIReport} getFitInvestorFirms={getFitInvestorFirms} isTwoMinuteTesHomePage={isTwoMinuteTesHomePage} sortSections={sortSections} handleCompleteInvestmentReadiness={handleCompleteInvestmentReadiness} updateUserType={updateUserType} handlePartnerChecklistNext={handlePartnerChecklistNext} isBackFitReport={isBackFitReport} setIsBackFitReport={setIsBackFitReport} isLoader={isLoader} setIsLoader={setIsLoader} />
										}
										{localStorage.getItem('isDemoChecklist') &&
											<div class='pf w90 h10vh df jcsb bg12 b0'>
												<p class='w60 pl3rem fs1rem c1 fw300'>
													{tab.endsWith("-report")
														? isWorkflowReport ? 'Automated Checklist Workflow' : 'Automated Checklist Report'
														: 'Module Checklist'
													}
												</p>
												<div class='w40 df jcc aic pa r0 b0'>
													<button onClick={(e) => handleDemoNext(e)} className='cp shadow c1 fw400 fs0-75rem pr br38px w200px h3rem mt6rem df aic jcc bg4'>
														{(tab.endsWith("-report") || !isPrePopulate)
															? 'Ok, next'
															: 'Pre-Populate'
														}
														<i className='icon pr ml0-5rem' style={{ top: '3px' }}>
															<svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
																<path d="M6.42954 17.0154H21.1966L16.7035 22.1842C15.413 23.6688 17.3488 25.8957 18.6394 24.4111L22.7314 19.6964L25.463 16.5491C25.9924 15.9365 25.9924 14.9471 25.463 14.3344L18.6394 6.47557C18.3798 6.16869 18.0225 5.99649 17.6502 6.00005C16.4212 6.00023 15.818 7.72225 16.7035 8.70263L21.2073 13.8714H6.35888C4.46611 13.9794 4.60744 17.1238 6.42954 17.0154Z" fill="white" />
															</svg>
														</i>
													</button>
													{tab.endsWith("-report")
														? isWorkflowReport
															? <img className="w60" src={require("../../../../images/demo-checklist/demo-checklist-sidebar-three.png")} alt="demo-checklist-sidebar" />
															: <img className="w60" src={require("../../../../images/demo-checklist/demo-checklist-sidebar-two.png")} alt="demo-checklist-sidebar" />
														: isPrePopulate
															? <img className="w60" src={require("../../../../images/demo-checklist/demo-checklist-sidebar-one.png")} alt="demo-checklist-sidebar" />
															: <img className="w60" src={require("../../../../images/demo-checklist/demo-checklist-pre-populate.png")} alt="demo-checklist-sidebar" />
													}
												</div>
											</div>}
										{localStorage.getItem('isPartnerChecklist') && <div class='df jcc w100 my2rem'>
											<button onClick={() => handlePartnerChecklistNext()} className={`shadow c1 fw400 fs0-75rem pr br38px w200px h3rem df aic jcc ${company.modules[sanitiseTab(tab)] && company.modules[sanitiseTab(tab)]?.['stats']['completionPercent'] > 0 ? 'bg4 cp' : 'bg16 cna'} `}>
												Next
											</button>
										</div>}
										{(user?.['type'] == 'Superflow' && tab == 'investor-lead') &&
											<div class='df jcc w100 my2rem'>
												<button onClick={() => handleSuperflowNext()} data-tooltip={company?.modules?.['investor-lead'] && company?.modules?.['investor-lead']?.['stats']?.['completionPercent'] != 100 ? 'Please complete the module 100%' : ''}
													className={`shadow c1 fw400 fs0-75rem pr br38px w200px h3rem df aic jcc ${company?.modules?.['investor-lead'] && company?.modules?.['investor-lead']?.['stats']?.['completionPercent'] == 100 ? 'bg4 cp' : 'bg16 cna'} `}>
													Next
												</button>
											</div>}
										{(user?.['type'] == 'Superflow' && tab == 'Investment Readiness') &&
											<div class='df jcc w100 my2rem'>
												<button onClick={() => handleCompleteInvestmentReadiness()} className={`shadow c1 fw400 fs1rem pr br38px px5rem py0-5rem df aic jcc mr1rem ${company?.modules?.[tab] && company?.modules?.[tab]?.['stats']['completionPercent'] > 0 ? 'bg4 cp' : 'bg16 cna'} `}>
													Next
												</button>
												{/* <button onClick={() => updateUserType()} className={`shadow c1 fw400 fs1rem pr br38px px5rem py0-5rem df aic jcc ml1rem ${company?.modules?.[tab] && company?.modules?.[tab]?.['stats']['completionPercent'] > 0 ? 'bg4 cp' : 'bg16 cna'} `}>
													Next
												</button> */}
											</div>
										}
									</div> || <Dashboard linearProgress={linearProgress} isWorkflowReport={isWorkflowReport} setIsWorkflowReport={setIsWorkflowReport} profileClass={profileClass} getFitInvestorFirms={getFitInvestorFirms} permissionLevel={permissionLevel} setCertificateSeeMore={setCertificateSeeMore}
										user={user} company={company} setTab={setTab} setIsViewTwoMinuteReport={setIsViewTwoMinuteReport} selectedSeeMore={selectedSeeMore} setSelectedSeeMore={setSelectedSeeMore} setCompanyDashboardTab={setCompanyDashboardTab} />
								)}
							</>}
							{companyDashboardTab == 'Analyser' && <>
								<Analyser company={company} setTab={setTab} setIsWorkflowReport={setIsWorkflowReport} setCompanyDashboardTab={setCompanyDashboardTab} permissionLevel={permissionLevel} />
							</>}
							{companyDashboardTab == 'AnyLists' && <>
								<AnyListChecklists company={company} setTab={setTab} setIsWorkflowReport={setIsWorkflowReport} setCompanyDashboardTab={setCompanyDashboardTab} permissionLevel={permissionLevel} />
							</>}
							{companyDashboardTab == 'Workflows' && <>
								<Workflows company={company} setTab={setTab} setIsWorkflowReport={setIsWorkflowReport} setCompanyDashboardTab={setCompanyDashboardTab} permissionLevel={permissionLevel} />
							</>}
							{companyDashboardTab == 'ResearchAid' && <>
								<ResearchAid company={company} getCompany={getCompany} setTab={setTab} setCompanyDashboardTab={setCompanyDashboardTab} permissionLevel={permissionLevel} isGenerateAllResearchAid={isGenerateAllResearchAid} />
							</>}

							{companyDashboardTab == 'InvestorMatch' && <>
								<InvestorLeadList
									tab={tab}
									user={user}
									setTab={setTab}
									company={company}
									isLeadPdf={isLeadPdf}
									downloadPDF={downloadPDF}
									linearProgress={linearProgress}
									fitInvestorFirms={fitInvestorFirms}
									setIsBackFitReport={setIsBackFitReport}
									handleInvestorEmail={handleInvestorEmail}
									getFitInvestorFirms={getFitInvestorFirms}
									handleContactInvestor={handleContactInvestor}
									investorFirmCounts={investorFirmCounts}
									setInvestorFirmCounts={setInvestorFirmCounts}
								/>
							</>}

							{companyDashboardTab == 'AppStore' && <>
								<AppStore company={company} setTab={setTab} setCompanyDashboardTab={setCompanyDashboardTab} permissionLevel={permissionLevel} user={user} />
							</>}
						</TabPanel>
						{/* Team */}
						<TabPanel className="w100 company-dashboard" value="Team">
							<Team company={company} teamMembers={company?.['members']} setEditUser={setEditUser} setUserAction={setUserAction} resendInviteMember={resendInviteMember} handleDeleteMember={handleDeleteMember} />
						</TabPanel>
						<TabPanel className="w100 company-dashboard" value="Portfolio Dashboard">
							<PortfolioDashboard permissionLevel={permissionLevel} company={company} companyId={companyId} setTab={setTab} setDashboardTab={setDashboardTab} setCompanyDashboardTab={setCompanyDashboardTab} setIsWorkflowReport={setIsWorkflowReport} />
						</TabPanel>
					</div>
				</TabContext>
			</div>

			{/* Investor Match Disclaimer */}
			<InvestorMatchDisclaimer handleClose={() => { dispatch(toggleModal({ open: '' })); setCompanyDashboardTab('InvestorMatch') }} />

			{/* Generated ResearchAid Reports Popup */}
			<Modal id="generatedResearchAidReports" open={modal['open'] == 'generatedResearchAidReports'} onClose={() => dispatch(toggleModal({ open: '' }))} className="backdrop td500 zi4 pf t0 l0 w100vw  df jcc aic advisor-dashboard-seemore">
				<div className="poppins-font-style mah100 bg1 shadow w100 py2rem px4rem df fdc m1rem pr br10px pr" style={{ outline: 'none', paddingBottom: '2rem', maxWidth: '750px' }}>
					<div className='top-logo pa t0 r0 mr1rem mt1rem'><img className='w4rem' src={require('../../../../images/favicon.png')} alt="" /></div>
					<div className='creaing-modal pr my1rem'>
						<h2 className='fs1-25rem fw600 c15 my2rem mb2rem tac'>ResearchAid Reports Generated</h2>
						<div className='df jcc'><img className="w10rem" src={require('../../../../images/firework.gif')} alt="" /></div>
						<div className='text-box w90 df jcc tac fdc mxa'>
							<p className='fs1rem fw400 c15 mt3rem mb1rem'>
								Reports from ResearchAid are generated!
								<br />
								Let’s go to your ResearchAid tab
							</p>
							<div className='tac w100 db'>
								<button onClick={() => handleRedirectResearchAid()} className='cp w200px py0-5rem c1 bg4 bg3-hover br35px my1rem fw400 fs1rem zi0 td250'>Next</button>
							</div>
						</div>
					</div>
				</div>
			</Modal>

			{/* Apply For Investor Match */}
			<Modal id="applyInvestorMatchPopup" open={modal['open'] == 'applyInvestorMatchPopup'} onClose={() => dispatch(toggleModal({ open: '' }))} className="backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic" >
				<div className='df jcc oscy' style={{ maxHeight: '100vh' }}>
					<div className='mah90 oya bg1 shadow w800px p3rem bsbb df fdc aic m1rem br20px pr'>
						<button className="close-popup" onClick={() => dispatch(toggleModal({ open: '' }))}>
							<svg style={{ position: 'relative', top: '4px' }} className="pen fds h1rem f1 mr0-5rem" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
								<path className="pen fa-primary" d="M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z" />
							</svg>
						</button>
						{partner?.['name'] == 'Climb25 Super Flow'
							? <img className='df my1rem' src={require('../../../../images/super-flow/apply-climb25-popup.png')} alt='' />
							: <img className='df my1rem' src={require('../../../../images/super-flow/apply-ehe-popup.png')} alt='' />
						}
						{partner?.['name'] == 'Climb25 Super Flow'
							? <p class='c15 fs1-25rem fw400 tac mb1rem'>Thank you for applying to Investor<span class='c4'>Match</span></p>
							: <p class='c15 fs1-25rem fw400 tac mb1rem'>Thank you for applying for investment from us.</p>
						}
						{partner?.['name'] == 'Climb25 Super Flow'
							? <p class='c14 fs0-75rem fw300 tac mb1rem'>We will notify you of your investor matches and name/details 3 days before <br /> the show. (Many investors only buy tickets shortly before the show)</p>
							: <p class='c14 fs0-75rem fw300 tac mb1rem'>We will be in touch with you shortly once we have reviewed your <br /> application.</p>
						}
						{partner?.['name'] == 'Climb25 Super Flow' && <img className='df' src={require('../../../../images/super-flow/apply-box-popup.png')} alt='' />}
						{partner?.['name'] == 'Climb25 Super Flow'
							? <p class='c15 fs1rem fw500 tac mt1rem'>Want to increase investor interest?</p>
							: <p class='c15 fs1rem fw500 tac mt3rem'>Want a speedier decision?</p>
						}
						{partner?.['_id'] &&
							<div className='tac w100 db'>
								<Link to={`/completeInvestment/${partner['_id']}?companyId=${company['_id']}&cName=${company['cName']}`} className='cp w300px py0-5rem c1 bg4 bg3-hover br35px my1rem fw400 fs1rem zi0 td250'>Next</Link>
							</div>
						}
					</div>
				</div>
			</Modal>

			{/* Super Flow Investor Match Popup */}
			<Modal id="superFlowPopup" open={modal['open'] == 'superFlowPopup'} onClose={() => dispatch(toggleModal({ open: '' }))} className="backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic" >
				<div className='df jcc oscy' style={{ maxHeight: '100vh' }}>
					<div className='mah90 oya bg1 shadow w1100px p3rem bsbb df fdc aic m1rem br20px pr'>
						<button className="close-popup" onClick={() => dispatch(toggleModal({ open: '' }))}>
							<svg style={{ position: 'relative', top: '4px' }} className="pen fds h1rem f1 mr0-5rem" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
								<path className="pen fa-primary" d="M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z" />
							</svg>
						</button>
						<div class='w100 df'>
							<img className="mr3rem" src={require(`../../../../images/super-flow/complete-icon-popup.png`)} alt="" />
							<div class='df fdc jcc'>
								<p class='w100 c15 fs1-25rem fw500 my1rem'>Thank you for completing your Investor<span class='c4'>Match</span> assessment</p>
								<p class='w100 c15 fs1-25rem fw500 tac'>You are well on the way to accessing your goodies!</p>
							</div>
						</div>
						<div class='w50 df jcsb my2rem'>
							<img className="" src={require(`../../../../images/super-flow/kpmg-popup-ai.png`)} alt="" />
							{/* <img className="" src={require(`../../../../images/super-flow/investor-matches-kpmg-popup.png`)} alt="" /> */}
							<div className='w30 df fdc fs10px fw300 tas p1rem bw1px bo16 bss br15px'>
								<p class='w100 c15 fs0-75rem fw600 mb1rem'>Investor Matches</p>
								<p class='w100 c12 lh2 mb0-5rem'>If you are not quite right for us, we will match you with other investors.</p>
								<p className={`w100 fs1rem lh1 fw600 ${fitInvestorFirms.length > 0 ? 'c34' : 'c16'}`}>{fitInvestorFirms.length}<br /><span className={`fs10px fw500 ${fitInvestorFirms.length > 0 ? 'c15' : 'c12'}`}>Matches</span></p>
							</div>
						</div>
						<div class='w100 df jcc my1rem'>
							<p class='c15 fs1-25rem fw500'>Now let’s complete your Investment Readiness checklist</p>
						</div>
						{partner?.['_id'] &&
							<div class='w80 df jce my1rem'>
								<button onClick={() => nextInvestmentReadiness()} className='df jcc cp w30 py0-5rem c1 bg4 bg3-hover br35px fw400 fs1rem'>Next</button>
							</div>
						}
					</div>
				</div>
			</Modal>

			{/* User List */}
			<Modal open={modal['open'] == 'userList'} onClose={() => dispatch(toggleModal({ open: '' }))} className="backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic">
				<div className="mah90 bg1 shadow w100  bsbb df fdc m1rem maw900px br10px">
					<div className='top-header py1rem px2rem df jcsb aic' style={{ backgroundColor: '#CBD3F980', borderRadius: '8px 8px 0 0' }}>
						<h4 className='fs1-5rem c15 fw500 ttc'>Members</h4>
						<img className="w60px" src={require(`../../../../images/logo-icon.svg`)} alt="TODO" />
					</div>
					<div className="df fdc gg1rem px3rem py2rem mah500px oya advisor-box-content">
						{company['creatorId'] &&
							<div className="pr df aic fs1rem-sm">
								{company['creatorId']?.['profile']
									? <img src={company['creatorId']?.['profile']} className={`pen pa t0 l0 w3rem h3rem df jcc aic br100 ${profileClass}`} data-tooltip={company['creatorId'].firstName ? (company['creatorId'].firstName + " " + (company['creatorId']?.lastName ? company['creatorId']?.lastName : "")) : "Register to show your name here"} />
									: <span class={`pen pa t0 l0 w3rem h3rem df jcc aic br100 ${profileClass}`}>{company?.['creatorId']?.['firstName']?.[0]?.toUpperCase() + (company?.['creatorId']?.['lastName'] ? company?.['creatorId']?.['lastName']?.[0]?.toUpperCase() : "")}</span>
								}
								<span style={{ marginLeft: "1.5rem" }} className="pl2rem br5px shadow h4rem w100 bg5 df aic dg gtcr7-md gg1rem">
									<span className="fs1rem">{company['creatorId']['firstName']}</span>
									<span className="fs0-75rem"> Owner </span>
									<span className="fs0-75rem"> {company['creatorId']['email']} </span>
									<span className='fs1rem tac'></span>
									<span className='fs0-75rem c7'>Active</span>
									<span className='fs0-75rem tac'> {company['creatorId']?.['lastLogin'] && <>Last Login:<br />
										<p className={((new Date().getTime() - new Date(company['creatorId']['lastLogin']).getTime()) / (1000 * 3600 * 24 * 30)) > 3 ? 'c9' : 'c7'}>{moment(company['creatorId']['lastLogin']).format('ll')}</p>
									</>}</span>
									<span className='fs1rem tac'></span>
								</span>
							</div>
						}
						{company['members'] && company['members'].map(user => (
							<div key={`team-member-${user['_id']}`} className="pr df aic fs1rem-sm">
								{user?.['profile']
									? <img src={user?.['profile']} className={`pen pa t0 l0 w3rem h3rem df jcc aic br100 ${profileClass}`} data-tooltip={user.firstName ? (user.firstName + " " + (user?.lastName ? user?.lastName : "")) : "Register to show your name here"} />
									: <span class={`pen pa t0 l0 w3rem h3rem df jcc aic br100 ${profileClass}`}>{(user?.['firstName'] ? user?.['firstName']?.[0]?.toUpperCase() : '') + (user?.['lastName'] ? user?.['lastName']?.[0]?.toUpperCase() : '')}</span>
								}
								<span style={{ marginLeft: "1.5rem" }} className="pl2rem br5px shadow h4rem w100 bg5 df aic dg gtcr7-md gg1rem">
									<span className="fs1rem">{user['firstName']}</span>
									<span className="fs0-75rem"> {user['designation']?.toUpperCase()} </span>
									<span className="fs0-75rem"> {user['email']} </span>
									<span className='fs1rem tac' onClick={() => handleMemberEdit(user)} ><button className="cp"> <i className="fa fa-edit" /> Edit </button></span>
									<span className={`fs0-75rem ${user['emailVerified'] ? ' c7' : ' c8'}`}>{user['emailVerified'] ? 'Active' : <p>Invite Sent <br />{moment(user['updatedAt']).format('ll')}</p>}</span>
									<span className='fs0-75rem tac'> {!user['emailVerified']
										? <><button className="cp" onClick={() => resendInviteMember(user['_id'])}> <i className="fa fa-history c8" /> Resend </button></>
										: <>Last Login:<br />
											<p className={((new Date().getTime() - new Date(user['lastLogin']).getTime()) / (1000 * 3600 * 24 * 30)) > 3 ? 'c9' : 'c7'}>{moment(user['lastLogin']).format('ll')}</p>
										</>}
									</span>
									<span className='fs1rem tac'> <button className="cp" onClick={() => handleDeleteMember(user['_id'])}> <i className="fa fa-trash c9" /> Delete </button> </span>
								</span>
							</div>
						))}
						<span onClick={() => { dispatch(toggleModal({ open: 'editUser' })); setEditUser({}); setUserAction('Search'); }} className="new-shadow bg3 bg4-hover c1 td250 br25px p1rem fw600 cp ttu bsbb tac df jcc aic px3rem mt1rem">New Member</span>
					</div>
					<svg className="pa cp" onClick={() => { dispatch(toggleModal({ open: '' })); setSelectAll(false); }} style={{ left: '50%', transform: 'translateX(-50%)', bottom: '40px' }} width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
						<rect opacity="0.8" x="4" y="4" width="52" height="52" rx="26" fill="#151313" />
						<path d="M48.5626 11.4375C44.8913 7.76665 40.214 5.26685 35.1221 4.2542C30.0302 3.24156 24.7523 3.76155 19.9559 5.74843C15.1595 7.73531 11.06 11.0998 8.17569 15.4166C5.29142 19.7333 3.75195 24.8084 3.75195 30C3.75195 35.1917 5.29142 40.2667 8.17569 44.5835C11.06 48.9002 15.1595 52.2647 19.9559 54.2516C24.7523 56.2385 30.0302 56.7585 35.1221 55.7458C40.214 54.7332 44.8913 52.2334 48.5626 48.5625C51.0004 46.1249 52.9342 43.231 54.2535 40.0461C55.5729 36.8611 56.252 33.4474 56.252 30C56.252 26.5526 55.5729 23.1389 54.2535 19.954C52.9342 16.769 51.0004 13.8751 48.5626 11.4375ZM39.3751 36.6375C39.5624 36.8129 39.7117 37.0249 39.8138 37.2603C39.9159 37.4958 39.9686 37.7496 39.9686 38.0063C39.9686 38.2629 39.9159 38.5168 39.8138 38.7522C39.7117 38.9876 39.5624 39.1996 39.3751 39.375C39.1999 39.5488 38.9921 39.6863 38.7636 39.7796C38.5352 39.8729 38.2906 39.9202 38.0438 39.9188C37.5519 39.9167 37.0805 39.7214 36.7313 39.375L30.0001 32.6438L23.3626 39.375C23.0133 39.7214 22.5419 39.9167 22.0501 39.9188C21.8033 39.9202 21.5587 39.8729 21.3302 39.7796C21.1018 39.6863 20.894 39.5488 20.7188 39.375C20.3696 39.0237 20.1736 38.5485 20.1736 38.0531C20.1736 37.5578 20.3696 37.0826 20.7188 36.7313L27.3563 30L20.7188 23.3625C20.4116 23.0038 20.2511 22.5424 20.2694 22.0705C20.2876 21.5986 20.4832 21.151 20.8171 20.8171C21.1511 20.4832 21.5987 20.2875 22.0706 20.2693C22.5425 20.2511 23.0039 20.4116 23.3626 20.7188L30.0001 27.3563L36.6376 20.7188C36.8111 20.539 37.0184 20.3952 37.2476 20.2956C37.4768 20.196 37.7233 20.1424 37.9732 20.1381C38.223 20.1337 38.4713 20.1786 38.7038 20.2702C38.9363 20.3618 39.1484 20.4983 39.3282 20.6719C39.5079 20.8455 39.6517 21.0528 39.7514 21.2819C39.851 21.5111 39.9045 21.7576 39.9089 22.0075C39.9132 22.2573 39.8683 22.5056 39.7767 22.7381C39.6851 22.9706 39.5486 23.1828 39.3751 23.3625L32.6438 30L39.3751 36.6375Z" fill="white" />
					</svg>
				</div>
			</Modal>

			{/* Generating AI Report */}
			<ModalWrapper modalType={'generatingAIReport'} onCloseHandler={() => dispatch(toggleModal({ open: '' }))}>
				<div className='tac'>
					<img className="h9rem" src={require(`../../../../images/wizard.gif`)} alt="" />
					<h3 className='mb1-5rem c15'>Generating AI Report</h3>
					<p className='mb1-5rem c15 fs12px px1rem op70'>Whilst we prepare your bespoked 2-minute test report, why don’t your bonus <b className="fsi">BONUS KPI Report</b> which suggests 10 useful business metrics for your business, how to calculate them, and your industry comparables.  You can then click on the “2 Minute Test Report” button to view it.</p>
				</div>
				{tab != 'kpi-report' &&
					<div className='df jcc'>
						<Button
							prefixIcon={<svg width="21" height="22" viewBox="0 0 21 22" fill="none" xmlns="http://www.w3.org/2000/svg">
								<g clip-path="url(#clip0_5984_61323)">
									<path d="M16.2524 14.5155L6.983 5.24614C6.78588 5.04898 6.50209 4.96547 6.22959 5.02441C5.95708 5.08335 5.73313 5.27662 5.63506 5.5376L0.0524681 20.391C-0.060735 20.6922 0.0126009 21.0318 0.240033 21.2594C0.468654 21.4882 0.80855 21.5601 1.10829 21.4477L15.9717 15.8751C16.5385 15.6633 16.6837 14.9286 16.2524 14.5155ZM9.343 16.6082L3.99936 14.5529L5.00453 11.8785L13.3732 15.0972L9.343 16.6082ZM6.723 7.30632L12.3704 12.9537L5.58183 10.3427L6.723 7.30632ZM3.42215 16.0887L7.02869 17.4759L2.22371 19.2774L3.42215 16.0887Z" fill="white" />
									<path d="M12.2407 4.70189C13.2024 3.7402 13.2026 2.18349 12.2407 1.22159C11.2811 0.262073 9.71997 0.262073 8.76041 1.22159C7.79868 2.18333 7.79855 3.74003 8.76041 4.70189C9.71985 5.66133 11.2811 5.66145 12.2407 4.70189ZM9.9205 2.38168C10.2403 2.06188 10.7607 2.06184 11.0806 2.38168C11.4012 2.70226 11.4012 3.22115 11.0806 3.54176C10.7607 3.8616 10.2403 3.8616 9.9205 3.54176C9.59992 3.22119 9.59992 2.7023 9.9205 2.38168Z" fill="white" />
									<path d="M19.6484 10.6074H18.8281V9.78711C18.8281 9.33405 18.4609 8.9668 18.0078 8.9668C17.5548 8.9668 17.1875 9.33405 17.1875 9.78711V10.6074H16.3672C15.9141 10.6074 15.5469 10.9747 15.5469 11.4277C15.5469 11.8808 15.9141 12.248 16.3672 12.248H17.1875V13.0684C17.1875 13.5214 17.5548 13.8887 18.0078 13.8887C18.4609 13.8887 18.8281 13.5214 18.8281 13.0684V12.248H19.6484C20.1015 12.248 20.4688 11.8808 20.4688 11.4277C20.4688 10.9747 20.1015 10.6074 19.6484 10.6074Z" fill="white" />
									<path d="M16.1231 8.43608C16.4435 8.11571 16.4435 7.59633 16.1231 7.276C15.8026 6.9555 15.8024 6.43653 16.1231 6.11591C16.4437 5.79538 16.9625 5.79529 17.2832 6.11591C17.6038 6.43649 18.1232 6.43604 18.4433 6.11591C18.7637 5.79554 18.7636 5.27616 18.4433 4.95583C18.1228 4.63533 18.1226 4.11636 18.4433 3.79574C18.7638 3.47516 19.2828 3.47512 19.6033 3.79574C19.9237 4.11611 20.4431 4.11611 20.7635 3.79574C21.0838 3.47537 21.0838 2.95599 20.7635 2.63566C19.8039 1.67609 18.2426 1.67618 17.2832 2.63566C16.8507 3.06808 16.5994 3.63316 16.5664 4.23908C15.9604 4.27206 15.3953 4.52344 14.963 4.95587C14.4982 5.4207 14.2422 6.03868 14.2422 6.69604C14.2422 7.3534 14.4982 7.97138 14.963 8.43621C15.2834 8.75642 15.8028 8.75642 16.1231 8.43608Z" fill="white" />
									<path d="M15.4219 2.14062C15.8749 2.14062 16.2422 1.77336 16.2422 1.32031C16.2422 0.867266 15.8749 0.5 15.4219 0.5C14.9688 0.5 14.6016 0.867266 14.6016 1.32031C14.6016 1.77336 14.9688 2.14062 15.4219 2.14062Z" fill="white" />
									<path d="M20.1797 8.53906C20.6327 8.53906 21 8.1718 21 7.71875C21 7.2657 20.6327 6.89844 20.1797 6.89844C19.7266 6.89844 19.3594 7.2657 19.3594 7.71875C19.3594 8.1718 19.7266 8.53906 20.1797 8.53906Z" fill="white" />
									<path d="M12.1406 8.53906C12.5937 8.53906 12.9609 8.1718 12.9609 7.71875C12.9609 7.2657 12.5937 6.89844 12.1406 6.89844C11.6876 6.89844 11.3203 7.2657 11.3203 7.71875C11.3203 8.1718 11.6876 8.53906 12.1406 8.53906Z" fill="white" />
								</g>
								<defs>
									<clipPath id="clip0_5984_61323">
										<rect width="21" height="21" fill="white" transform="translate(0 0.5)" />
									</clipPath>
								</defs>
							</svg>
							}
							btnType="warning"
							text="Free KPI Report"
							textClassName={"ttu"}
							customClassName="df"
							onClick={() => openKPI()}
						/>
					</div>
				}
			</ModalWrapper>

			{/* Complete AI Report */}
			<Modal open={modal['open'] == 'completeAIReport'} onClose={() => dispatch(toggleModal({ open: '' }))} className="backdrop td500 zi4 pf t0 l0 w100vw h110vh df jcc aic">
				<div className="mah90 bg1 shadow w100 px6rem py3rem bsbb df fdc aic m1rem maw800px pr pt5rem br20px pr" style={{ backgroundImage: `url(${require('../../../../images/aiWatermark.png')})`, backgroundRepeat: 'no-repeat', backgroundPosition: 'center', lineHeight: '1.8' }}>
					<button className="close-popup" onClick={() => dispatch(toggleModal({ open: '' }))}>
						<svg style={{ position: 'relative', top: '4px' }} className="pen fds h1rem f1 mr0-5rem" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
							<path className="pen fa-primary" d="M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z" />
						</svg>
					</button>
					<img className="h2rem pa t0 l0 m1rem" src={require(`../../../../images/logo.svg`)} alt="TODO" />
					<h2 className='mb1-5rem c15'>AI Report Now Complete!​</h2>
					<div className="tac c12">
						<p className='mb1-5rem c15 fs12px px1rem op70'>"🌟 Huzzah, Valiant Voyager! 🌟 The stars have aligned and the spells have been cast. Your AI-enhanced report has been meticulously crafted and is now ready for your discerning eyes. Unveil the magic and insights within... simply click below to embark on this revelation! 📜✨"​</p>
						<img className="h8rem" src={require(`../../../../images/firework.gif`)} alt="" />
					</div>
					{moduleAI !== '' &&
						<button onClick={() => { setTab(moduleAI + "-report", true); dispatch(toggleModal({ open: '' })) }} className={`w40 df jcc aic fw500 px1rem py0-5rem c1 bg4 br19px cp`}>
							<svg className="pen fds h1rem f1 mr0-5rem" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path className="fa-primary" d="M339.8 211.8l-128 128C206.3 345.3 199.2 348 192 348s-14.34-2.719-19.81-8.188l-64-64c-10.91-10.94-10.91-28.69 0-39.63c10.94-10.94 28.69-10.94 39.63 0L192 280.4l108.2-108.2c10.94-10.94 28.69-10.94 39.63 0C350.7 183.1 350.7 200.9 339.8 211.8z" /><path className="fa-secondary" d="M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96C448 60.65 419.3 32 384 32zM339.8 211.8l-128 128C206.3 345.3 199.2 348 192 348s-14.34-2.719-19.81-8.188l-64-64c-10.91-10.94-10.91-28.69 0-39.63c10.94-10.94 28.69-10.94 39.63 0L192 280.4l108.2-108.2c10.94-10.94 28.69-10.94 39.63 0C350.7 183.1 350.7 200.9 339.8 211.8z" /></svg>
							View AI Report
						</button>
					}
				</div>
			</Modal>

			{/* First Setup Data Repository */}
			<FirstSetupDataRepositoryModal modalType={"firstSetupDataRepository"} dispatch={dispatch} companyId={companyId} company={company} />

			{/* Data Repository Setup Steps */}
			<Modal open={modal['open'] == 'DataRepositorySetupSteps'} onClose={() => dispatch(toggleModal({ open: '' }))} className="backdrop td500 zi4 pf t0 l0 w100vw h110vh df jcc aic">
				<div className="pr oya bg1 shadow w100 p3rem pt5rem bsbb df fdc m1rem maw1000px br5px pr">
					<span className="pa t0 l0 m1rem ttu c7 fs1-5rem fw500">{company.subscription}</span>
					<img className="h2rem pa t0 center-horizontally" src={require(`../../../../images/logo.svg`)} alt="TODO" style={{ top: '15px' }} />
					<button className="close-popup" onClick={() => dispatch(toggleModal({ open: '' }))}>
						<svg style={{ position: 'relative', top: '4px' }} className="pen fds h1rem f1 mr0-5rem" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
							<path className="pen fa-primary" d="M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z" />
						</svg>
					</button>
					<div className='df jcc'><h1 className="text-gradient fw600 tac mb1rem fs1-5em">{company.cName}</h1></div>
					<div className='df jcc'><h2 className="c4 fs1-25rem-sm ttu w100 tac mb2rem">Diligentsia Filing Assistant</h2></div>
					<div className='df jcc fdc aic'>
						<h2 className="repository-step">Step1. Select your data room folders/files to be ingested</h2>
						<svg xmlns="http://www.w3.org/2000/svg" className="pen h2rem" viewBox="0 0 24 24">
							<path d="M19.924 13.617A1 1 0 0 0 19 13h-3V3a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v10H5a1 1 0 0 0-.707 1.707l7 7a1 1 0 0 0 1.414 0l7-7a1 1 0 0 0 .217-1.09z" style={{ fill: '#4A67FF' }} />
						</svg>
						<h2 className="repository-step">Step2. With the use of AI we do our magic in the background and allocate your files to our Repository sections</h2>
						<svg xmlns="http://www.w3.org/2000/svg" className="pen h2rem" viewBox="0 0 24 24">
							<path d="M19.924 13.617A1 1 0 0 0 19 13h-3V3a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v10H5a1 1 0 0 0-.707 1.707l7 7a1 1 0 0 0 1.414 0l7-7a1 1 0 0 0 .217-1.09z" style={{ fill: '#4A67FF' }} />
						</svg>
						<h2 className="repository-step">Step3. You review the allocation of your files to our sections and reallocate if desired</h2>
						<svg xmlns="http://www.w3.org/2000/svg" className="pen h2rem" viewBox="0 0 24 24">
							<path d="M19.924 13.617A1 1 0 0 0 19 13h-3V3a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v10H5a1 1 0 0 0-.707 1.707l7 7a1 1 0 0 0 1.414 0l7-7a1 1 0 0 0 .217-1.09z" style={{ fill: '#4A67FF' }} />
						</svg>
						<h2 className="repository-step">Step4. You can (optionally) remove duplicated files using our deduper</h2>
					</div>
					<div className="df jcc fdr jcc aic mt2rem">
						<button onClick={() => dispatch(toggleModal({ open: '' }))} className="shadow bg3 bg4-hover c1 td250 br5px p1rem fw600 cp miw20 w40 ttu bsbb tac mb1rem df jcc aic mr1rem">Let's go to Filing Assistant</button>
					</div>
				</div>
			</Modal>

			{/* Connecting DataRoom */}
			<Modal open={modal['open'] == 'connectingDataRoom'} onClose={() => dispatch(toggleModal({ open: '' }))} className="backdrop td500 zi4 pf t0 l0 w100vw h110vh df jcc aic">
				<div className="mah90 bg1 shadow w100 p3rem bsbb df fdc m1rem maw800px pr pt5rem br5px pr">
					<button className="close-popup" onClick={() => dispatch(toggleModal({ open: '' }))}>
						<svg style={{ position: 'relative', top: '4px' }} className="pen fds h1rem f1 mr0-5rem" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
							<path className="pen fa-primary" d="M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z" />
						</svg>
					</button>
					<img className="h2rem pa t0 l0 m1rem" src={require(`../../../../images/logo.svg`)} alt="TODO" />
					<h1 className="text-gradient fw600 pb1rem">{props.storageName || 'Data Room'} to be Connected!</h1>
					<div className="tac my1rem">
						<p className="mb0-5rem">Setting up a replica (backup) Diligentsia folder structure in your chosen cloud Data Room will take a few moments.  Once created, you will be able to sync between the two platforms, effectively creating a backup on your cloud.</p>
						{props.storageId != 'GDrive' && <p className="mb0-5rem fs0-75rem">If you already have a data room, You can also choose to copy files from other folders in your cloud folders to the Diligentsia Data Room folder in your cloud. You can  then import/sync them. Your files imported in this manner coloured differently depending upon their source.  You will then need to go into each section and mark that section as “complete”.​</p>}
						<p className="mb0-5rem">We keep an audit log of all changes and have comprehensive reporting.</p>
						{props.storageId == 'GDrive' && <img className="h10rem" src={require(`../../../../images/GDrive.gif`)} alt="" />}
						{props.storageId == 'dropbox' && <img className="h10rem" src={require(`../../../../images/dropbox.gif`)} alt="" />}
						{props.storageId == 'sharepoint' && <img className="h10rem" src={require(`../../../../images/sharepoint.gif`)} alt="" />}
					</div>
					<div className="df jcc"><span className="px1rem py0-5rem mr1rem fw600" >Patience!​</span></div>
				</div>
			</Modal>

			{/* Created DataRoom */}
			<Modal open={modal['open'] == 'createdDataRoom'} onClose={() => dispatch(toggleModal({ open: '' }))} className="backdrop td500 zi4 pf t0 l0 w100vw h110vh df jcc aic">
				<div className="mah90 bg1 shadow w100 p3rem bsbb df fdc m1rem maw600px pr pt5rem br5px pr">
					<button className="close-popup" onClick={() => dispatch(toggleModal({ open: '' }))}>
						<svg style={{ position: 'relative', top: '4px' }} className="pen fds h1rem f1 mr0-5rem" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
							<path className="pen fa-primary" d="M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z" />
						</svg>
					</button>
					<img className="h2rem pa t0 l0 m1rem" src={require(`../../../../images/logo.svg`)} alt="TODO" />
					<div className="tac my1rem">
						<p className="mb0-5rem">Good news!  Your Cloud Data<br />Room has now been created.<br />You can now sync.​</p>
					</div>
					<div className="df jcc">
						<button className="w60 shadow bg4 bg3-hover c1 td250 br5px px1rem py0-5rem mr1rem fw600 cp ttu bsbb df jcc" onClick={() => { moveToCompanyPage(); }}>Let’s go!​</button>
					</div>
				</div>
			</Modal>

			{/* Delete Member */}
			<Modal open={modal['open'] == 'deleteMember'} onClose={() => dispatch(toggleModal({ open: '' }))} className="backdrop td500 zi4 pf t0 l0 w100vw h110vh df jcc aic">
				<div className="mah70 bg1 shadow w100  bsbb df fdc m1rem maw600px br10px">
					<div className='top-header py1rem px2rem df jcsb aic' style={{ backgroundColor: '#CBD3F980', borderRadius: '8px 8px 0 0' }}>
						<h4 className='fs1-5rem c15 fw500 ttc'>Delete Member</h4>
						<img className="w60px" src={require(`../../../../images/logo-icon.svg`)} alt="TODO" />
					</div>
					<div className="df fdc gg1rem px3rem py2rem mah500px oya advisor-box-content">
						<div className="tac my1rem">
							<p className="c15">Are you certain you want to delete Member?</p>
						</div>
						<div className="df jcse">
							<button onClick={() => dispatch(toggleModal({ open: '' }))} className="new-shadow bg4 bg3-hover c1 td250 br25px p1rem fw600 cp ttu bsbb tac df jcc aic px3rem mt1rem">Cancel</button>
							<button onClick={() => submitDeleteMember()} className="new-shadow bg3 bg4-hover c1 td250 br25px p1rem fw600 cp ttu bsbb tac df jcc aic px3rem mt1rem">Submit</button>
						</div>
					</div>
					<svg className="pa cp" onClick={() => dispatch(toggleModal({ open: '' }))} style={{ left: '50%', transform: 'translateX(-50%)', bottom: '40px' }} width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
						<rect opacity="0.8" x="4" y="4" width="52" height="52" rx="26" fill="#151313" />
						<path d="M48.5626 11.4375C44.8913 7.76665 40.214 5.26685 35.1221 4.2542C30.0302 3.24156 24.7523 3.76155 19.9559 5.74843C15.1595 7.73531 11.06 11.0998 8.17569 15.4166C5.29142 19.7333 3.75195 24.8084 3.75195 30C3.75195 35.1917 5.29142 40.2667 8.17569 44.5835C11.06 48.9002 15.1595 52.2647 19.9559 54.2516C24.7523 56.2385 30.0302 56.7585 35.1221 55.7458C40.214 54.7332 44.8913 52.2334 48.5626 48.5625C51.0004 46.1249 52.9342 43.231 54.2535 40.0461C55.5729 36.8611 56.252 33.4474 56.252 30C56.252 26.5526 55.5729 23.1389 54.2535 19.954C52.9342 16.769 51.0004 13.8751 48.5626 11.4375ZM39.3751 36.6375C39.5624 36.8129 39.7117 37.0249 39.8138 37.2603C39.9159 37.4958 39.9686 37.7496 39.9686 38.0063C39.9686 38.2629 39.9159 38.5168 39.8138 38.7522C39.7117 38.9876 39.5624 39.1996 39.3751 39.375C39.1999 39.5488 38.9921 39.6863 38.7636 39.7796C38.5352 39.8729 38.2906 39.9202 38.0438 39.9188C37.5519 39.9167 37.0805 39.7214 36.7313 39.375L30.0001 32.6438L23.3626 39.375C23.0133 39.7214 22.5419 39.9167 22.0501 39.9188C21.8033 39.9202 21.5587 39.8729 21.3302 39.7796C21.1018 39.6863 20.894 39.5488 20.7188 39.375C20.3696 39.0237 20.1736 38.5485 20.1736 38.0531C20.1736 37.5578 20.3696 37.0826 20.7188 36.7313L27.3563 30L20.7188 23.3625C20.4116 23.0038 20.2511 22.5424 20.2694 22.0705C20.2876 21.5986 20.4832 21.151 20.8171 20.8171C21.1511 20.4832 21.5987 20.2875 22.0706 20.2693C22.5425 20.2511 23.0039 20.4116 23.3626 20.7188L30.0001 27.3563L36.6376 20.7188C36.8111 20.539 37.0184 20.3952 37.2476 20.2956C37.4768 20.196 37.7233 20.1424 37.9732 20.1381C38.223 20.1337 38.4713 20.1786 38.7038 20.2702C38.9363 20.3618 39.1484 20.4983 39.3282 20.6719C39.5079 20.8455 39.6517 21.0528 39.7514 21.2819C39.851 21.5111 39.9045 21.7576 39.9089 22.0075C39.9132 22.2573 39.8683 22.5056 39.7767 22.7381C39.6851 22.9706 39.5486 23.1828 39.3751 23.3625L32.6438 30L39.3751 36.6375Z" fill="white" />
					</svg>
				</div>
			</Modal>

			{/* Investor Email Sent */}
			<Modal open={modal['open'] == 'investorEmailSent'} onClose={() => dispatch(toggleModal({ open: '' }))} className="backdrop td500 zi4 pf t0 l0 w100vw h110vh df jcc aic">
				<div className="mah90 bg1 shadow w100 px3rem py2rem bsbb df fdc m1rem maw800px pr pt3rem br5px pr">
					<button className="close-popup" onClick={() => dispatch(toggleModal({ open: '' }))}>
						<svg style={{ position: 'relative', top: '4px' }} className="pen fds h1rem f1 mr0-5rem" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
							<path className="pen fa-primary" d="M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z" />
						</svg>
					</button>
					<img className="h2rem pa t0 l0 m1rem" src={require(`../../../../images/logo.svg`)} alt="TODO" />
					<h1 className="text-gradient fw600">Investor Email</h1>
					<div className="tac my1rem oa">
						<p className="fs0-75rem taj px0-5rem">Dear <b>{investorEmail['name']} </b>, <br />
							Prediligenced Investment Lead From <b>{company['cName']} </b>
							We have pleasure in providing you a FREE introduction to <b>{company['cName']} </b>
							which we have prediligenced and which has scored an <b>{investorEmail['fitScorePercentage'] + '%'} </b> Fit Score against
							our understanding of your firm's  investment criteria.
							Diligentsia is a new low-cost automated platform assisted by AI, to help SMEs,
							their professional advisors and investors find investment, grow, and eventually
							exit. It was borne out of our frustration as angel investors in our receiving
							impressive pitch decks and then being unable to cost-effectively diligence their
							contents. With the aid of checklist processes to complete in each area, the
							company self-diligences itself, receives scores and recommendations for
							improvement, and creates a detailed diligence pack in the process, each focused
							on the company's stated objective - investment, growth or exit.
							Click here box to view your bespoked <Link target="_blank" to={`/company/${company['_id']}#fit-report:${investorEmail['_id']}`} className="c3 fw500 tdu">Fit Report </Link> - showing the fit between the applicant company and your firm's investment criteria.  You can change/improve
							these later. <br />
							Click here box to view the company's <Link target="_blank" to={`/company/${company['_id']}#fit-report:${investorEmail['_id']}_Diligence-Reports`} className="c3 fw500 tdu">Diligence Pack </Link>, consisting of reports its
							data repository, 20-section business audit (20 sections including legal, IP,
							material contracts etc), warranty disclosure schedule and directors'
							questionnaires.  The reports each have a completeness and risk score, which
							count towards Diligentsia certification - bronze, silver, gold.  Only companies
							that that reached gold certification have access to a module which matches their
							investment requirements to those of a database of suitable investors. The
							companies pay Diligentsia - the leads to your firm are FREE.
							Just as you receive reports on completeness and risk, we provide our companies
							reports on each investor's completeness of information we hold on them, and a
							prompt responsiveness score! <br />
							You can click here - <Link target="_blank" to={`/company/${company['_id']}#fit-report:${investorEmail['_id']}_About-the-Investor`} className="c3 fw500 tdu"> Your Profile </Link> - to view the profile we hold on you - your bio
							etc.  We recognise that you may not be the contact person within your firm who
							should deal with these initial approaches, and you can nominate a colleague to
							be the point person in your place. However, we wish to offer quality, not
							quantity of diligenced leads in both directions, and for this reason ask that you
							nominate a specific individual rather than a generic “enquiries @” email address.
							Diligentsia's module for investors - also FREE - and which you can activate
							separately, offers many other features such as benchmarking, KPI reporting, and
							automatic generation of detailed due diligence checklists bespoked to a
							particular applicant company and industry, each with automated completeness
							and risk scoring. <br />
							Automation CANNOT replicate what you and your team does in relation to the
							critical processes of team chemistry, understanding of the investment
							opportunity, ambition, route to market, competition etc that you undertake.  But
							Diligentsia CAN do a lot of the boring and time-consuming work in the foothills of
							those conversations, and we believe ultimately improve your firm's efficiency
							and investment performance. <br />
							If you would like to find out more about this, please set up a call with me here. In
							the meantime feel free to investigate the opportunity we have provided in this
							email. <br />
							Kind regards,</p>
					</div>
					<div className="df jcc mb1rem">
						<span className="checkbox w20px h20px pr">
							<input defaultChecked={acceptEmail} onChange={() => setAcceptEmail(!acceptEmail)} className="bg5 shadow bo5 bw2px bss cp td250 w20px h20px br5px" type="checkbox" />
						</span>
						<span className="c4 fw500 w100 fs0-75rem lh3 ml0-5rem usn mr2rem">In send this email I understand that the company's diligence reports will be made available that investor</span>
					</div>
					<div className="df jcse">
						<button onClick={() => { setInvestorEmail({}), dispatch(toggleModal({ open: '' })) }} className="h100 mt0-5rem shadow bg4 c1 td250 br5px px2rem fs0-75rem py0-5rem fw600 cp ttu bsbb tac df jcc aic">Cancel</button>
						<button disabled={!acceptEmail} onClick={() => sendInvestorEmail()} className={`${acceptEmail ? 'bg3 c1 ' : 'bg5 c0 '} h100 mt0-5rem shadow td250 br5px px2rem fs0-75rem py0-5rem fw600 cp ttu bsbb tac df jcc aic`}>Send Email</button>
					</div>
				</div>
			</Modal>

			{/* Two-Minute Test Completed */}
			<ModalWrapper modalType={'twoMinuteTestCompleted'} onCloseHandler={() => dispatch(toggleModal({ open: '' }))}>
				<div className='tac'>
					<svg className="maw100px mah100px mb1rem" width="100" height="101" viewBox="0 0 118 119" fill="none" xmlns="http://www.w3.org/2000/svg">
						<circle cx="59" cy="59.5" r="59" fill="#15D757" fill-opacity="0.2" />
						<g clip-path="url(#clip0_6321_2)">
							<path d="M53 75.4999C52.207 75.4999 51.443 75.1859 50.879 74.6208L42.879 66.6208C41.707 65.4499 41.707 63.5499 42.879 62.3789C44.05 61.2069 45.95 61.2069 47.121 62.3789L52.675 67.9328L68.599 46.6999C69.595 45.3739 71.477 45.1069 72.799 46.0999C74.125 47.0939 74.394 48.9748 73.4 50.2998L55.4 74.2999C54.879 74.9958 54.08 75.4309 53.213 75.4919C53.142 75.4969 53.07 75.4999 53 75.4999Z" fill="#15D757" />
							<path d="M35 60.5H30C29.447 60.5 29 60.053 29 59.5C29 58.947 29.447 58.5 30 58.5H35C35.553 58.5 36 58.947 36 59.5C36 60.053 35.553 60.5 35 60.5Z" fill="#AEE090" />
							<path d="M33.8838 74.9998C33.5378 74.9998 33.2018 74.8208 33.0168 74.4998C32.7408 74.0208 32.9048 73.4098 33.3828 73.1338L37.7128 70.6338C38.1898 70.3588 38.8018 70.5208 39.0788 70.9998C39.3548 71.4788 39.1908 72.0898 38.7128 72.3658L34.3828 74.8658C34.2258 74.9568 34.0538 74.9998 33.8838 74.9998Z" fill="#AEE090" />
							<path d="M44.4997 85.6139C44.3297 85.6139 44.1577 85.5709 44.0007 85.4799C43.5217 85.2039 43.3577 84.5919 43.6347 84.1139L46.1347 79.7839C46.4117 79.3049 47.0227 79.1409 47.5007 79.4179C47.9787 79.6949 48.1437 80.3059 47.8667 80.7839L45.3667 85.1139C45.1807 85.4339 44.8457 85.6139 44.4997 85.6139Z" fill="#AEE090" />
							<path d="M59 89.5C58.447 89.5 58 89.053 58 88.5V83.5C58 82.947 58.447 82.5 59 82.5C59.553 82.5 60 82.947 60 83.5V88.5C60 89.053 59.553 89.5 59 89.5Z" fill="#AEE090" />
							<path d="M73.501 85.6134C73.155 85.6134 72.819 85.4344 72.634 85.1134L70.134 80.7834C69.858 80.3044 70.022 79.6934 70.5 79.4174C70.976 79.1414 71.589 79.3044 71.866 79.7834L74.366 84.1134C74.642 84.5924 74.478 85.2034 74 85.4794C73.843 85.5704 73.671 85.6134 73.501 85.6134Z" fill="#AEE090" />
							<path d="M84.1109 75.0002C83.9409 75.0002 83.7689 74.9572 83.6119 74.8662L79.2819 72.3662C78.8029 72.0902 78.6389 71.4782 78.9159 71.0002C79.1919 70.5212 79.8049 70.3582 80.2819 70.6342L84.6119 73.1342C85.0909 73.4102 85.2549 74.0222 84.9779 74.5002C84.7919 74.8212 84.4569 75.0002 84.1109 75.0002Z" fill="#AEE090" />
							<path d="M88 60.5H83C82.447 60.5 82 60.053 82 59.5C82 58.947 82.447 58.5 83 58.5H88C88.553 58.5 89 58.947 89 59.5C89 60.053 88.553 60.5 88 60.5Z" fill="#AEE090" />
							<path d="M79.7823 48.5007C79.4363 48.5007 79.1003 48.3217 78.9153 48.0007C78.6393 47.5217 78.8033 46.9107 79.2813 46.6347L83.6113 44.1347C84.0883 43.8577 84.7013 44.0217 84.9773 44.5007C85.2533 44.9797 85.0893 45.5907 84.6113 45.8667L80.2813 48.3667C80.1243 48.4577 79.9523 48.5007 79.7823 48.5007Z" fill="#AEE090" />
							<path d="M70.9997 39.7154C70.8297 39.7154 70.6577 39.6724 70.5007 39.5814C70.0217 39.3054 69.8577 38.6934 70.1347 38.2154L72.6347 33.8854C72.9107 33.4064 73.5227 33.2424 74.0007 33.5194C74.4787 33.7964 74.6437 34.4074 74.3667 34.8854L71.8667 39.2154C71.6807 39.5354 71.3457 39.7154 70.9997 39.7154Z" fill="#AEE090" />
							<path d="M59 36.5C58.447 36.5 58 36.053 58 35.5V30.5C58 29.947 58.447 29.5 59 29.5C59.553 29.5 60 29.947 60 30.5V35.5C60 36.053 59.553 36.5 59 36.5Z" fill="#AEE090" />
							<path d="M47.001 39.717C46.655 39.717 46.319 39.538 46.134 39.217L43.634 34.887C43.358 34.408 43.522 33.797 44 33.521C44.477 33.245 45.09 33.408 45.366 33.887L47.866 38.217C48.142 38.696 47.978 39.307 47.5 39.583C47.343 39.674 47.171 39.717 47.001 39.717Z" fill="#AEE090" />
							<path d="M38.2125 48.4992C38.0425 48.4992 37.8705 48.4562 37.7135 48.3652L33.3835 45.8652C32.9045 45.5892 32.7405 44.9772 33.0175 44.4992C33.2935 44.0202 33.9055 43.8552 34.3835 44.1332L38.7135 46.6332C39.1925 46.9092 39.3565 47.5212 39.0795 47.9992C38.8935 48.3202 38.5585 48.4992 38.2125 48.4992Z" fill="#AEE090" />
						</g>
						<defs>
							<clipPath id="clip0_6321_2">
								<rect width="60" height="60" fill="white" transform="translate(29 29.5)" />
							</clipPath>
						</defs>
					</svg>
					<h3 className='mb1-5rem c15'>Two Minute Test Completed</h3>
					<p className='mb1-5rem c15 fs12px px1rem op70'>Whilst we prepare your report, please glance at your <b className="fsi">BONUS KPI Report</b> which has been tailored to your business and suggests 10  useful business metrics, how to calculate them, and what your industry comparables could be.</p>
				</div>
				<div className='df jcc'>
					<Button
						prefixIcon={<svg width="21" height="22" viewBox="0 0 21 22" fill="none" xmlns="http://www.w3.org/2000/svg">
							<g clip-path="url(#clip0_5984_61323)">
								<path d="M16.2524 14.5155L6.983 5.24614C6.78588 5.04898 6.50209 4.96547 6.22959 5.02441C5.95708 5.08335 5.73313 5.27662 5.63506 5.5376L0.0524681 20.391C-0.060735 20.6922 0.0126009 21.0318 0.240033 21.2594C0.468654 21.4882 0.80855 21.5601 1.10829 21.4477L15.9717 15.8751C16.5385 15.6633 16.6837 14.9286 16.2524 14.5155ZM9.343 16.6082L3.99936 14.5529L5.00453 11.8785L13.3732 15.0972L9.343 16.6082ZM6.723 7.30632L12.3704 12.9537L5.58183 10.3427L6.723 7.30632ZM3.42215 16.0887L7.02869 17.4759L2.22371 19.2774L3.42215 16.0887Z" fill="white" />
								<path d="M12.2407 4.70189C13.2024 3.7402 13.2026 2.18349 12.2407 1.22159C11.2811 0.262073 9.71997 0.262073 8.76041 1.22159C7.79868 2.18333 7.79855 3.74003 8.76041 4.70189C9.71985 5.66133 11.2811 5.66145 12.2407 4.70189ZM9.9205 2.38168C10.2403 2.06188 10.7607 2.06184 11.0806 2.38168C11.4012 2.70226 11.4012 3.22115 11.0806 3.54176C10.7607 3.8616 10.2403 3.8616 9.9205 3.54176C9.59992 3.22119 9.59992 2.7023 9.9205 2.38168Z" fill="white" />
								<path d="M19.6484 10.6074H18.8281V9.78711C18.8281 9.33405 18.4609 8.9668 18.0078 8.9668C17.5548 8.9668 17.1875 9.33405 17.1875 9.78711V10.6074H16.3672C15.9141 10.6074 15.5469 10.9747 15.5469 11.4277C15.5469 11.8808 15.9141 12.248 16.3672 12.248H17.1875V13.0684C17.1875 13.5214 17.5548 13.8887 18.0078 13.8887C18.4609 13.8887 18.8281 13.5214 18.8281 13.0684V12.248H19.6484C20.1015 12.248 20.4688 11.8808 20.4688 11.4277C20.4688 10.9747 20.1015 10.6074 19.6484 10.6074Z" fill="white" />
								<path d="M16.1231 8.43608C16.4435 8.11571 16.4435 7.59633 16.1231 7.276C15.8026 6.9555 15.8024 6.43653 16.1231 6.11591C16.4437 5.79538 16.9625 5.79529 17.2832 6.11591C17.6038 6.43649 18.1232 6.43604 18.4433 6.11591C18.7637 5.79554 18.7636 5.27616 18.4433 4.95583C18.1228 4.63533 18.1226 4.11636 18.4433 3.79574C18.7638 3.47516 19.2828 3.47512 19.6033 3.79574C19.9237 4.11611 20.4431 4.11611 20.7635 3.79574C21.0838 3.47537 21.0838 2.95599 20.7635 2.63566C19.8039 1.67609 18.2426 1.67618 17.2832 2.63566C16.8507 3.06808 16.5994 3.63316 16.5664 4.23908C15.9604 4.27206 15.3953 4.52344 14.963 4.95587C14.4982 5.4207 14.2422 6.03868 14.2422 6.69604C14.2422 7.3534 14.4982 7.97138 14.963 8.43621C15.2834 8.75642 15.8028 8.75642 16.1231 8.43608Z" fill="white" />
								<path d="M15.4219 2.14062C15.8749 2.14062 16.2422 1.77336 16.2422 1.32031C16.2422 0.867266 15.8749 0.5 15.4219 0.5C14.9688 0.5 14.6016 0.867266 14.6016 1.32031C14.6016 1.77336 14.9688 2.14062 15.4219 2.14062Z" fill="white" />
								<path d="M20.1797 8.53906C20.6327 8.53906 21 8.1718 21 7.71875C21 7.2657 20.6327 6.89844 20.1797 6.89844C19.7266 6.89844 19.3594 7.2657 19.3594 7.71875C19.3594 8.1718 19.7266 8.53906 20.1797 8.53906Z" fill="white" />
								<path d="M12.1406 8.53906C12.5937 8.53906 12.9609 8.1718 12.9609 7.71875C12.9609 7.2657 12.5937 6.89844 12.1406 6.89844C11.6876 6.89844 11.3203 7.2657 11.3203 7.71875C11.3203 8.1718 11.6876 8.53906 12.1406 8.53906Z" fill="white" />
							</g>
							<defs>
								<clipPath id="clip0_5984_61323">
									<rect width="21" height="21" fill="white" transform="translate(0 0.5)" />
								</clipPath>
							</defs>
						</svg>
						}
						btnType="warning"
						text="Free KPI Report"
						textClassName={"ttu"}
						customClassName="df"
						onClick={() => { openKPI(), dispatch(toggleModal({ open: '' })) }}
					/>
				</div>
			</ModalWrapper>

			{/* Sharepoint Not Support Personal account */}
			<ModalWrapper modalType={'notSupportPersonalAccount'} onCloseHandler={moveToCompanyPage}>
				<div className='tac'>
					<svg width="60" height="60" viewBox="0 0 82 82" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M40.9346 76C60.3018 76 76.002 60.2998 76.002 40.9326C76.002 21.5654 60.3018 5.86523 40.9346 5.86523C21.5674 5.86523 5.86719 21.5654 5.86719 40.9326C5.86719 60.2998 21.5674 76 40.9346 76Z" fill="url(#paint0_linear_5984_47190)" />
						<path d="M75.8262 44.4635L45.6436 14.2808C44.6406 12.9422 42.8694 12.8047 40.8963 12.8047C37.7014 12.8047 35.7969 13.9299 35.7969 16.9691C35.7969 26.2423 36.8879 39.5683 36.8879 48.8416C36.8879 50.0536 36.8291 50.9124 37.672 51.4674L57.8565 71.6519C67.6994 66.2184 74.6533 56.1932 75.8262 44.4635Z" fill="url(#paint1_linear_5984_47190)" />
						<path d="M57.5222 71.8347L45.3323 59.6447C44.2374 58.4271 42.6732 57.9434 40.9715 57.9434C37.5426 57.9434 35.2656 60.3763 35.2656 63.6493C35.2656 65.3942 35.7417 67.0187 36.9961 68.1378L44.6613 75.803C49.2741 75.3157 53.6198 73.9344 57.5222 71.8347Z" fill="url(#paint2_linear_5984_47190)" />
						<path d="M46.8997 63.6494C46.8997 66.8446 44.1724 69.65 40.9772 69.65C37.5482 69.65 34.9766 66.8446 34.9766 63.6494C34.9766 60.3765 37.5482 57.6488 40.9772 57.6488C44.1724 57.6488 46.8997 60.3765 46.8997 63.6494ZM45.4192 48.8431C45.4192 51.259 42.7695 52.272 40.8991 52.272C38.4055 52.272 36.3014 51.259 36.3014 48.8431C36.3014 39.5699 35.2103 26.2438 35.2103 16.9706C35.2103 13.9314 37.704 12.2168 40.8991 12.2168C43.9383 12.2168 46.51 13.9311 46.51 16.9706C46.5102 26.2438 45.4192 39.5696 45.4192 48.8431Z" fill="url(#paint3_linear_5984_47190)" />
						<defs>
							<linearGradient id="paint0_linear_5984_47190" x1="24.6242" y1="24.6222" x2="58.4244" y2="58.4225" gradientUnits="userSpaceOnUse">
								<stop stop-color="#FF637B" />
								<stop offset="1" stop-color="#E63950" />
							</linearGradient>
							<linearGradient id="paint1_linear_5984_47190" x1="62.8505" y1="50.2933" x2="26.647" y2="26.0601" gradientUnits="userSpaceOnUse">
								<stop stop-color="#E63950" stop-opacity="0" />
								<stop offset="0.0467" stop-color="#E4354B" stop-opacity="0.047" />
								<stop offset="0.4669" stop-color="#D31822" stop-opacity="0.467" />
								<stop offset="0.7991" stop-color="#C90709" stop-opacity="0.799" />
								<stop offset="1" stop-color="#C50000" />
							</linearGradient>
							<linearGradient id="paint2_linear_5984_47190" x1="54.4907" y1="74.2011" x2="36.1085" y2="61.5086" gradientUnits="userSpaceOnUse">
								<stop stop-color="#E63950" stop-opacity="0" />
								<stop offset="0.0467" stop-color="#E4354B" stop-opacity="0.047" />
								<stop offset="0.4669" stop-color="#D31822" stop-opacity="0.467" />
								<stop offset="0.7991" stop-color="#C90709" stop-opacity="0.799" />
								<stop offset="1" stop-color="#C50000" />
							</linearGradient>
							<linearGradient id="paint3_linear_5984_47190" x1="34.9769" y1="40.9333" x2="46.8997" y2="40.9333" gradientUnits="userSpaceOnUse">
								<stop stop-color="#EDF5FF" />
								<stop offset="1" stop-color="#D5E8FE" />
							</linearGradient>
						</defs>
					</svg>
					<h3 className='mb1-5rem c15'>Only Microsoft business accounts are supported</h3>
					<p className='mb1-5rem c15 fs12px px1rem op70'>
						Diligentsia only supports data synchronisation with Microsoft 365 Sharepoint business accounts.  These are sometimes called ‘Work or School’ accounts by Microsoft. You may have been trying to connect to a Microsoft personal account.
					</p>
				</div>
				<div className='df jcc'>
					<Button
						prefixIcon={<KeyboardArrowLeft />}
						btnType="warning"
						text="Try with Diffrent Account"
						textClassName={"ttu"}
						customClassName="df"
						onClick={moveToCompanyPage}
					/>
				</div>
			</ModalWrapper>

			{/* Upload Profile */}
			<Modal open={modal["open"] == "uploadProfile"} onClose={() => dispatch(toggleModal({ open: "" }))} className="backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic">
				<div className="mah90 oya bg1 shadow w100 bsbb df fdc m1rem maw600px br10px pr">
					<div className={`top-header py1rem px2rem df jcsb aic ${profileClass}`} style={{ borderRadius: '8px 8px 0 0' }}>
						<h4 className='fs1-5rem c15 fw500 ttc'>Upload Company Logo</h4>
						<img className="w60px" src={require(`../../../../images/logo-icon.svg`)} alt="TODO" />
					</div>
					<div className='df fdc p3rem'>
						{uploadImage == "" ? (
							<label for="profile" className="w100 bsbb bg5 br5px tac p1rem bsd bo6 bw2px cp pr upload-pic-area">
								<span className="pen fs1rem fw500 tac">Upload Logo</span>
								<br />
								<div className="">
									<input type="file" className="" id="profile" onChange={(e) => handleUploadImage(e)} accept="image/jpeg, image/jpg, image/png" />
								</div>
								<label>Max file size 5MB</label>
							</label>
						) : (
							<div className="img-box pr">
								<Cropper
									ref={cropper}
									guides={false}
									src={uploadImage}
									aspectRatio={1 / 1}
									className="cropper-settings"
									style={{ maxHeight: "500px" }}
								/>
							</div>
						)}
						<div className="df jcse">
							<span onClick={() => dispatch(toggleModal({ open: "" }))} className="shadow bg4 bg4-hover c1 td250 br5px px2rem py0-5rem cp ttu mr1rem bsbb tac df jcc aic mt1rem">
								Cancel
							</span>
							<span onClick={() => updateProfile()} className={`shadow bg3 bg4-hover c1 td250 br5px px2rem py0-5rem cp ttu mr1rem bsbb tac df jcc aic mt1rem`}>
								{Object.keys(uploadImage).length == 0
									? "Upload"
									: "Crop & Upload"}
							</span>
						</div>
					</div>
				</div>
			</Modal>

			{/* Show Directors */}
			<Modal open={modal['open'] == 'showDirectors'} onClose={() => dispatch(toggleModal({ open: '' }))} className="backdrop showDirectors td500 zi4 pf t0 l0 w100vw h100vh df jcc aic">
				<div className="pr maw1000px inner-showDirectors pr">
					<button className="close-popup" onClick={() => dispatch(toggleModal({ open: '' }))}>
						<svg style={{ position: 'relative', top: '4px' }} className="pen fds h1rem f1 mr0-5rem" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
							<path className="pen fa-primary" d="M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z" />
						</svg>
					</button>
					<div className='top-header mb1rem'>
						<h1 className="c15 fw600 tac ">LIST OF QUESTIONNAIRES</h1>
						<div className="tar my0-5rem">
							<button onClick={() => dispatch(toggleModal({ open: 'addDirector' }))} className="cp tac c1 bg3 br5px shadow px0-25rem py0-5rem fw500 director-add">Add a Director or Senior Manager​</button>
						</div>
					</div>
					<div className='table-area-showDirectors'>
						<table id="table" className="table-showDirectors">
							<thead className="ps t0">
								<tr>
									<th className="c15">Name</th>
									<th className="c15">Designation</th>
									<th className="c15">Progress</th>
									<th className="c15">Action</th>
								</tr>
							</thead>
							<tbody>
								{directors && directors.length > 0 && <>
									{directors.map((item, idx) => (
										<tr key={`director-${item['_id'] || idx}`}>
											<td className={`${item['headShot'] && 'df aic '} c6 fw500 ttc`}>
												{item['headShot'] && <img src={item['headShot']['location']} className="w2rem h2rem df jcc aic br100 bg3 c1 mr0-5rem" />}
												{item['name']}
											</td>
											<td className='c6 fw500 ttc'>{item['designation']}</td>
											<td className='p1rem c6 fw500 ttc'>{showPopupPercent(company?.['modules']?.[`directors-questionnaire_${item['_id']}`]?.['stats']?.['completionPercent'] || 0, 'Completeness')}. {showPopupPercent(company?.['modules']?.[`directors-questionnaire_${item['_id']}`]?.['stats']?.['riskPercent'] || 0, 'Risk')}</td>
											<td className="df jcfs aic">
												<Link to={`#directors-questionnaire_${item['_id']}`} onClick={() => handleViewDirector(item)} className="cp tac px1rem py0-5rem br5px fw500">
													{/* <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
														<path d="M20.1821 11.1817C19.9651 11.1817 19.757 11.2679 19.6036 11.4214C19.4501 11.5748 19.3639 11.7829 19.3639 11.9999V16.9091C19.3639 17.5601 19.1053 18.1844 18.645 18.6447C18.1847 19.1051 17.5603 19.3637 16.9093 19.3637H7.09098C6.43998 19.3637 5.81565 19.1051 5.35532 18.6447C4.895 18.1844 4.63639 17.5601 4.63639 16.9091V7.09074C4.63639 6.43974 4.895 5.81541 5.35532 5.35508C5.81565 4.89476 6.43998 4.63615 7.09098 4.63615H12.0002C12.2172 4.63615 12.4253 4.54995 12.5787 4.3965C12.7322 4.24306 12.8184 4.03495 12.8184 3.81795C12.8184 3.60095 12.7322 3.39284 12.5787 3.2394C12.4253 3.08596 12.2172 2.99976 12.0002 2.99976H7.09098C6.55375 2.99976 6.02177 3.10557 5.52543 3.31116C5.02909 3.51675 4.5781 3.81809 4.19822 4.19798C3.43101 4.96518 3 6.00574 3 7.09074V16.9091C3 17.4463 3.10582 17.9783 3.31141 18.4746C3.517 18.971 3.81834 19.422 4.19822 19.8018C4.96543 20.5691 6.00599 21.0001 7.09098 21.0001H16.9093C17.4466 21.0001 17.9785 20.8943 18.4749 20.6887C18.9712 20.4831 19.4222 20.1817 19.8021 19.8018C20.182 19.422 20.4833 18.971 20.6889 18.4746C20.8945 17.9783 21.0003 17.4463 21.0003 16.9091V11.9999C21.0003 11.7829 20.9141 11.5748 20.7607 11.4214C20.6072 11.2679 20.3991 11.1817 20.1821 11.1817Z" fill="#FC7785" />
														<path d="M8.6292 10.7399C8.40023 10.9686 8.21874 11.2403 8.09517 11.5394C7.9716 11.8384 7.90839 12.159 7.90919 12.4826V13.6363C7.90919 14.2873 8.16779 14.9116 8.62812 15.3719C9.08844 15.8323 9.71278 16.0909 10.3638 16.0909H11.5174C11.841 16.0917 12.1616 16.0285 12.4607 15.9049C12.7598 15.7813 13.0315 15.5998 13.2602 15.3709L20.2803 8.35074C20.5091 8.1227 20.6907 7.85173 20.8146 7.55337C20.9385 7.25501 21.0023 6.93513 21.0023 6.61207C21.0023 6.28902 20.9385 5.96914 20.8146 5.67078C20.6907 5.37242 20.5091 5.10145 20.2803 4.87341L19.1267 3.71975C18.8986 3.49092 18.6276 3.30935 18.3293 3.18546C18.0309 3.06158 17.711 2.9978 17.388 2.9978C17.0649 2.9978 16.745 3.06158 16.4467 3.18546C16.1483 3.30935 15.8774 3.49092 15.6493 3.71975L8.6292 10.7399ZM17.9648 4.87341L19.1267 6.03525C19.279 6.18855 19.3646 6.39592 19.3646 6.61207C19.3646 6.82823 19.279 7.0356 19.1267 7.1889L18.423 7.90892L16.0911 5.57706L16.7948 4.87341C16.871 4.79548 16.962 4.73356 17.0625 4.69128C17.1629 4.64901 17.2708 4.62723 17.3798 4.62723C17.4888 4.62723 17.5967 4.64901 17.6972 4.69128C17.7976 4.73356 17.8886 4.79548 17.9648 4.87341ZM9.54558 12.4826C9.54496 12.375 9.5656 12.2682 9.60631 12.1685C9.64703 12.0688 9.70702 11.9782 9.78286 11.9017L14.9457 6.73889L17.2612 9.05439L12.0984 14.2172C12.0219 14.293 11.9312 14.353 11.8315 14.3938C11.7319 14.4345 11.6251 14.4551 11.5174 14.4545H10.3638C10.1468 14.4545 9.93867 14.3683 9.78522 14.2148C9.63178 14.0614 9.54558 13.8533 9.54558 13.6363V12.4826Z" fill="#FC7785" />
													</svg> */}
													<i class="fa fa-eye fs1-5rem c4" style={{ fontSize: '22px' }} />
												</Link>
												<div onClick={() => handleDeleteDirector(item)}><Delete sx={{ fontSize: '24px', color: '#FC7785', }} /></div>
											</td>
										</tr>
									))}
								</>}
							</tbody>
						</table>
						{directors && directors.length == 0 &&
							<div className='tac py3rem'>
								<h2 className="text-gradient fw600">No Directors Added</h2>
							</div>
						}
						<div className='logo-modal'>
							<img className="h2rem" src={require(`../../../../images/logo.svg`)} alt="TODO" />
						</div>
					</div>
				</div>
			</Modal>

			{/* Delete Director */}
			<ModalWrapper
				modalType="deleteDirector"
			>
				<h1 className="c15 fs2rem tac lh1 fw600 mb2rem">DELETE DIRECTOR</h1>
				<p className="fs1rem fw500 mb1rem c15 tac w100">Are you sure you want to remove {selectedDirector['name']} as a Director or Senior Manager. This action cannot be reversed.</p>
				<div
					className="df jcc aic gg1rem"
				>
					<Button
						onClick={() => handleDeleteDirector()}
						btnType="warning"
						text="Delete Director"
					/>
					<Button onClick={() => dispatch(toggleModal({ open: '' }))}
						btnType="outline"
						text="Cancel"
					/>
				</div>
			</ModalWrapper>

			{/* Add Directors */}
			<Modal open={modal['open'] == 'addDirector'} onClose={() => dispatch(toggleModal({ open: '' }))} className="backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic">
				<div className="mah90 oya bg1 shadow w100 p3rem bsbb df fdc m1rem maw600px br5px pr">
					<button className="close-popup" onClick={() => dispatch(toggleModal({ open: '' }))}>
						<svg style={{ position: 'relative', top: '4px' }} className="pen fds h1rem f1 mr0-5rem" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
							<path className="pen fa-primary" d="M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z" />
						</svg>
					</button>
					<h1 className="text-gradient fs2rem tac lh1 fw600 mb2rem">ADD DIRECTOR</h1>
					<div className="df fdc gg1rem">
						<div className="pr">
							<input id="directorName" type="text" placeholder="Name of Director" className="pl4rem shadow bg5 w100 br5px p1rem" />
							<svg className="center-vertically f3 pa l0 ml1rem w2rem" viewBox="0 0 640 512">
								<path
									d="M639.77 208.21v32.1c0 8.5-6.7 15.1-15.2 15.8-39.4 3.2-105.4 51-138.4 65.8-34.3 15.4-66.7 30-102.3 30-28.2 0-50.2-8.5-65.5-25.3-22.7-24.9-22.8-55.3-20.6-83.8-56.5 45.1-169 153.6-211.2 195.8A31.63 31.63 0 0 1 64 448c-27 0-36.5-27-29.7-43.9l98.2-245.6c8-19.9-14.3-38.8-32.7-27.1l-58 38.9a15.91 15.91 0 0 1-22.1-4.9l-17.2-27a16.08 16.08 0 0 1 4.9-22.1l54.9-36.9c76.5-48.7 160.1 26.9 129.7 102.8l-41.5 103.7c105.2-101.2 144.4-124.5 169.5-126 54.4-3.1 43.8 68.1 42.7 76.1-4.7 35.7-1.3 51.9 21.3 51.9 21.9 0 47-11.3 76.1-24.4 37.4-16.8 111.3-68 163.1-71.5 9.07-.59 16.8 7.11 16.57 16.21z"
									className="fa-secondary"></path>
							</svg>
						</div>
						<div className="pr">
							<input id="directorDesignation" type="text" placeholder="Designation of Director" className="pl4rem shadow bg5 w100 br5px p1rem" />
							<svg className="center-vertically f3 pa l0 ml1rem w2rem" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
								<path className="fa-primary" d="M512 144v288c0 26.5-21.5 48-48 48h-416C21.5 480 0 458.5 0 432v-288C0 117.5 21.5 96 48 96h416C490.5 96 512 117.5 512 144z" />
								<path className="fa-secondary" d="M176 96H128V48C128 21.5 149.5 0 176 0h160C362.5 0 384 21.5 384 48V96h-48V48h-160V96z" />
							</svg>
						</div>
						<span onClick={() => createDirector()} className="shadow bg3 bg4-hover c1 td250 br5px p1rem fw600 cp ttu w100 bsbb tac mb1rem df jcc aic">
							<svg className="pen ml0-5rem h1rem f1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512">
								<path className="fa-primary"
									d="M616 200h-48v-48C568 138.8 557.3 128 544 128s-24 10.75-24 24v48h-48C458.8 200 448 210.8 448 224s10.75 24 24 24h48v48C520 309.3 530.8 320 544 320s24-10.75 24-24v-48h48C629.3 248 640 237.3 640 224S629.3 200 616 200z" />
								<path className="fa-secondary"
									d="M224 256c70.7 0 128-57.31 128-128S294.7 0 224 0C153.3 0 96 57.31 96 128S153.3 256 224 256zM274.7 304H173.3C77.61 304 0 381.6 0 477.3C0 496.5 15.52 512 34.66 512h378.7C432.5 512 448 496.5 448 477.3C448 381.6 370.4 304 274.7 304z" />
							</svg>
							Add Director
						</span>
						<span onClick={() => dispatch(toggleModal({ open: 'showDirectors' }))} className="c3-hover td250 fs1-25rem cp">Back to List of Questionaire's</span>
					</div>
				</div>
			</Modal>

			<Modal open={modal['open'] == 'editUser'} onClose={() => dispatch(toggleModal({ open: '' }))} className="backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic">
				<div className="bg1 shadow w100  bsbb df fdc m1rem maw600px br10px">
					<div className='top-header py1rem px2rem df jcsb aic' style={{ backgroundColor: '#CBD3F980', borderRadius: '8px 8px 0 0' }}>
						<h4 className='fs1-5rem c15 fw500 ttc'>{userAction} User</h4>
						<img className="w60px" src={require(`../../../../images/logo-icon.svg`)} alt="TODO" />
					</div>
					<div className="df fdc gg1rem px3rem py2rem mah600px oya advisor-box-content">
						{userAction === 'Search'
							? <div className="df fdc gg1rem">
								<div className="pr">
									<input id="searchEmail" name="searchEmail" type="email" placeholder="Search Email" className="pl4rem bg1 w100 br10px p1rem bss bo16 bw1px c15 fs1rem" />
									<svg className="center-vertically f3 pa l0 ml1rem w2rem" viewBox="0 0 512 512">
										<path d="M256.47 352h-.94c-30.1 0-60.41-23.42-82.54-40.52C169.39 308.7 24.77 202.7 0 183.33V400a48 48 0 0 0 48 48h416a48 48 0 0 0 48-48V183.36c-24.46 19.17-169.4 125.34-173 128.12-22.12 17.1-52.43 40.52-82.53 40.52zM464 64H48a48 48 0 0 0-48 48v19a24.08 24.08 0 0 0 9.2 18.9c30.6 23.9 40.7 32.4 173.4 128.7 16.8 12.2 50.2 41.8 73.4 41.4 23.2.4 56.6-29.2 73.4-41.4 132.7-96.3 142.8-104.7 173.4-128.7A23.93 23.93 0 0 0 512 131v-19a48 48 0 0 0-48-48z" className="fa-secondary"></path>
										<path d="M512 131v52.36c-24.46 19.17-169.4 125.34-173 128.12-22.12 17.1-52.43 40.52-82.53 40.52h-.94c-30.1 0-60.41-23.42-82.54-40.52C169.39 308.7 24.77 202.7 0 183.33V131a24.08 24.08 0 0 0 9.2 18.9c30.6 23.9 40.7 32.4 173.4 128.7 16.69 12.12 49.75 41.4 72.93 41.4h.94c23.18 0 56.24-29.28 72.93-41.4 132.7-96.3 142.8-104.7 173.4-128.7A23.93 23.93 0 0 0 512 131z" className="fa-primary"></path>
									</svg>
								</div>
								<span id='NewUserStep' onClick={findUser} className="new-shadow bg3 bg4-hover c1 td250 br25px p1rem fw600 cp ttu bsbb tac df jcc aic px3rem mt1rem">
									Search User
								</span>
							</div>
							: <div className="df fdc gg1rem">
								<div className="pr">
									<input id="userFirstName" name="firstName" type="text" placeholder="First Name" onChange={handleUserChange} value={editUser['firstName'] || ""}
										className="pl4rem bg1 w100 br10px p1rem bss bo16 bw1px c15 fs1rem" />
									<svg className="center-vertically f3 pa l0 ml1rem w2rem" viewBox="0 0 640 512">
										<path d="M639.77 208.21v32.1c0 8.5-6.7 15.1-15.2 15.8-39.4 3.2-105.4 51-138.4 65.8-34.3 15.4-66.7 30-102.3 30-28.2 0-50.2-8.5-65.5-25.3-22.7-24.9-22.8-55.3-20.6-83.8-56.5 45.1-169 153.6-211.2 195.8A31.63 31.63 0 0 1 64 448c-27 0-36.5-27-29.7-43.9l98.2-245.6c8-19.9-14.3-38.8-32.7-27.1l-58 38.9a15.91 15.91 0 0 1-22.1-4.9l-17.2-27a16.08 16.08 0 0 1 4.9-22.1l54.9-36.9c76.5-48.7 160.1 26.9 129.7 102.8l-41.5 103.7c105.2-101.2 144.4-124.5 169.5-126 54.4-3.1 43.8 68.1 42.7 76.1-4.7 35.7-1.3 51.9 21.3 51.9 21.9 0 47-11.3 76.1-24.4 37.4-16.8 111.3-68 163.1-71.5 9.07-.59 16.8 7.11 16.57 16.21z" className="fa-secondary"></path>
									</svg>
								</div>
								<div className="pr">
									<input id="userLastName" name="lastName" type="text" placeholder="Last Name" onChange={handleUserChange} value={editUser['lastName'] || ""}
										className="pl4rem bg1 w100 br10px p1rem bss bo16 bw1px c15 fs1rem" />
									<svg className="center-vertically f3 pa l0 ml1rem w2rem" viewBox="0 0 640 512">
										<path d="M639.77 208.21v32.1c0 8.5-6.7 15.1-15.2 15.8-39.4 3.2-105.4 51-138.4 65.8-34.3 15.4-66.7 30-102.3 30-28.2 0-50.2-8.5-65.5-25.3-22.7-24.9-22.8-55.3-20.6-83.8-56.5 45.1-169 153.6-211.2 195.8A31.63 31.63 0 0 1 64 448c-27 0-36.5-27-29.7-43.9l98.2-245.6c8-19.9-14.3-38.8-32.7-27.1l-58 38.9a15.91 15.91 0 0 1-22.1-4.9l-17.2-27a16.08 16.08 0 0 1 4.9-22.1l54.9-36.9c76.5-48.7 160.1 26.9 129.7 102.8l-41.5 103.7c105.2-101.2 144.4-124.5 169.5-126 54.4-3.1 43.8 68.1 42.7 76.1-4.7 35.7-1.3 51.9 21.3 51.9 21.9 0 47-11.3 76.1-24.4 37.4-16.8 111.3-68 163.1-71.5 9.07-.59 16.8 7.11 16.57 16.21z" className="fa-secondary"></path>
									</svg>
								</div>
								<div className="pr">
									<input id="userEmail" name="email" type="email" placeholder="Email" onChange={handleUserChange} value={editUser['email'] || ""} disabled={userAction == 'Edit' || userAction == 'Add' ? true : false}
										className="pl4rem bg1 w100 br10px p1rem bss bo16 bw1px c15 fs1rem" />
									<svg className="center-vertically f3 pa l0 ml1rem w2rem" viewBox="0 0 512 512">
										<path d="M256.47 352h-.94c-30.1 0-60.41-23.42-82.54-40.52C169.39 308.7 24.77 202.7 0 183.33V400a48 48 0 0 0 48 48h416a48 48 0 0 0 48-48V183.36c-24.46 19.17-169.4 125.34-173 128.12-22.12 17.1-52.43 40.52-82.53 40.52zM464 64H48a48 48 0 0 0-48 48v19a24.08 24.08 0 0 0 9.2 18.9c30.6 23.9 40.7 32.4 173.4 128.7 16.8 12.2 50.2 41.8 73.4 41.4 23.2.4 56.6-29.2 73.4-41.4 132.7-96.3 142.8-104.7 173.4-128.7A23.93 23.93 0 0 0 512 131v-19a48 48 0 0 0-48-48z" className="fa-secondary"></path>
										<path d="M512 131v52.36c-24.46 19.17-169.4 125.34-173 128.12-22.12 17.1-52.43 40.52-82.53 40.52h-.94c-30.1 0-60.41-23.42-82.54-40.52C169.39 308.7 24.77 202.7 0 183.33V131a24.08 24.08 0 0 0 9.2 18.9c30.6 23.9 40.7 32.4 173.4 128.7 16.69 12.12 49.75 41.4 72.93 41.4h.94c23.18 0 56.24-29.28 72.93-41.4 132.7-96.3 142.8-104.7 173.4-128.7A23.93 23.93 0 0 0 512 131z" className="fa-primary"></path>
									</svg>
								</div>
								<div className="pr">
									<input id="designation" name="designation" type="text" placeholder="Job Title" className="pl4rem bg1 w100 br10px p1rem bss bo16 bw1px c15 fs1rem" onChange={handleUserChange} value={editUser['designation'] || ""} />
									<svg className="center-vertically f3 pa l0 ml1rem w2rem" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path className="fa-primary" d="M133.3 308.8C56.91 326.9 0 395.4 0 477.3C0 496.5 15.52 512 34.66 512H184L133.3 308.8zM314.7 308.8L264 512h149.3C432.5 512 448 496.5 448 477.3C448 395.4 391.1 326.9 314.7 308.8z" /><path className="fa-secondary" d="M176 288l32 56l-31.99 135.1L184 512h80l7.988-32.05L240 344l32-56H176zM224 0C153.3 0 96 57.25 96 128s57.25 128 128 128s128-57.25 128-128S294.8 0 224 0z" /></svg>
								</div>
								<h2 className="c15 fs1-25rem ttu w100 tal 0 mb0-5rem">Permissions</h2>
								<div id="userPermissions" className="dg gg0-5rem my1rem">
									<div className="tac df jcfs">
										<span className="checkbox w30px h30px pr mr1rem">
											<input onChange={selectAllPermissions} className="bg1 new-shadow bo5 bw2px bss cp td250 w30px h30px br5px"
												type="checkbox" checked={selectAll} />
										</span>
										<span className="fs1rem c15 fw600 mr1rem usn">All Permissions</span>

									</div>
									{company?.['sections'] && company?.['sections'].map((section, idx) => {
										return (
											<label key={idx} for={"permissions" + section['sectionNo']} className="df cp fs1rem">
												<span className="checkbox w30px h30px pr mr1rem">
													<input
														type="checkbox"
														onChange={changeUser}
														name={section['sectionNo']}
														id={"permissions" + section['sectionNo']}
														className="bg1 new-shadow bo5 bw2px bss cp td250 w30px h30px br5px"
														checked={editUser.permissions && editUser.permissions[section['sectionNo']]}
													/></span>
												<span className="fs1rem fw600 mr1rem usn c15">{section['sectionNo']}</span>
												<span className="fs1rem fw400 usn c15">{section['sectionName']}</span>
											</label>
										)
									})}
								</div>
								<span onClick={() => saveUser()} className="new-shadow bg3 bg4-hover c1 td250 br25px p1rem fw600 cp ttu bsbb tac df jcc aic px3rem mt1rem">Save</span>
								<span onClick={() => dispatch(toggleModal({ open: '' }))} className="c3-hover td250 fs1-25rem cp">Cancel</span>
							</div>
						}
					</div>
					<svg className="pa cp" onClick={() => { dispatch(toggleModal({ open: '' })); setSelectAll(false); }} style={{ left: '50%', transform: 'translateX(-50%)', bottom: '12px' }} width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
						<rect opacity="0.8" x="4" y="4" width="52" height="52" rx="26" fill="#151313" />
						<path d="M48.5626 11.4375C44.8913 7.76665 40.214 5.26685 35.1221 4.2542C30.0302 3.24156 24.7523 3.76155 19.9559 5.74843C15.1595 7.73531 11.06 11.0998 8.17569 15.4166C5.29142 19.7333 3.75195 24.8084 3.75195 30C3.75195 35.1917 5.29142 40.2667 8.17569 44.5835C11.06 48.9002 15.1595 52.2647 19.9559 54.2516C24.7523 56.2385 30.0302 56.7585 35.1221 55.7458C40.214 54.7332 44.8913 52.2334 48.5626 48.5625C51.0004 46.1249 52.9342 43.231 54.2535 40.0461C55.5729 36.8611 56.252 33.4474 56.252 30C56.252 26.5526 55.5729 23.1389 54.2535 19.954C52.9342 16.769 51.0004 13.8751 48.5626 11.4375ZM39.3751 36.6375C39.5624 36.8129 39.7117 37.0249 39.8138 37.2603C39.9159 37.4958 39.9686 37.7496 39.9686 38.0063C39.9686 38.2629 39.9159 38.5168 39.8138 38.7522C39.7117 38.9876 39.5624 39.1996 39.3751 39.375C39.1999 39.5488 38.9921 39.6863 38.7636 39.7796C38.5352 39.8729 38.2906 39.9202 38.0438 39.9188C37.5519 39.9167 37.0805 39.7214 36.7313 39.375L30.0001 32.6438L23.3626 39.375C23.0133 39.7214 22.5419 39.9167 22.0501 39.9188C21.8033 39.9202 21.5587 39.8729 21.3302 39.7796C21.1018 39.6863 20.894 39.5488 20.7188 39.375C20.3696 39.0237 20.1736 38.5485 20.1736 38.0531C20.1736 37.5578 20.3696 37.0826 20.7188 36.7313L27.3563 30L20.7188 23.3625C20.4116 23.0038 20.2511 22.5424 20.2694 22.0705C20.2876 21.5986 20.4832 21.151 20.8171 20.8171C21.1511 20.4832 21.5987 20.2875 22.0706 20.2693C22.5425 20.2511 23.0039 20.4116 23.3626 20.7188L30.0001 27.3563L36.6376 20.7188C36.8111 20.539 37.0184 20.3952 37.2476 20.2956C37.4768 20.196 37.7233 20.1424 37.9732 20.1381C38.223 20.1337 38.4713 20.1786 38.7038 20.2702C38.9363 20.3618 39.1484 20.4983 39.3282 20.6719C39.5079 20.8455 39.6517 21.0528 39.7514 21.2819C39.851 21.5111 39.9045 21.7576 39.9089 22.0075C39.9132 22.2573 39.8683 22.5056 39.7767 22.7381C39.6851 22.9706 39.5486 23.1828 39.3751 23.3625L32.6438 30L39.3751 36.6375Z" fill="white" />
					</svg>
				</div>
			</Modal>

			{/* // Alert */}
			<RepositoryAlert setTabName={setTabName} />

			{/* Demo Checklist Flow */}
			<Modal id="demoChecklistFlow" open={modal['open'] == 'demoChecklistFlow'} onClose={() => dispatch(toggleModal({ open: '' }))} className="backdrop td500 zi4 pf t0 l0 w100vw  df jcc aic advisor-dashboard-seemore">
				<div className="poppins-font-style mah100 bg1 shadow w100 py2rem px4rem df fdc m1rem pr br10px pr" style={{ outline: 'none', paddingBottom: '2rem', maxWidth: '750px' }}>
					<div className='top-logo pa t0 r0 mr1rem mt1rem'><img className='w4rem' src={require('../../../../images/favicon.png')} alt="" /></div>
					<div className='creaing-modal pr mb3rem'>
						<div className='df jcc'><img className="w10rem" src={require('../../../../images/wizard.gif')} alt="" /></div>
						<div className='text-box w90 df jcc tac fdc mla mra'>
							<h3 className='fs1-5rem c15 mb1rem'>
								{isPrePopulate
									? <>Completing demo checklist for you <br /> to save time…</>
									: tab.endsWith("-report")
										? 'Generating your workflow manager'
										: 'Generating your checklist report'
								}
							</h3>
							<div className="my1rem tac">
								<div className="checklist-progress"><div className={`checklist-progress-bar ${isPrePopulate && ` questions-progress-bar`}`}></div></div>
							</div>
							<p className='c15 fs1rem mt1rem'>This may take {isPrePopulate ? ' couple of minutes' : ' few seconds'}.</p>
						</div>
						{!isPrePopulate &&
							<div className='img-box pa' style={{ top: '10px', right: '-345px' }}>
								{tab.endsWith("-report")
									? <img className="w80" src={require(`../../../../images/demo-checklist/demo-checklist-popup-workflow.png`)} alt="" />
									: <img className="w80" src={require(`../../../../images/demo-checklist/demo-checklist-popup-report.png`)} alt="" />
								}
							</div>
						}
					</div>
					<svg className="pa cp" onClick={() => dispatch(toggleModal({ open: '' }))} style={{ left: '50%', transform: 'translateX(-50%)', bottom: '-80px' }} width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
						<rect opacity="0.8" x="4" y="4" width="52" height="52" rx="26" fill="#151313" />
						<path d="M48.5626 11.4375C44.8913 7.76665 40.214 5.26685 35.1221 4.2542C30.0302 3.24156 24.7523 3.76155 19.9559 5.74843C15.1595 7.73531 11.06 11.0998 8.17569 15.4166C5.29142 19.7333 3.75195 24.8084 3.75195 30C3.75195 35.1917 5.29142 40.2667 8.17569 44.5835C11.06 48.9002 15.1595 52.2647 19.9559 54.2516C24.7523 56.2385 30.0302 56.7585 35.1221 55.7458C40.214 54.7332 44.8913 52.2334 48.5626 48.5625C51.0004 46.1249 52.9342 43.231 54.2535 40.0461C55.5729 36.8611 56.252 33.4474 56.252 30C56.252 26.5526 55.5729 23.1389 54.2535 19.954C52.9342 16.769 51.0004 13.8751 48.5626 11.4375ZM39.3751 36.6375C39.5624 36.8129 39.7117 37.0249 39.8138 37.2603C39.9159 37.4958 39.9686 37.7496 39.9686 38.0063C39.9686 38.2629 39.9159 38.5168 39.8138 38.7522C39.7117 38.9876 39.5624 39.1996 39.3751 39.375C39.1999 39.5488 38.9921 39.6863 38.7636 39.7796C38.5352 39.8729 38.2906 39.9202 38.0438 39.9188C37.5519 39.9167 37.0805 39.7214 36.7313 39.375L30.0001 32.6438L23.3626 39.375C23.0133 39.7214 22.5419 39.9167 22.0501 39.9188C21.8033 39.9202 21.5587 39.8729 21.3302 39.7796C21.1018 39.6863 20.894 39.5488 20.7188 39.375C20.3696 39.0237 20.1736 38.5485 20.1736 38.0531C20.1736 37.5578 20.3696 37.0826 20.7188 36.7313L27.3563 30L20.7188 23.3625C20.4116 23.0038 20.2511 22.5424 20.2694 22.0705C20.2876 21.5986 20.4832 21.151 20.8171 20.8171C21.1511 20.4832 21.5987 20.2875 22.0706 20.2693C22.5425 20.2511 23.0039 20.4116 23.3626 20.7188L30.0001 27.3563L36.6376 20.7188C36.8111 20.539 37.0184 20.3952 37.2476 20.2956C37.4768 20.196 37.7233 20.1424 37.9732 20.1381C38.223 20.1337 38.4713 20.1786 38.7038 20.2702C38.9363 20.3618 39.1484 20.4983 39.3282 20.6719C39.5079 20.8455 39.6517 21.0528 39.7514 21.2819C39.851 21.5111 39.9045 21.7576 39.9089 22.0075C39.9132 22.2573 39.8683 22.5056 39.7767 22.7381C39.6851 22.9706 39.5486 23.1828 39.3751 23.3625L32.6438 30L39.3751 36.6375Z" fill="white" />
					</svg>
				</div>
			</Modal>

		</AnimatedPage >
	);
}